import React, { useState, useEffect, useRef, useCallback } from "react";
import { LIVE_STREAM_TOS_TEXT, LIVE_STREAM_TOS_VERSION, LIVE_STREAM_TOS_TYPE } from "./liveStreamTos";

// ─── CONFIG & CONSTANTS ───────────────────────────────────────────────
const SUPABASE_URL = "https://guqytcsovjqmbomyacyd.supabase.co";
const SUPABASE_ANON_KEY = "sb_publishable_RBY52Obs_adPGMsKM3bMjA_ifz6WF2H";
const EMAILJS_SERVICE_ID = "service_rh6uozl";
const EMAILJS_TEMPLATE_ID = "template_b6xnvkj";
const EMAILJS_PUBLIC_KEY = "xElMdZFRvZqh8-bIw";

// *** FIRECRAWL: API key moved server-side to Netlify env var FIRECRAWL_API_KEY ***

// ─── STYLES ───────────────────────────────────────────────────────────
const theme = {
  red: "#E31837",
  redDark: "#B71230",
  redLight: "#FF3050",
  white: "#FFFFFF",
  offWhite: "#F8F5F2",
  grey: "#6B7280",
  greyLight: "#E5E7EB",
  dark: "#1A1A1A",
  shadow: "0 4px 24px rgba(227,24,55,0.10)",
  shadowHover: "0 8px 32px rgba(227,24,55,0.18)",
  radius: "14px",
  radiusSm: "10px",
  font: "'DM Sans', 'Segoe UI', sans-serif",
  fontDisplay: "'Playfair Display', Georgia, serif",
  // *** SIDEBAR: Dark sidebar colors ***
  sidebarBg: "#1a1a2e",
  sidebarBorder: "rgba(255,255,255,0.06)",
  sidebarText: "rgba(255,255,255,0.8)",
  sidebarTextMuted: "rgba(255,255,255,0.35)",
  sidebarTextDim: "rgba(255,255,255,0.25)",
  sidebarCardBg: "rgba(255,255,255,0.05)",
  sidebarCardBorder: "rgba(255,255,255,0.07)",
};

// ─── ICONS (inline SVGs) ─────────────────────────────────────────────
const Icons = {
  send: (
    <svg width="22" height="22" fill="none" viewBox="0 0 24 24"><path d="M3.4 20.4l18.6-8.4L3.4 3.6v6.6l12 1.8-12 1.8v6.6z" fill="currentColor"/></svg>
  ),
  mic: (
    <svg width="20" height="20" fill="none" viewBox="0 0 24 24"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" stroke="currentColor" strokeWidth="2"/><path d="M19 10v2a7 7 0 0 1-14 0v-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M12 19v4m-4 0h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
  ),
  micActive: (
    <svg width="20" height="20" fill="none" viewBox="0 0 24 24"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" fill="#E31837" stroke="#E31837" strokeWidth="2"/><path d="M19 10v2a7 7 0 0 1-14 0v-2" stroke="#E31837" strokeWidth="2" strokeLinecap="round"/><path d="M12 19v4m-4 0h8" stroke="#E31837" strokeWidth="2" strokeLinecap="round"/></svg>
  ),
  plus: (
    <svg width="20" height="20" fill="none" viewBox="0 0 24 24"><path d="M12 5v14m-7-7h14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>
  ),
  home: (
    <svg width="22" height="22" fill="none" viewBox="0 0 24 24"><path d="M3 12l9-9 9 9M5 10v10a1 1 0 001 1h3a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1h3a1 1 0 001-1V10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
  ),
  eye: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12z" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/></svg>
  ),
  eyeOff: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M1 1l22 22" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
  ),
  check: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
  ),
  bot: (
    <svg width="24" height="24" fill="none" viewBox="0 0 24 24"><rect x="4" y="8" width="16" height="12" rx="3" stroke="currentColor" strokeWidth="2"/><circle cx="9" cy="14" r="1.5" fill="currentColor"/><circle cx="15" cy="14" r="1.5" fill="currentColor"/><path d="M12 4v4M8 4h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
  ),
  user: (
    <svg width="20" height="20" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="2"/><path d="M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
  ),
  spinner: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{animation:'spin 1s linear infinite'}}><circle cx="12" cy="12" r="10" stroke="#E31837" strokeWidth="3" strokeDasharray="50 20" strokeLinecap="round"/></svg>
  ),
  logout: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
  ),
  file: (
    <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/><path d="M14 2v6h6" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/></svg>
  ),
  // *** SIDEBAR: Agent SVG icons (red stroke, no emojis) ***
  agentSell: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" stroke="#E31837" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M9 22V12h6v10" stroke="#E31837" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
  ),
  agentOffer: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="#E31837" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" stroke="#E31837" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
  ),
  agentApproved: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path d="M22 11.08V12a10 10 0 11-5.93-9.14" stroke="#E31837" strokeWidth="2" strokeLinecap="round"/><path d="M22 4L12 14.01l-3-3" stroke="#E31837" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
  ),
  agentLive: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2" stroke="#E31837" strokeWidth="2"/><path d="M8 21h8M12 17v4" stroke="#E31837" strokeWidth="2" strokeLinecap="round"/><circle cx="12" cy="10" r="2" fill="#E31837"/></svg>
  ),
  // *** SIDEBAR: Hamburger menu icon for mobile ***
  menu: (
    <svg width="22" height="22" fill="none" viewBox="0 0 24 24"><path d="M3 12h18M3 6h18M3 18h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
  ),
  // *** SIDEBAR: Dropdown chevron ***
  chevronDown: (
    <svg width="12" height="12" fill="none" viewBox="0 0 16 16"><path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
  ),
  // *** SIDEBAR: Account menu icons ***
  editProfile: (
    <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="1.5"/></svg>
  ),
  subscription: (
    <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><rect x="1" y="4" width="22" height="16" rx="2" stroke="currentColor" strokeWidth="1.5"/><path d="M1 10h22" stroke="currentColor" strokeWidth="1.5"/></svg>
  ),
  searchHistory: (
    <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="1.5"/><path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
  ),
  settings: (
    <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.5"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z" stroke="currentColor" strokeWidth="1.5"/></svg>
  ),
  plusSmall: (
    <svg width="10" height="10" fill="none" viewBox="0 0 16 16"><path d="M8 3v10M3 8h10" stroke="#fff" strokeWidth="2" strokeLinecap="round"/></svg>
  ),
  // *** VOICE MODE: Icons ***
  voiceOn: (
    <svg width="20" height="20" fill="none" viewBox="0 0 24 24"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" fill="#E31837" stroke="#E31837" strokeWidth="1.5"/><path d="M19 10v2a7 7 0 0 1-14 0v-2" stroke="#E31837" strokeWidth="2" strokeLinecap="round"/><path d="M12 19v4m-4 0h8" stroke="#E31837" strokeWidth="2" strokeLinecap="round"/><circle cx="19" cy="5" r="4" fill="#4CAF50"/><path d="M17.5 5l1 1 2-2" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
  ),
  voiceOff: (
    <svg width="20" height="20" fill="none" viewBox="0 0 24 24"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" stroke="currentColor" strokeWidth="2"/><path d="M19 10v2a7 7 0 0 1-14 0v-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M12 19v4m-4 0h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M1 1l22 22" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
  ),
  stopSpeaking: (
    <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><rect x="6" y="6" width="12" height="12" rx="2" fill="currentColor"/></svg>
  ),
  agentMarketplace: (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path d="M3 3h18v4H3z" stroke="#E31837" strokeWidth="2" strokeLinejoin="round"/><path d="M5 7v13h14V7" stroke="#E31837" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M9 10h6M9 14h6" stroke="#E31837" strokeWidth="1.5" strokeLinecap="round"/></svg>
  ),
};

// ─── GLOBAL STYLES ────────────────────────────────────────────────────
const globalCSS = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,400&family=Playfair+Display:wght@400;600;700&display=swap');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: ${theme.font}; background: ${theme.offWhite}; }
  @keyframes spin { to { transform: rotate(360deg); } }
  @keyframes fadeUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
  @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: .5; } }
  @keyframes slideIn { from { opacity:0; transform: translateX(-20px); } to { opacity:1; transform: translateX(0); } }
  @keyframes dotBounce { 0%, 80%, 100% { transform: scale(0); } 40% { transform: scale(1); } }
  @keyframes slideUp { from { transform: translateY(100%); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
  ::-webkit-scrollbar { width: 6px; }
  ::-webkit-scrollbar-thumb { background: #ddd; border-radius: 3px; }
  input:-webkit-autofill { -webkit-box-shadow: 0 0 0 40px white inset !important; }
  /* *** SIDEBAR: Mobile overlay *** */
  @media (max-width: 768px) {
    .sidebar-overlay { display: block !important; }
    .sidebar-panel { position: fixed !important; left: -280px; z-index: 10000 !important; transition: left 0.3s ease !important; }
    .sidebar-panel.open { left: 0 !important; }
    .agent-overlay { left: 0 !important; }
  }
  @media (min-width: 769px) {
    .sidebar-overlay { display: none !important; }
    .sidebar-panel { position: relative !important; left: 0 !important; }
    .mobile-menu-btn { display: none !important; }
    .agent-overlay { left: 250px !important; }
  }
  /* *** TABLET: Optimize for iPad 768-1024px *** */
  @media (min-width: 769px) and (max-width: 1024px) {
    .marketplace-grid { grid-template-columns: repeat(2, 1fr) !important; }
    table { font-size: 13px !important; }
    td, th { padding: 5px 8px !important; }
  }
  /* *** MATCH-FIRST LISTINGS: card grid — 2 columns desktop, 1 column mobile *** */
  .mf-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; margin: 8px 0 12px; }
  @media (max-width: 768px) { .mf-grid { grid-template-columns: 1fr !important; } }
  /* *** MOBILE: Fix wobble, overflow, and frame issues *** */
  html, body { overflow-x: hidden !important; width: 100% !important; max-width: 100vw !important; }
  * { box-sizing: border-box; }
  @media (max-width: 768px) {
    table { font-size: 12px !important; }
    td, th { padding: 4px 6px !important; }
  }
`;

// ─── DEMO MODE ────────────────────────────────────────────────────────
const DEMO_MODE = false;

// ─── SUPABASE HELPERS ─────────────────────────────────────────────────
async function supabaseRequest(path, options = {}) {
  if (DEMO_MODE) return { data: null, error: null };
  const res = await fetch(`${SUPABASE_URL}/rest/v1${path}`, {
    ...options,
    headers: {
      apikey: SUPABASE_ANON_KEY,
      Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
      "Content-Type": "application/json",
      Prefer: options.headers && options.headers.Prefer ? options.headers.Prefer : "return=representation",
      ...(options.headers || {}),
    },
  });
  const data = await res.json();
  let count;
  try { const range = res.headers.get('content-range'); if (range) { const t = range.split('/')[1]; if (t && t !== '*') count = parseInt(t); } } catch(e) {}
  return { data, error: res.ok ? null : data, count };
}

// ─── EMAIL VERIFICATION ───────────────────────────────────────────────
function generateCode() {
  return Math.floor(100000 + Math.random() * 900000).toString();
}

async function sendVerificationEmail(email, code) {
  if (DEMO_MODE) return { status: 200 };
  const res = await fetch("https://api.emailjs.com/api/v1.0/email/send", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      service_id: EMAILJS_SERVICE_ID,
      template_id: EMAILJS_TEMPLATE_ID,
      user_id: EMAILJS_PUBLIC_KEY,
      template_params: { email, verification_code: code, to_name: email.split("@")[0] },
    }),
  });
  return res;
}

// ─── FIRECRAWL SEARCH ───────────────────────────────
async function firecrawlSearch(query, options = {}) {
  if (DEMO_MODE) {
    return generateDemoResults(query);
  }
  try {
    const requestBody = {
      query,
      limit: options.limit || 5,
    };

    // Only include scrapeOptions if explicitly passed
    // Without scrapeOptions: fast search (2-3 sec), returns title + url + description
    // With scrapeOptions: slower (10-20 sec), returns full page markdown
    if (options.scrapeOptions) {
      requestBody.scrapeOptions = options.scrapeOptions;
    }

    const res = await fetch("/.netlify/functions/firecrawl-search", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    });
    if (!res.ok) {
      console.error("[Firecrawl] API error:", res.status, res.statusText);
      return { results: [], images: [], error: `API error: ${res.status}` };
    }
    const data = await res.json();
    if (data.error || data.success === false) {
      console.error("[Firecrawl] Error response:", data.error);
      return { results: [], images: [], error: data.error };
    }
    // Normalize Firecrawl response to match the shape our app expects:
    // Firecrawl returns: { success, data: [{ url, title, description, markdown? }] }
    // Our app expects: { results: [{ url, title, content }], images: [] }
   const fcResults = (data.data && data.data.web) ? data.data.web : (Array.isArray(data.data) ? data.data : []);
    const results = fcResults.map(r => ({
      url: r.url || "",
      title: r.title || "",
      // Use markdown if available (when scrapeOptions was used), otherwise description
      content: r.markdown || r.description || "",
      // Include JSON extraction data if available
      json: r.json || null,
    }));
    // Extract image URLs from markdown content (only present if scrapeOptions was used)
    const images = [];
    const videos = [];
    const seenImgs = new Set();
    fcResults.forEach(r => {
      const text = r.markdown || "";
      if (text) {
        // Find ALL image URLs in markdown — multiple patterns
        // 1. Markdown image refs: ![alt](url)
        const imgMatches = text.match(/!\[.*?\]\((https?:\/\/[^\s)]+)\)/g) || [];
        imgMatches.forEach(m => {
          const urlMatch = m.match(/\((https?:\/\/[^\s)]+)\)/);
          if (urlMatch && urlMatch[1]) addPhoto(urlMatch[1]);
        });
        // 2. HTML img src attributes
        const htmlImgMatches = text.match(/src=["'](https?:\/\/[^"'\s]+\.(?:jpg|jpeg|png|webp)[^"'\s]*)["']/gi) || [];
        htmlImgMatches.forEach(m => {
          const urlMatch = m.match(/src=["'](https?:\/\/[^"'\s]+)["']/i);
          if (urlMatch && urlMatch[1]) addPhoto(urlMatch[1]);
        });
        // 3. Bare URLs from Zillow, Redfin, Realtor.com photo CDNs
        const cdnMatches = text.match(/https?:\/\/(?:photos\.zillowstatic\.com|ap\.rdcpix\.com|ssl\.cdn-redfin\.com|img\.chime\.me\/imageemb)\/[^\s)\]"']+/gi) || [];
        cdnMatches.forEach(u => addPhoto(u));
        // 4. Any other .jpg/.webp URLs in the text
        const anyImgMatches = text.match(/https?:\/\/[^\s)\]"']+\.(?:jpg|jpeg|png|webp)[^\s)\]"']*/gi) || [];
        anyImgMatches.forEach(u => addPhoto(u));
        // 5. YouTube video URLs
        const ytMatches = text.match(/https?:\/\/(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)[^\s)\]"']+/gi) || [];
        ytMatches.forEach(u => { if (!videos.includes(u)) videos.push(u); });
        // 6. Matterport / virtual tour URLs
        const tourMatches = text.match(/https?:\/\/[^\s)\]"']*(?:matterport|my\.matterport)[^\s)\]"']*/gi) || [];
        tourMatches.forEach(u => { if (!videos.includes(u)) videos.push(u); });
      }
    });
    function addPhoto(url) {
      if (images.length >= 20) return;
      if (seenImgs.has(url)) return;
      if (url.includes('logo') || url.includes('icon') || url.includes('favicon') ||
          url.includes('avatar') || url.includes('sprite') || url.includes('static/images') ||
          url.includes('badge') || url.includes('agent') || url.includes('broker') ||
          url.length < 40) return;
      if (!url.match(/\.(jpg|jpeg|png|webp)/i) && !url.includes('zillowstatic') && !url.includes('rdcpix') && !url.includes('cdn-redfin') && !url.includes('chime.me/imageemb')) return;
      seenImgs.add(url);
      images.push(url);
    }
    console.log("[Firecrawl] Results:", results.length, "| Images:", images.length, "| Videos:", videos.length);
    return { results, images, videos };
  } catch (e) {
    console.error("[Firecrawl] Fetch failed:", e);
    return { results: [], images: [], error: e.message };
  }
}

// ─── FETCH DAILY MORTGAGE RATE ────────────────────────────────────────
async function fetchMortgageRate() {
  try {
   const res = await firecrawlSearch("today's 30 year fixed mortgage rate MND daily mortgage rate index", {
      limit: 3,
      scrapeOptions: { formats: ["markdown"], onlyMainContent: true },
    });
    const allContent = (res.results || []).map(r => r.content).join(" ");
    const rateMatch = allContent.match(/(?:30[- ]?year[- ]?fixed|30[- ]?yr)[^]*?(\d\.\d{1,2})%/i)
      || allContent.match(/(\d\.\d{1,2})%[^]*?(?:30[- ]?year|30[- ]?yr|fixed)/i)
      || allContent.match(/(?:average|current|today)[^]*?(\d\.\d{1,2})%/i);
    if (rateMatch) return parseFloat(rateMatch[1]);
    const anyRate = allContent.match(/(\d\.\d{1,2})%/);
    if (anyRate) {
      const r = parseFloat(anyRate[1]);
      if (r > 3 && r < 12) return r;
    }
  } catch (e) {
    console.log("Could not fetch mortgage rate, using fallback");
  }
  return 6.75;
}

// ─── LOFTY CRM INTEGRATION ──────────────────────────────────────────
async function loftyCRM(action, data) {
  try {
    const res = await fetch('/.netlify/functions/lofty-crm', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action, ...data }),
    });
    const result = await res.json();
    console.log(`[Lofty CRM] ${action}:`, result);
    return result;
  } catch (e) {
    console.error(`[Lofty CRM] ${action} failed:`, e.message);
    return { success: false, error: e.message };
  }
}

// ─── DETECT IF QUERY IS A SPECIFIC ADDRESS ────────────────────────────
function isSpecificAddress(query) {
  return /^\d+\s+[A-Za-z]/i.test(query.trim()) &&
    /\b(st|street|ave|avenue|blvd|boulevard|dr|drive|ln|lane|rd|road|ct|court|way|pl|place|cir|circle|pkwy|parkway)\b/i.test(query);
}

function generateDemoResults(query) {
  const q = query.toLowerCase();
  const isCommercial = q.includes("commercial") || q.includes("lease") || q.includes("restaurant") || q.includes("office") || q.includes("retail");
  const isNewConstruction = q.includes("new home") || q.includes("new construction");

  if (isNewConstruction) {
    return {
      results: [
        { title: "New Construction Homes", url: "https://www.showingnew.com/nationrealtor", content: "Browse new construction homes available in your area." },
      ],
      images: [],
    };
  }

  if (isCommercial) {
    return {
      results: [
        { title: "Restaurant Space for Lease - Downtown", url: "https://www.loopnet.com/listing/example1", content: "2,500 sq ft restaurant space, fully equipped kitchen, high foot traffic area. $4,500/mo NNN." },
        { title: "Retail Storefront - Main Street", url: "https://www.crexi.com/listing/example2", content: "1,800 sq ft retail space on Main St. Great visibility. $3,200/mo." },
        { title: "Business for Sale - Italian Restaurant", url: "https://www.bizbuysell.com/listing/example3", content: "Established Italian restaurant, 15 years in business. Revenue $850K/year. Asking $275,000." },
      ],
      images: ["https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=600", "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=600"],
    };
  }

  return {
    results: [
      { title: "4 Bed, 3 Bath Home - 123 Oak Lane, San Diego, CA 92101", url: "https://www.zillow.com/homedetails/example1", content: "Beautiful 4 bedroom, 3 bathroom home with 2,450 sq ft. Updated kitchen with granite countertops, hardwood floors throughout. Large backyard with pool. Listed at $875,000." },
      { title: "3 Bed, 2 Bath Condo - 456 Palm Ave, San Diego, CA 92102", url: "https://www.realtor.com/realestateandhomes-detail/example2", content: "Modern 3 bedroom, 2 bath condo in the heart of downtown. 1,650 sq ft with panoramic city views. In-unit laundry, secure parking. $625,000." },
      { title: "5 Bed, 4 Bath Estate - 789 Vista Dr, San Diego, CA 92103", url: "https://www.redfin.com/CA/San-Diego/example3", content: "Stunning 5 bedroom estate on a hill with ocean views. 3,800 sq ft, gourmet kitchen, home theater, 3-car garage. $1,450,000." },
      { title: "2 Bed, 2 Bath Townhome - 321 Elm St, San Diego, CA 92104", url: "https://www.homes.com/property/example4", content: "Charming townhome with 1,200 sq ft. Open floor plan, private patio, community pool. Walking distance to shops and restaurants. $485,000." },
    ],
    images: [
      "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=600",
      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600",
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=600",
    ],
  };
}

// ─── MORTGAGE CALCULATOR (accurate P&I, extracted taxes & HOA) ────────
function calculateMortgage(price, rate, downPct, monthlyTax, hoaAmount) {
  const downPayment = price * (downPct / 100);
  const loanAmount = price - downPayment;
  const monthlyRate = rate / 100 / 12;
  const numPayments = 30 * 12;
  // Standard amortization formula — exact P&I payment
  const monthlyPI = monthlyRate > 0
    ? (loanAmount * (monthlyRate * Math.pow(1 + monthlyRate, numPayments))) / (Math.pow(1 + monthlyRate, numPayments) - 1)
    : loanAmount / numPayments;
  const hoa = hoaAmount || 0;
  const tax = monthlyTax || 0;
  return {
    downPayment: Math.round(downPayment),
    monthlyPI: Math.round(monthlyPI),
    taxes: Math.round(tax),
    hoa,
    total: Math.round(monthlyPI + tax + hoa),
    loanAmount: Math.round(loanAmount),
  };
}

// ─── EXTRACT PROPERTY TAX FROM CONTENT ────────────────────────────────
// Priority: 1) Extract actual annual tax from listing page, 2) Fall back to state average rate
function extractPropertyTax(content, price, address) {
  // Try to extract actual annual tax amount from listing content
  if (content) {
    // Zillow/Redfin patterns: "Property Tax: $5,234", "Annual tax: $5,234", "Tax assessed: $5,234"
    const taxMatch = content.match(/(?:property\s*tax|annual\s*tax|tax\s*(?:assessed|amount|paid|history))\s*[:.]?\s*\$\s*([\d,]+)/i)
      || content.match(/\$\s*([\d,]+)\s*(?:\/?\s*(?:yr|year|annually))\s*(?:tax|property)/i)
      || content.match(/(?:tax|taxes)\s*[:.]?\s*\$\s*([\d,]+)\s*(?:\/?\s*(?:yr|year|annually))/i)
      || content.match(/(?:property\s*tax|tax\s*amount)\s*\$\s*([\d,]+)/i);
    if (taxMatch) {
      const annualTax = parseInt(taxMatch[1].replace(/,/g, ''));
      // Sanity check: tax should be between $500 and $100,000/year
      if (annualTax >= 500 && annualTax <= 100000) {
        return { monthlyTax: Math.round(annualTax / 12), annualTax, source: 'listing' };
      }
    }
  }

  // Fallback: use state average effective tax rate
  const stateRates = {
    'AL': 0.0040, 'AK': 0.0119, 'AZ': 0.0062, 'AR': 0.0062, 'CA': 0.0071,
    'CO': 0.0051, 'CT': 0.0198, 'DE': 0.0057, 'FL': 0.0089, 'GA': 0.0092,
    'HI': 0.0028, 'ID': 0.0063, 'IL': 0.0197, 'IN': 0.0085, 'IA': 0.0157,
    'KS': 0.0141, 'KY': 0.0086, 'LA': 0.0055, 'ME': 0.0136, 'MD': 0.0109,
    'MA': 0.0123, 'MI': 0.0154, 'MN': 0.0110, 'MS': 0.0080, 'MO': 0.0097,
    'MT': 0.0074, 'NE': 0.0173, 'NV': 0.0060, 'NH': 0.0186, 'NJ': 0.0240,
    'NM': 0.0080, 'NY': 0.0172, 'NC': 0.0080, 'ND': 0.0098, 'OH': 0.0157,
    'OK': 0.0090, 'OR': 0.0097, 'PA': 0.0153, 'RI': 0.0163, 'SC': 0.0057,
    'SD': 0.0128, 'TN': 0.0067, 'TX': 0.0168, 'UT': 0.0058, 'VT': 0.0190,
    'VA': 0.0082, 'WA': 0.0098, 'WV': 0.0058, 'WI': 0.0176, 'WY': 0.0057,
    'DC': 0.0056,
  };
  const stateMatch = (address || "").match(/\b([A-Z]{2})\s*\d{5}\b/)
    || (address || "").match(/,\s*([A-Z]{2})\s*$/i)
    || (address || "").match(/,\s*([A-Z]{2})\b/i);
  let taxRate = 0.0110; // national average fallback
  let stateName = "";
  if (stateMatch) {
    stateName = stateMatch[1].toUpperCase();
    if (stateRates[stateName]) taxRate = stateRates[stateName];
  }
  const annualTax = Math.round(price * taxRate);
  return { monthlyTax: Math.round(annualTax / 12), annualTax, taxRate, stateName, source: 'estimated' };
}

// ─── EXTRACT HOA FROM CONTENT ─────────────────────────────────────────
function extractHOA(content) {
  if (!content) return null;
  const hoaMatch = content.match(/HOA\s*(?:fee|dues?)?\s*[:.]?\s*\$\s*([\d,]+)/i)
    || content.match(/\$([\d,]+)\s*\/?\s*(?:mo|month)\s*HOA/i)
    || content.match(/HOA\s*[:.]?\s*\$([\d,]+)\s*(?:\/?\s*(?:mo|month))?/i)
    || content.match(/homeowners?\s*association\s*[:.]?\s*\$([\d,]+)/i);
  if (hoaMatch) {
    const amount = parseInt(hoaMatch[1].replace(/,/g, ''));
    if (amount > 0 && amount < 5000) return amount;
  }
  if (content.match(/no\s*HOA/i) || content.match(/HOA\s*[:.]?\s*(?:none|n\/a|\$0)/i)) {
    return 0;
  }
  return null; // unknown
}

// ─── TYPING ANIMATION ─────────────────────────────────────────────────
function TypingDots() {
  return (
    <div style={{ display: "flex", gap: 5, padding: "12px 0", alignItems: "center" }}>
      {[0, 1, 2].map((i) => (
        <div key={i} style={{
          width: 8, height: 8, borderRadius: "50%", background: theme.red,
          animation: `dotBounce 1.4s infinite ease-in-out both`,
          animationDelay: `${i * 0.16}s`,
        }} />
      ))}
    </div>
  );
}

// ─── REGISTRATION COMPONENT ──────────────────────────────────────────
function RegistrationScreen({ onLogin }) {
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [sentCode, setSentCode] = useState("");
  const [consentChecked, setConsentChecked] = useState(false);

  const handleRegister = async () => {
    if (!firstName || !lastName || !phone || !email || !password) { setError("Please fill in all fields."); return; }
    if (password.length < 6) { setError("Password must be at least 6 characters."); return; }
    if (!consentChecked) { setError("Please agree to the terms before continuing."); return; }
    const fullName = `${firstName} ${lastName}`;
    setLoading(true); setError("");
    if (DEMO_MODE) {
      const demoCode = generateCode();
      setSentCode(demoCode);
      setMode("verify");
      setLoading(false);
      return;
    }
    try {
      const { error: dbErr } = await supabaseRequest("/users?email=eq." + encodeURIComponent(email), { method: "GET" });
      const vCode = generateCode();
      setSentCode(vCode);
      await supabaseRequest("/users", {
        method: "POST",
        body: JSON.stringify({ email, password, name: fullName, phone, verification_code: vCode, verified: false }),
      });
      await sendVerificationEmail(email, vCode);
      setMode("verify");
    } catch (e) { setError("Registration failed. Try again."); }
    setLoading(false);
  };

  const handleVerify = async () => {
    const fullName = `${firstName} ${lastName}`.trim();
    if (DEMO_MODE) {
      if (code === sentCode) { onLogin({ email, name: fullName, phone }); }
      else { setError("Invalid code. Try again."); }
      return;
    }
    setLoading(true); setError("");
    try {
      const { data } = await supabaseRequest(`/users?email=eq.${encodeURIComponent(email)}&verification_code=eq.${code}`, { method: "GET" });
      if (data && data.length > 0) {
        await supabaseRequest(`/users?email=eq.${encodeURIComponent(email)}`, { method: "PATCH", body: JSON.stringify({ verified: true }) });
        onLogin({ email, name: data[0].name || fullName, phone: data[0].phone || phone });
      } else { setError("Invalid verification code."); }
    } catch { setError("Verification failed."); }
    setLoading(false);
  };

  const handleLogin = async () => {
    if (!email || !password) { setError("Please enter email and password."); return; }
    setLoading(true); setError("");
    if (DEMO_MODE) {
      onLogin({ email, name: email.split("@")[0] });
      setLoading(false);
      return;
    }
    try {
      const { data } = await supabaseRequest(`/users?email=eq.${encodeURIComponent(email)}&password=eq.${encodeURIComponent(password)}&select=*`, { method: "GET" });
      if (data && data.length > 0 && data[0].verified) {
        onLogin({ email, name: data[0].name, phone: data[0].phone || '' });
      } else { setError("Invalid credentials or unverified account."); }
    } catch { setError("Login failed."); }
    setLoading(false);
  };

  const inputStyle = {
    width: "100%", padding: "14px 16px", border: `2px solid ${theme.greyLight}`, borderRadius: theme.radiusSm,
    fontSize: 15, fontFamily: theme.font, outline: "none", transition: "border-color 0.2s",
    background: theme.white,
  };

  return (
    <div style={{
      minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
      background: `linear-gradient(135deg, ${theme.offWhite} 0%, #fff 50%, ${theme.offWhite} 100%)`,
      padding: 20,
    }}>
      {mode !== "verify" && (
        <div style={{
          textAlign: "center", maxWidth: 600, marginBottom: 32,
          animation: "fadeUp 0.6s ease-out",
        }}>
          <h1 style={{
            fontFamily: theme.fontDisplay, fontSize: "clamp(32px, 5vw, 48px)", fontWeight: 700,
            color: theme.dark, marginBottom: 12, lineHeight: 1.1, letterSpacing: "-0.02em",
          }}>
            Your AI-Powered Real Estate Assistant
          </h1>
          <p style={{
            color: theme.grey, fontSize: "clamp(14px, 1.4vw, 17px)", fontWeight: 400,
            lineHeight: 1.5, maxWidth: 520, margin: "0 auto",
          }}>
            Search homes, submit offers, get pre-approved, and schedule tours — all in one intelligent platform for buyers, sellers, and borrowers.
          </p>
        </div>
      )}
      <div style={{
        width: "100%", maxWidth: 440, background: theme.white, borderRadius: 20,
        boxShadow: "0 20px 60px rgba(0,0,0,0.08)", padding: "48px 36px",
        animation: "fadeUp 0.8s ease-out",
      }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <img src="/logo.png" alt="Realty AI" style={{
            width: 100, height: 100, borderRadius: 20,
            boxShadow: "0 8px 24px rgba(227,24,55,0.25)", marginBottom: 16,
          }} />
          <h1 style={{ fontFamily: theme.fontDisplay, fontSize: 28, fontWeight: 700, color: theme.dark, marginBottom: 4 }}>
            Realty AI
          </h1>
          <p style={{ color: theme.grey, fontSize: 14 }}>
            {mode === "login" ? "Welcome back" : mode === "register" ? "Create your account" : "Verify your email"}
          </p>
        </div>

        {error && (
          <div style={{
            background: "#FEF2F2", border: "1px solid #FECACA", borderRadius: theme.radiusSm,
            padding: "10px 14px", marginBottom: 16, color: "#B91C1C", fontSize: 13,
          }}>{error}</div>
        )}

        {mode === "verify" ? (
          <>
            <p style={{ color: theme.grey, fontSize: 14, marginBottom: 8, textAlign: "center" }}>
              Enter the 6-digit code sent to <strong>{email}</strong>
            </p>
            {DEMO_MODE && (
              <p style={{ color: theme.red, fontSize: 13, marginBottom: 16, textAlign: "center", background: "#FEF2F2", padding: 8, borderRadius: 8 }}>
                Demo Mode — Your code is: <strong>{sentCode}</strong>
              </p>
            )}
            <input
              style={{ ...inputStyle, textAlign: "center", fontSize: 24, letterSpacing: 8, fontWeight: 600 }}
              placeholder="000000" maxLength={6} value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
              onFocus={(e) => e.target.style.borderColor = theme.red}
              onBlur={(e) => e.target.style.borderColor = theme.greyLight}
            />
            <button onClick={handleVerify} disabled={loading} style={{
              width: "100%", padding: 16, background: theme.red, color: theme.white,
              border: "none", borderRadius: theme.radiusSm, fontSize: 16, fontWeight: 600,
              fontFamily: theme.font, cursor: "pointer", marginTop: 20,
              boxShadow: "0 4px 16px rgba(227,24,55,0.3)", transition: "all 0.2s",
            }}>
              {loading ? "Verifying..." : "Verify Email"}
            </button>
          </>
        ) : (
          <>
            {mode === "register" && (
              <>
              <div style={{ display: "flex", gap: 10, marginBottom: 14 }}>
                <div style={{ flex: 1 }}>
                  <label style={{ display: "block", fontSize: 13, fontWeight: 500, color: theme.dark, marginBottom: 6 }}>First Name</label>
                  <input style={inputStyle} placeholder="John" value={firstName} onChange={(e) => setFirstName(e.target.value)}
                    onFocus={(e) => e.target.style.borderColor = theme.red}
                    onBlur={(e) => e.target.style.borderColor = theme.greyLight} />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ display: "block", fontSize: 13, fontWeight: 500, color: theme.dark, marginBottom: 6 }}>Last Name</label>
                  <input style={inputStyle} placeholder="Doe" value={lastName} onChange={(e) => setLastName(e.target.value)}
                    onFocus={(e) => e.target.style.borderColor = theme.red}
                    onBlur={(e) => e.target.style.borderColor = theme.greyLight} />
                </div>
              </div>
              <div style={{ marginBottom: 14 }}>
                <label style={{ display: "block", fontSize: 13, fontWeight: 500, color: theme.dark, marginBottom: 6 }}>Phone Number</label>
                <input style={inputStyle} type="tel" placeholder="(555) 123-4567" value={phone} onChange={(e) => setPhone(e.target.value)}
                  onFocus={(e) => e.target.style.borderColor = theme.red}
                  onBlur={(e) => e.target.style.borderColor = theme.greyLight} />
              </div>
              </>
            )}
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: "block", fontSize: 13, fontWeight: 500, color: theme.dark, marginBottom: 6 }}>Email</label>
              <input style={inputStyle} type="email" placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => { if (e.key === "Enter" && mode === "login") handleLogin(); }}
                onFocus={(e) => e.target.style.borderColor = theme.red}
                onBlur={(e) => e.target.style.borderColor = theme.greyLight} />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: "block", fontSize: 13, fontWeight: 500, color: theme.dark, marginBottom: 6 }}>Password</label>
              <div style={{ position: "relative" }}>
                <input style={{ ...inputStyle, paddingRight: 44 }} type={showPass ? "text" : "password"} placeholder="••••••••"
                  value={password} onChange={(e) => setPassword(e.target.value)}
                  onKeyDown={(e) => { if (e.key === "Enter") { mode === "login" ? handleLogin() : handleRegister(); } }}
                  onFocus={(e) => e.target.style.borderColor = theme.red}
                  onBlur={(e) => e.target.style.borderColor = theme.greyLight} />
                <button onClick={() => setShowPass(!showPass)} style={{
                  position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)",
                  background: "none", border: "none", cursor: "pointer", color: theme.grey,
                }}>{showPass ? Icons.eyeOff : Icons.eye}</button>
              </div>
            </div>
            {/* Inline Disclaimer - only show on register mode */}
            {mode === "register" && (
              <div onClick={() => setConsentChecked(!consentChecked)} style={{
                display: "flex", gap: 10, cursor: "pointer", padding: "12px 0", alignItems: "flex-start",
              }}>
                <div style={{
                  width: 20, height: 20, minWidth: 20, borderRadius: 5,
                  border: consentChecked ? "none" : "2px solid #ccc",
                  background: consentChecked ? theme.red : "#fff",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  marginTop: 2, transition: "all 0.15s",
                }}>
                  {consentChecked && <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>}
                </div>
                <p style={{ fontSize: 11, color: "#666", lineHeight: 1.6, margin: 0, fontFamily: theme.font }} onClick={(e) => e.stopPropagation()}>
                  By checking this box, I agree by electronic signature to the{" "}
                  <a href="https://nationrealtor.axenrealty.com/site/electronic-disclosure-consent" target="_blank" rel="noopener noreferrer" style={{ color: theme.red, textDecoration: "none", fontWeight: 600 }}>Electronic Disclosure Consent Agreement</a>
                  ; to receive recurring marketing communication from or on behalf of Giancarlo DiFazio,{" "}
                  <a href="https://www.nationrealtor.com" target="_blank" rel="noopener noreferrer" style={{ color: theme.red, textDecoration: "none", fontWeight: 600 }}>nationrealtor.com</a>,{" "}
                  <a href="https://nationrealtor.axenrealty.com" target="_blank" rel="noopener noreferrer" style={{ color: theme.red, textDecoration: "none", fontWeight: 600 }}>nationrealtor.axenrealty.com</a>,{" "}
                  <a href="https://www.nationhomelending.com" target="_blank" rel="noopener noreferrer" style={{ color: theme.red, textDecoration: "none", fontWeight: 600 }}>nationhomelending.com</a> and{" "}
                  <a href="https://realtyaii.netlify.app" target="_blank" rel="noopener noreferrer" style={{ color: theme.red, textDecoration: "none", fontWeight: 600 }}>realtyaii.netlify.app</a>{" "}
                  including auto-dialed calls, texts, and artificial/prerecorded voice messages
                  (message frequency varies; data rates may apply; reply "STOP" to opt-out of texts or "HELP" for assistance); and to the{" "}
                  <a href="https://nationrealtor.axenrealty.com/site/privacy-terms#terms-of-service" target="_blank" rel="noopener noreferrer" style={{ color: theme.red, textDecoration: "none", fontWeight: 600 }}>Terms of Service</a> and{" "}
                  <a href="https://nationrealtor.axenrealty.com/site/privacy-terms#privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: theme.red, textDecoration: "none", fontWeight: 600 }}>Privacy Policy</a>{" "}
                  of this website. Consent not required to make a purchase.
                </p>
              </div>
            )}
            <button onClick={mode === "login" ? handleLogin : handleRegister} disabled={loading || (mode === "register" && !consentChecked)} style={{
              width: "100%", padding: 16, background: (mode === "register" && !consentChecked) ? "#ccc" : theme.red, color: theme.white,
              border: "none", borderRadius: theme.radiusSm, fontSize: 16, fontWeight: 600,
              fontFamily: theme.font, cursor: (mode === "register" && !consentChecked) ? "not-allowed" : "pointer",
              boxShadow: (mode === "register" && !consentChecked) ? "none" : "0 4px 16px rgba(227,24,55,0.3)", transition: "all 0.2s",
            }}>
              {loading ? "Please wait..." : mode === "login" ? "Sign In" : "Create Account"}
            </button>
            <p style={{ textAlign: "center", marginTop: 20, fontSize: 14, color: theme.grey }}>
              {mode === "login" ? "Don't have an account? " : "Already have an account? "}
              <button onClick={() => { setMode(mode === "login" ? "register" : "login"); setError(""); }}
                style={{ background: "none", border: "none", color: theme.red, fontWeight: 600, cursor: "pointer", fontFamily: theme.font, fontSize: 14 }}>
                {mode === "login" ? "Sign Up" : "Sign In"}
              </button>
            </p>
          </>
        )}
      </div>
    </div>
  );
}

// ─── CHAT MESSAGE COMPONENT ──────────────────────────────────────────
function ChatMessage({ msg, index, profilePhoto, userInitials }) {
  const isUser = msg.role === "user";

  return (
    <div style={{
      display: "flex", gap: 12, maxWidth: window.innerWidth <= 768 ? "100%" : 820, margin: "0 auto",
      flexDirection: isUser ? "row-reverse" : "row",
      animation: "fadeUp 0.35s ease-out", animationDelay: `${index * 0.05}s`,
      animationFillMode: "backwards", padding: "4px 0",
    }}>
      {/* Avatar: logo for AI, photo/initials for user */}
      {isUser ? (
        profilePhoto ? (
          <img src={profilePhoto} alt="" style={{
            width: 36, height: 36, borderRadius: 12, flexShrink: 0, objectFit: "cover",
          }} />
        ) : (
          <div style={{
            width: 36, height: 36, borderRadius: 12, flexShrink: 0,
            background: theme.dark,
            display: "flex", alignItems: "center", justifyContent: "center",
            color: theme.white, fontSize: 13, fontWeight: 700,
          }}>{userInitials || Icons.user}</div>
        )
      ) : (
        <img src="/logo.png" alt="Realty AI" style={{
          width: 36, height: 36, borderRadius: 12, flexShrink: 0,
          boxShadow: "0 3px 12px rgba(227,24,55,0.2)",
        }} />
      )}
      <div style={{
        background: isUser ? theme.dark : theme.white,
        color: isUser ? theme.white : theme.dark,
        padding: window.innerWidth <= 768 ? "10px 10px" : "14px 18px", borderRadius: 16,
        borderTopRightRadius: isUser ? 4 : 16,
        borderTopLeftRadius: isUser ? 16 : 4,
        maxWidth: window.innerWidth <= 768 ? "92%" : "80%", fontSize: window.innerWidth <= 768 ? 13.5 : 14.5, lineHeight: 1.65,
        boxShadow: isUser ? "none" : theme.shadow,
        whiteSpace: "pre-wrap", wordBreak: "break-word",
      }}>
        {msg.type === "rich" ? <RichContent content={msg.content} /> : msg.content}
        {msg.attachments && msg.attachments.length > 0 && (
          <div style={{ marginTop: 8, display: "flex", gap: 6, flexWrap: "wrap" }}>
            {msg.attachments.map((a, i) => (
              <div key={i} style={{
                display: "flex", alignItems: "center", gap: 4, background: "rgba(255,255,255,0.15)",
                padding: "4px 10px", borderRadius: 8, fontSize: 12,
              }}>
                {Icons.file} {a.name}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

// ─── RICH CONTENT RENDERER ───────────────────────────────────────────
function RichContent({ content }) {
  if (typeof content === "string") {
    return <div dangerouslySetInnerHTML={{ __html: formatText(content) }} />;
  }
  return content;
}

function formatText(text) {
  let html = text;

  const lines = html.split('\n');
  let inTable = false;
  let tableHTML = '';
  let headerDone = false;
  const processed = [];

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i].trim();
    if (line.startsWith('|') && line.endsWith('|')) {
      if (!inTable) {
        inTable = true;
        headerDone = false;
        tableHTML = '<div style="overflow-x:auto;-webkit-overflow-scrolling:touch;margin:12px 0;max-width:100%;"><table style="width:100%;border-collapse:collapse;font-size:12px;border-radius:8px;overflow:hidden;">';
      }
      if (line.match(/^\|[\s\-:|]+\|$/)) {
        headerDone = true;
        continue;
      }
      const cells = line.split('|').filter(c => c.trim() !== '');
      if (!headerDone) {
        tableHTML += '<tr>';
        cells.forEach(c => {
          tableHTML += `<th style="background:#E31837;color:#fff;padding:8px 8px;text-align:left;font-weight:600;border:1px solid #c41230;font-size:11px;white-space:nowrap;">${c.trim().replace(/\*\*/g,'')}</th>`;
        });
        tableHTML += '</tr>';
      } else {
        tableHTML += '<tr>';
        cells.forEach((c, ci) => {
          const val = c.trim().replace(/\*\*/g,'');
          const bg = ci === 0 ? 'background:#FEF2F2;font-weight:600;' : '';
          tableHTML += `<td style="padding:6px 8px;border:1px solid #E5E7EB;font-size:12px;white-space:nowrap;${bg}">${val}</td>`;
        });
        tableHTML += '</tr>';
      }
    } else {
      if (inTable) {
        tableHTML += '</table></div>';
        processed.push(tableHTML);
        inTable = false;
        tableHTML = '';
        headerDone = false;
      }
      processed.push(line);
    }
  }
  if (inTable) {
    tableHTML += '</table></div>';
    processed.push(tableHTML);
  }

  html = processed.join('\n');

  // Photo grid: replace tags and strip newlines between grid start/end so images flow inline
  html = html.replace(/\{\{PHOTO_GRID_START\}\}\n*/g, '<div style="display:flex;flex-wrap:wrap;gap:6px;margin:8px 0;">');
  html = html.replace(/\n*\{\{PHOTO_GRID_END\}\}/g, '</div>');
  html = html.replace(/\{\{IMG:(.*?)\}\}\n?/g, '<img src="$1" style="width:calc(50% - 3px);height:200px;object-fit:cover;border-radius:10px;" onerror="this.style.display=\'none\'" />');
  html = html.replace(/\{\{YOUTUBE:(.*?)\}\}/g, '<div style="margin:8px 0;width:100%;aspect-ratio:16/9;"><iframe width="100%" height="100%" style="width:100%;height:100%;border-radius:10px;border:none;display:block;" src="https://www.youtube.com/embed/$1" allowfullscreen></iframe></div>');
  html = html.replace(/━+/g, '<hr style="border:none;border-top:2px solid #E5E7EB;margin:12px 0;"/>');
  html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener" style="color:#E31837;text-decoration:underline;font-weight:500">$1</a>');

  // -- Bare URLs (http://... or https://...) → clickable links
  // Skip URLs already inside an <a href="..."> tag by requiring the URL not be preceded by href=" or >
  html = html.replace(/(^|[^"'>])(https?:\/\/[^\s<>"'\)]+)/g, function(_match, prefix, url) {
    return prefix + '<a href="' + url + '" target="_blank" rel="noopener" style="color:#E31837;text-decoration:underline;font-weight:500;word-break:break-all;">' + url + '</a>';
  });

  html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

  // -- Headers (## and ###) -- must be at line start, before newline-to-br conversion
  html = html.replace(/^###\s+(.+)$/gm, '<h3 style="font-size:15px;font-weight:700;color:#1F2937;margin:14px 0 6px;">$1</h3>');
  html = html.replace(/^##\s+(.+)$/gm, '<h2 style="font-size:18px;font-weight:700;color:#111827;margin:18px 0 8px;border-bottom:2px solid #E31837;padding-bottom:4px;">$1</h2>');
  html = html.replace(/^#\s+(.+)$/gm, '<h1 style="font-size:22px;font-weight:800;color:#111827;margin:20px 0 10px;">$1</h1>');

  // -- Horizontal rules: --- on its own line
  html = html.replace(/^---+$/gm, '<hr style="border:none;border-top:1px solid #E5E7EB;margin:16px 0;"/>');

  // -- Numbered lists: groups of consecutive lines starting "1. ", "2. " etc.
  html = html.replace(/(?:^\d+\.\s+.+(?:\n|$))+/gm, function(block) {
    const items = block.trim().split(/\n/).map(line => line.replace(/^\d+\.\s+/, ''));
    return '<ol style="margin:8px 0 8px 20px;padding-left:8px;">' +
      items.map(it => '<li style="margin:3px 0;">' + it + '</li>').join('') +
      '</ol>';
  });

  // -- Bullet lists: groups of consecutive lines starting "- " or "* "
  html = html.replace(/(?:^[-*]\s+.+(?:\n|$))+/gm, function(block) {
    const items = block.trim().split(/\n/).map(line => line.replace(/^[-*]\s+/, ''));
    return '<ul style="margin:8px 0 8px 20px;padding-left:8px;list-style:disc;">' +
      items.map(it => {
        const isCmaCompare = /(?:<strong>|\*\*)\s*(Current Asking Price|CMA Estimate|Suggested Listing\/Offer Range)\s*:?\s*(?:<\/strong>|\*\*)/i.test(it);
        const liStyle = isCmaCompare
          ? 'margin:6px 0;color:#E31837;font-weight:700;font-size:14px;'
          : 'margin:3px 0;';
        return '<li style="' + liStyle + '">' + it + '</li>';
      }).join('') +
      '</ul>';
  });

  html = html.replace(/\n/g, '<br/>');

  return html;
}

// ─── CLEAN CONTENT ─────────────────────────────────────────────
function cleanContent(rawContent) {
  if (!rawContent) return "";
  let text = rawContent;
  text = text.replace(/#{1,4}\s*[A-Za-z\s&]+\n?/g, '');
  text = text.replace(/\$[\d,]+\/sq\s*ft\s*/g, '');
  text = text.replace(/All mortgage lending products[\s\S]*?(?=\n\n|\Z)/gi, '');
  text = text.replace(/Redfin Corporation[\s\S]*?(?=\n\n|\Z)/gi, '');
  text = text.replace(/If you are using a screen reader[\s\S]*?(?=\n\n|\Z)/gi, '');
  text = text.replace(/This site is not authorized[\s\S]*?(?=\n\n|\Z)/gi, '');
  text = text.replace(/NMLS\s*#\d+[^.]*\./gi, '');
  text = text.replace(/Licensed in \d+ states\.[^.]*\./gi, '');
  text = text.replace(/\|\s*\|/g, '');
  text = text.replace(/\|\s*\d+\s+\$[\d,]+\s+\d+\s+bed.*?\|/g, '');
  text = text.replace(/Show more\s*\.{0,3}/gi, '');
  text = text.replace(/View estimated energy.*$/gim, '');
  text = text.replace(/\n{3,}/g, '\n\n').trim();
  const sentences = text.split(/\.\s+/);
  let cleaned = "";
  for (const s of sentences) {
    if (cleaned.length > 300) break;
    if (s.trim().length > 10) cleaned += s.trim() + ". ";
  }
  return cleaned.trim() || text.substring(0, 300).trim();
}

// ─── EXTRACT LOCATION FROM QUERY ──────────────────────────────────────
function extractLocationFromQuery(query) {
  // Try "in/near/around City, ST" pattern
  const cityState = query.match(/(?:in|near|around)\s+([A-Za-z\s]+(?:,\s*[A-Z]{2})?)/i);
  if (cityState) return cityState[1].trim();
  // Try "City for/under/budget" pattern
  const cityBudget = query.match(/^([A-Za-z\s]+?)(?:\s+for|\s+under|\s+\$|\s+budget|\s+homes|\s+houses|\s+properties)/i);
  if (cityBudget && cityBudget[1].trim().length > 2) return cityBudget[1].trim();
  // Try "City, ST" anywhere in query
  const cityStateAnywhere = query.match(/([A-Za-z\s]+,\s*[A-Z]{2})\b/);
  if (cityStateAnywhere) return cityStateAnywhere[1].trim();
  // Try zip code
  const zip = query.match(/\b\d{5}\b/);
  if (zip) return zip[0];
  return "";
}

// ─── PROCESS SEARCH RESULTS ──────────────────────────────────────────
function buildPropertyResponse(query, searchResults, mortgageRate, isAddressSearch, videos, known) {
  const q = query.toLowerCase();
  const isCommercial = q.includes("commercial") || q.includes("lease") || q.includes("restaurant") || q.includes("office") || q.includes("retail") || q.includes("business");
  const isNewConstruction = q.includes("new home") || q.includes("new construction");
  const results = searchResults.results || [];
  // *** MATCH-FIRST: when opened from an IDX card, that listing's own photos come first, then
  // scraped photos from listing-portal CDNs only (so agent headshots / logos stay out) ***
  // Scraped pages also carry "similar homes" photos, logos and icons that can't be told apart
  // from the listing's own, so an IDX card's panel uses the feed photos only.
  const images = (known && known.photos && known.photos.length > 0) ? known.photos : (searchResults.images || []);
  const propertyVideos = videos || [];
  const rate = mortgageRate || 6.75;

  const exactAddress = isAddressSearch ? query.trim() : "";
  const location = isAddressSearch ? exactAddress : extractLocationFromQuery(query);
  // Always try to get the best address — use query if it looks like an address, or first result title
  const firstResultAddr = results[0]?.title ? extractAddress(results[0].title) : "";
  const mapAddress = exactAddress || location || firstResultAddr || query.trim() || "property location";
  const encodedAddr = encodeURIComponent(mapAddress);

  let output = "";

  if (isNewConstruction) {
    output += `🏗️ **New Construction Homes**\n\n`;
    output += `Browse new construction homes here:\n[ShowingNew - New Homes](https://www.showingnew.com/nationrealtor)\n\n`;
    if (results.length > 0) {
      results.forEach((r) => {
        output += `**${r.title}**\n[View Listing](${r.url})\n\n`;
      });
    }
    return output;
  }

if (isAddressSearch) {
    output += `🏠 **Property Details**\n\n`;
    output += `**${exactAddress}**\n\n`;

    // Extract property details from content
    const allContent = results.map(r => r.content || "").join(" ") + " " + results.map(r => r.title || "").join(" ");
    const price = (known && known.price) || extractPrice(allContent) || 500000;
    const sqft = (known && known.sqft) || extractSqft(allContent) || 2000;
    const bedsMatch = (known && known.beds) ? [null, String(known.beds)] : allContent.match(/(\d+)\s*(?:beds?|bedrooms?|br)\b/i);
    const bathsMatch = (known && known.baths) ? [null, String(known.baths)] : allContent.match(/([\d.]+)\s*(?:baths?|bathrooms?|ba)\b/i);
    const yearMatch = allContent.match(/(?:built\s*(?:in\s*)?|year\s*built\s*[:.]?\s*)(\d{4})/i);
    const lotMatch = allContent.match(/([\d,.]+)\s*(?:acre|sq\s*ft\s*lot|lot\s*size)/i);
    const typeMatch = allContent.match(/\b(single\s*family|condo|townhouse|townhome|multi\s*family|duplex|triplex|manufactured)\b/i);

    const beds = bedsMatch ? bedsMatch[1] : null;
    const baths = bathsMatch ? bathsMatch[1] : null;
    const yearBuilt = yearMatch ? yearMatch[1] : null;
    const lotSize = lotMatch ? lotMatch[1] : null;
    const propType = typeMatch ? typeMatch[1] : null;

    // Show property summary
    output += `💰 **Price: $${price.toLocaleString()}**\n\n`;
    let details = [];
    if (beds) details.push(`🛏️ ${beds} Beds`);
    if (baths) details.push(`🛁 ${baths} Baths`);
    if (sqft) details.push(`📐 ${sqft.toLocaleString()} sqft`);
    if (yearBuilt) details.push(`📅 Built ${yearBuilt}`);
    if (propType) details.push(`🏠 ${propType}`);
    if (lotSize) details.push(`🌳 ${lotSize} acres lot`);
    if (details.length > 0) output += details.join("  ·  ") + `\n\n`;

    if (images.length > 0) {
      output += `📸 **Property Photos**\n\n`;
      output += `{{PHOTO_GRID_START}}\n`;
      images.forEach((img) => { output += `{{IMG:${img}}}\n`; });
      output += `{{PHOTO_GRID_END}}\n\n`;
    }
    // Show YouTube videos if found
    if (propertyVideos.length > 0) {
      output += `🎥 **Property Videos**\n\n`;
      propertyVideos.forEach(v => {
        const ytId = v.url.match(/(?:watch\?v=|shorts\/|embed\/|youtu\.be\/)([\w-]+)/);
        if (ytId) {
          output += `{{YOUTUBE:${ytId[1]}}}\n`;
          if (v.title) output += `*${v.title}*\n`;
        }
      });
      output += `\n`;
    }
    const reSites = results.filter(r => r.url.match(/zillow|realtor\.com|redfin|homes\.com/i));
    const bestResult = reSites[0] || results[0];
    if (bestResult) {
      output += `🔗 [View Full Listing](${bestResult.url})\n\n`;
    }

    output += buildMortgageTable(price, rate, exactAddress, allContent);
    output += buildConfidentTrigger(price, sqft);
    output += buildAreaLinks(exactAddress, encodedAddr);
    return output;
  }
  if (isCommercial) {
    output += `🏢 **Commercial Real Estate Results**\n\n`;
  } else {
    output += `🏠 **Residential Property Results**\n\n`;
  }

  if (images.length > 0) {
    output += `📸 **Property Photos**\n\n`;
    images.forEach((img) => { output += `{{IMG:${img}}}\n`; });
    output += `\n`;
  }

  if (results.length === 0) {
    output += `⚠️ **No listings found for this search.**\n\n`;
    output += `This could be due to:\n`;
    output += `• No matching properties in this area/price range\n`;
    output += `• Temporary search service issue\n\n`;
    output += `**Try refining your search** — add a city, state, price range, or bedroom count.\n`;
    output += `*Example: "3 bed homes in Las Vegas under $500K"*\n`;
    return output;
  }

  // *** MATCH-FIRST LISTINGS: card grid. Mortgage / Trigger / Area now live in the
  // per-property panel (click a card) instead of being computed from the first price found.
  output += buildListingCards(results, isCommercial);

  if (isCommercial && results.length > 0) {
    output += buildAreaLinks(mapAddress, encodedAddr);
  }

  return output;
}

// ─── MATCH-FIRST LISTINGS: CARD GRID ─────────────────────────────────
function listingSource(url) {
  const h = (url || "").toLowerCase();
  if (h.includes("zillow")) return { label: "Zillow", bg: "#E6F1FB", fg: "#0C447C" };
  if (h.includes("redfin")) return { label: "Redfin", bg: "#FCEBEB", fg: "#791F1F" };
  if (h.includes("realtor.com")) return { label: "Realtor.com", bg: "#EEEDFE", fg: "#26215C" };
  if (h.includes("homes.com")) return { label: "Homes.com", bg: "#E1F5EE", fg: "#04342C" };
  if (h.includes("loopnet")) return { label: "LoopNet", bg: "#FAEEDA", fg: "#633806" };
  if (h.includes("crexi")) return { label: "Crexi", bg: "#FAEEDA", fg: "#633806" };
  if (h.includes("bizbuysell")) return { label: "BizBuySell", bg: "#FAEEDA", fg: "#633806" };
  try { return { label: new URL(url).hostname.replace(/^www\./, ""), bg: "#F1EFE8", fg: "#444441" }; }
  catch { return { label: "Listing", bg: "#F1EFE8", fg: "#444441" }; }
}

// Strip portal suffixes from a search-result title and try to isolate the street address
function cleanListingTitle(title) {
  let t = (title || "").trim();
  t = t.split("|")[0].trim();
  t = t.replace(/\s*[-–]\s*(zillow|redfin|realtor\.com|homes\.com|loopnet|crexi|bizbuysell|mls\s*#?\s*[\w-]*|for sale|home details).*$/i, "").trim();
  const dashPart = t.match(/[-–]\s*(\d+\s+[A-Za-z].+)$/);
  if (dashPart && isSpecificAddress(dashPart[1])) t = dashPart[1].trim();
  return t;
}

function escListing(str) {
  return String(str || "")
    .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;")
    .replace(/\*\*/g, "");
}

function buildListingCards(results, isCommercial) {
  const seen = new Set();
  const cards = [];
  results.forEach((r) => {
    if (!r.url) return;
    const key = r.url.split("?")[0].split("#")[0].replace(/\/$/, "").toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);

    const text = (r.title || "") + " " + (r.content || "");
    const price = extractPrice(text);
    const sqft = extractSqft(text);
    const bedsMatch = text.match(/(\d+)\s*(?:beds?|bedrooms?|br|bd)\b/i);
    const bathsMatch = text.match(/([\d.]+)\s*(?:baths?|bathrooms?|ba)\b/i);
    const address = cleanListingTitle(r.title) || r.url;
    const src = listingSource(r.url);
    const clickable = !isCommercial && isSpecificAddress(address);
    const href = clickable ? `#listing-${encodeURIComponent(address)}` : r.url;
    const extAttrs = clickable ? "" : ` target="_blank" rel="noopener"`;

    const specs = [];
    if (bedsMatch) specs.push(`${bedsMatch[1]} bd`);
    if (bathsMatch) specs.push(`${bathsMatch[1]} ba`);
    if (sqft) specs.push(`${sqft.toLocaleString()} sqft`);

    cards.push(
      `<a href="${href}"${extAttrs} style="display:block;text-decoration:none;color:#1A1A1A;border:1px solid #E5E7EB;border-radius:12px;overflow:hidden;background:#fff;">` +
      `<div style="height:110px;background:#F1EFE8;display:flex;align-items:center;justify-content:center;position:relative;font-size:34px;">🏠` +
      `<span style="position:absolute;top:8px;left:8px;font-size:11px;font-weight:600;padding:3px 8px;border-radius:6px;background:${src.bg};color:${src.fg};">${src.label}</span></div>` +
      `<div style="padding:10px 12px;">` +
      `<div style="font-size:17px;font-weight:700;">${price ? "$" + price.toLocaleString() : "See listing for price"}</div>` +
      `<div style="font-size:12px;color:#6B7280;margin:2px 0 6px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${escListing(address)}</div>` +
      `<div style="font-size:12px;color:#6B7280;">${specs.length ? specs.join(" · ") : "Details on listing page"}</div>` +
      `<div style="font-size:12px;color:#E31837;font-weight:600;margin-top:8px;">${clickable ? "View details →" : "View listing ↗"}</div>` +
      `</div></a>`
    );
  });
  if (cards.length === 0) return "";
  return listingGridWrap(cards);
}

// Shared grid wrapper. The chat bubble is shrink-to-fit, so the grid needs an explicit width
// (capped at 100%) or auto-fill collapses to a single column.
function listingGridWrap(cards) {
  return `<div class="mf-grid" style="width:640px;max-width:100%;">${cards.join("")}</div>\n`;
}

// ─── MATCH-FIRST LISTINGS: TABLE-FIRST SEARCH ─────────────────────────
// Parses city / state / zip, target price (with under/over/±25% window) and beds from the query.
function parseMatchQuery(query) {
  const q = query.toLowerCase();
  let location = extractLocationFromQuery(query) || "";
  // extractLocationFromQuery keeps trailing words like "under" — cut them off
  location = location.replace(/\s+(under|over|below|above|for|with|around|near|between|from|up|to|homes?|houses?|properties|condos?|budget|max|min|at|and|area|region|neighborhood|neighbourhood|market|vicinity)\b.*$/i, "").trim();
  location = location.replace(/^(the)\s+/i, "").trim();
  let city = "", state = "", zip = "";
  if (/^\d{5}$/.test(location)) {
    zip = location;
  } else {
    const st = location.match(/^(.*?)[\s,]+([A-Za-z]{2})$/);
    if (st && /^[A-Z]{2}$/.test(st[2])) { city = st[1].trim(); state = st[2]; }
    else city = location.replace(/,\s*$/, "").trim();
  }

  let target = null;
  const pm = query.match(/\$\s*([\d.,]+)\s*(million|mil|m|k|thousand)?\b/i) || query.match(/\b([\d.,]+)\s*(million|mil|m|k)\b/i);
  if (pm) {
    let n = parseFloat(pm[1].replace(/,/g, ""));
    const u = (pm[2] || "").toLowerCase();
    if (u.startsWith("m")) n *= 1e6;
    else if (u === "k" || u === "thousand") n *= 1e3;
    if (!isNaN(n) && n >= 20000) target = Math.round(n);
  }
  let min = null, max = null;
  if (target) {
    if (/\b(under|below|less than|max|up to|no more than|within)\b/.test(q)) { min = 0; max = target; }
    else if (/\b(over|above|more than|at least|min|starting at)\b/.test(q)) { min = target; max = null; }
    else { min = Math.round(target * 0.75); max = Math.round(target * 1.25); }
  }
  const bm = query.match(/(\d+)\s*\+?\s*(?:bed|br|bd)/i);
  const beds = bm ? parseInt(bm[1]) : null;
  const rent = /\b(rent|rental|lease)\b/.test(q);
  return { city, state, zip, target, min, max, beds, rent };
}

function normalizeListingRow(l) {
  const photos = Array.isArray(l.photos) ? l.photos : (l.photo_url ? [l.photo_url] : []);
  const addr = l.address || "";
  const fullAddress = addr.includes(",") ? addr : [addr, l.city, l.state].filter(Boolean).join(", ");
  return {
    address: fullAddress,
    price: Number(l.price) || null,
    beds: l.beds || null,
    baths: l.baths || null,
    sqft: l.sqft || null,
    photo: photos[0] || null,
    photoCount: photos.length,
    photos,
    detailUrl: l.detailUrl || l.detail_url || "",
  };
}

// Listings shown as cards, keyed by lowercase address, so the panel can use the IDX
// photos / price instead of whatever the page scrape happens to find.
const matchListingCache = {};

// Fallback city → state map used only when the geocoder can't answer
const METRO_STATES = {
  "las vegas": "NV", "north las vegas": "NV", "henderson": "NV", "reno": "NV", "summerlin": "NV",
  "los angeles": "CA", "beverly hills": "CA", "san diego": "CA", "san francisco": "CA", "san jose": "CA",
  "sacramento": "CA", "irvine": "CA", "santa monica": "CA", "malibu": "CA", "pasadena": "CA", "long beach": "CA",
  "phoenix": "AZ", "scottsdale": "AZ", "tucson": "AZ", "mesa": "AZ",
  "miami": "FL", "orlando": "FL", "tampa": "FL", "fort lauderdale": "FL", "jacksonville": "FL",
  "austin": "TX", "dallas": "TX", "houston": "TX", "san antonio": "TX",
  "new york": "NY", "brooklyn": "NY", "chicago": "IL", "seattle": "WA", "portland": "OR",
  "denver": "CO", "atlanta": "GA", "boston": "MA", "nashville": "TN", "salt lake city": "UT",
  "boise": "ID", "charlotte": "NC", "washington": "DC", "philadelphia": "PA", "detroit": "MI", "minneapolis": "MN",
};

function withinMatch(row, p) {
  if (!row.address || !row.price) return false;
  if (p.min !== null && row.price < p.min) return false;
  if (p.max !== null && row.price > p.max) return false;
  if (p.beds && row.beds && row.beds < p.beds) return false;
  return true;
}

// Pull the "where" part of a sentence for the geocoder. Google is forgiving, so we only cut off
// the price / qualifier tokens that are clearly not part of a place name.
function extractLocationPhrase(query) {
  const clean = (t) => {
    t = t.replace(/\$\s*[\d.,]+\s*(million|mil|m|k|thousand)?\b/gi, " ");
  t = t.replace(/\b[\d.,]+\s*(million|mil|m|k)\b/gi, " ");
  t = t.replace(/\b(under|over|below|above|between|budget|max|min|up to|less than|more than|at least|no more than)\b.*$/i, " ");
  t = t.replace(/\b(\d+)\s*\+?\s*(bed|beds|bedroom|bedrooms|br|bd|bath|baths|bathroom|bathrooms|ba)\b/gi, " ");
  t = t.replace(/\b(homes?|houses?|properties|property|condos?|townhomes?|listings?|for sale|for rent|rentals?|looking for|find me|show me|i want|i need|please|a house|a home|a property|a condo|with a pool|with pool)\b/gi, " ");
    t = t.replace(/\b(for|with|and|or|the|a|an|in|near|around|at)\s*$/i, " ");
    return t.replace(/\s{2,}/g, " ").replace(/^[\s,.-]+|[\s,.-]+$/g, "").trim();
  };
  // Prefer the LAST place phrase ("in Los Angeles ... in the Beverly Hills area" → Beverly Hills),
  // since the later mention is usually the more specific one
  const parts = query.split(/\b(?:in|near|at|within|close to)\s+/i);
  for (let i = parts.length - 1; i >= 1; i--) { const c = clean(parts[i]); if (c) return c; }
  return clean(query);
}

async function geocodeLocation(text) {
  if (!text) return null;
  try {
    const res = await fetch("/.netlify/functions/geocode-location", {
      method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ text }),
    });
    if (!res.ok) { console.warn("[MatchFirst] geocode HTTP", res.status); return null; }
    const data = await res.json();
    if (!data.found) { console.warn("[MatchFirst] geocode:", data.status, data.message || ""); return null; }
    return data;
  } catch (e) { console.warn("[MatchFirst] geocode failed:", e.message); return null; }
}

// 1) marketplace_listings table (IDX imports + posted listings) → 2) live import-idx-listings page 1
// Returns null when nothing usable was found so handleSend can fall back to Firecrawl web search.
async function fetchMatchListings(query) {
  const p = parseMatchQuery(query);
  // Resolve the place with Google so "the beverly hills area" → Beverly Hills, CA
  const phrase = extractLocationPhrase(query);
  const geo = await geocodeLocation(phrase);
  if (geo && (geo.city || geo.zip)) {
    p.city = geo.city || p.city;
    p.state = geo.state || p.state;
    // Only treat it as a zip search when the user actually typed a zip
    p.zip = /^\d{5}$/.test(phrase) ? (geo.zip || p.zip) : "";
    console.log("[MatchFirst] geocoded", JSON.stringify(phrase), "→", geo.city, geo.state, geo.zip || "");
  }
  if (!p.city && !p.zip) return null;
  let rows = [];
  let source = "table";
  try {
    let f = `/marketplace_listings?select=address,city,state,zip,price,beds,baths,sqft,photos,listing_type&status=eq.active`;
    f += `&listing_type=eq.${p.rent ? "rent" : "sell"}`;
    if (p.zip) f += `&zip=eq.${p.zip}`;
    else f += `&city=ilike.*${encodeURIComponent(p.city)}*`;
    if (p.state) f += `&state=eq.${p.state}`;
    if (p.min !== null) f += `&price=gte.${p.min}`;
    if (p.max !== null) f += `&price=lte.${p.max}`;
    if (p.beds) f += `&beds=gte.${p.beds}`;
    f += `&order=price.asc&limit=40`;
    const { data } = await supabaseRequest(f, { method: "GET" });
    if (Array.isArray(data)) rows = data.map(normalizeListingRow).filter(r => withinMatch(r, p));
  } catch (e) { console.error("[MatchFirst] table query failed:", e); }

  // The IDX import needs a state. Borrow it from table rows if we have any, else from a
  // small metro map (covers the case where the geocoder is unavailable).
  if (!p.state && rows.length > 0) {
    try {
      const { data: st } = await supabaseRequest(`/marketplace_listings?select=state&city=ilike.*${encodeURIComponent(p.city)}*&limit=1`, { method: "GET" });
      if (Array.isArray(st) && st[0] && st[0].state) p.state = st[0].state;
    } catch (e) {}
  }
  if (!p.state && p.city) p.state = METRO_STATES[p.city.toLowerCase()] || "";

  // Top up from the live IDX feed, page by page, until we have 10 in the window
  if (rows.length < 10 && p.city) {
    source = rows.length ? "table+idx" : "idx";
    const seenAddr = new Set(rows.map(r => r.address.toLowerCase().trim()));
    for (let page = 1; page <= 5 && rows.length < 10; page++) {
      try {
        const body = { page, city: p.city };
        if (p.state) body.state = p.state;
        if (p.min !== null && p.min > 0) body.minPrice = p.min;
        if (p.max !== null) body.maxPrice = p.max;
        if (p.beds) body.beds = p.beds;
        const res = await fetch("/.netlify/functions/import-idx-listings", {
          method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body),
        });
        if (res.status === 429) { await new Promise(r => setTimeout(r, 2500)); page--; continue; }
        if (!res.ok) { console.warn("[MatchFirst] import-idx-listings page", page, "returned", res.status); break; }
        const data = await res.json();
        const batch = (data.listings || []);
        if (batch.length === 0) break;
        batch.map(normalizeListingRow).filter(r => withinMatch(r, p)).forEach(r => {
          const k = r.address.toLowerCase().trim();
          if (!seenAddr.has(k)) { seenAddr.add(k); rows.push(r); }
        });
        console.log("[MatchFirst] idx page", page, "→", batch.length, "listings,", rows.length, "in window");
        if (page < 5 && rows.length < 10) await new Promise(r => setTimeout(r, 600));
      } catch (e) { console.error("[MatchFirst] live IDX fetch failed:", e); break; }
    }
  }
  if (rows.length === 0) return null;

  // Closest to the target price first when there is one, else cheapest first; cap at 10, dedupe by address
  if (p.target) rows.sort((a, b) => Math.abs(a.price - p.target) - Math.abs(b.price - p.target));
  const seen = new Set();
  const listings = [];
  for (const r of rows) {
    const k = r.address.toLowerCase().trim();
    if (seen.has(k)) continue;
    seen.add(k); listings.push(r);
    matchListingCache[k] = r;
    if (listings.length >= 10) break;
  }
  console.log("[MatchFirst]", listings.length, "listings from", source);
  return { listings, source, ...p };
}

function fmtMoneyShort(n) {
  if (n >= 1e6) return "$" + (n / 1e6).toFixed(n % 1e6 === 0 ? 0 : 1) + "M";
  if (n >= 1e3) return "$" + Math.round(n / 1e3) + "K";
  return "$" + n;
}

function buildMatchCards(listings) {
  const cards = listings.map((r) => {
    const specs = [];
    if (r.beds) specs.push(`${r.beds} bd`);
    if (r.baths) specs.push(`${r.baths} ba`);
    if (r.sqft) specs.push(`${Number(r.sqft).toLocaleString()} sqft`);
    const photo = r.photo
      ? `🏠<img src="${escListing(r.photo)}" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;" onerror="this.style.display='none'" />`
      : `🏠`;
    const count = r.photoCount > 1 ? `<span style="position:absolute;bottom:8px;right:8px;font-size:11px;font-weight:600;padding:3px 8px;border-radius:6px;background:rgba(0,0,0,0.6);color:#fff;">📷 ${r.photoCount}</span>` : "";
    return `<a href="#listing-${encodeURIComponent(r.address)}" style="display:block;text-decoration:none;color:#1A1A1A;border:1px solid #E5E7EB;border-radius:12px;overflow:hidden;background:#fff;">` +
      `<div style="height:150px;background:#F1EFE8;display:flex;align-items:center;justify-content:center;position:relative;font-size:34px;overflow:hidden;">${photo}` +
      `<span style="position:absolute;top:8px;left:8px;font-size:11px;font-weight:600;padding:3px 8px;border-radius:6px;background:#E1F5EE;color:#04342C;">MLS</span>${count}</div>` +
      `<div style="padding:10px 12px;">` +
      `<div style="font-size:17px;font-weight:700;">$${r.price.toLocaleString()}</div>` +
      `<div style="font-size:12px;color:#6B7280;margin:2px 0 6px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${escListing(r.address)}</div>` +
      `<div style="font-size:12px;color:#6B7280;">${specs.length ? specs.join(" · ") : "Details on listing page"}</div>` +
      `<div style="font-size:12px;color:#E31837;font-weight:600;margin-top:8px;">View details →</div>` +
      `</div></a>`;
  });
  return listingGridWrap(cards);
}

function buildMatchResponse(query, match) {
  const cityTC = (match.city || "").replace(/\b\w/g, c => c.toUpperCase());
  const where = match.zip || [cityTC, match.state].filter(Boolean).join(", ");
  let range = "";
  if (match.min !== null && match.max !== null && match.min > 0) range = ` · ${fmtMoneyShort(match.min)}–${fmtMoneyShort(match.max)}`;
  else if (match.max !== null) range = ` · under ${fmtMoneyShort(match.max)}`;
  else if (match.min !== null && match.min > 0) range = ` · over ${fmtMoneyShort(match.min)}`;
  const bedsTxt = match.beds ? ` · ${match.beds}+ beds` : "";
  let o = `🏠 **Matching Listings** — ${match.listings.length} in ${where}${range}${bedsTxt}\n\n`;
  o += buildMatchCards(match.listings);
  o += `*Tap a home for photos, mortgage estimate, trigger analysis and area info.*\n`;
  return o;
}

// ─── TABLE BUILDERS ───────────────────────────────────────────────────

// ─── TABLE BUILDERS ───────────────────────────────────────────────────
function buildMortgageTable(price, rate, address, content) {
  const taxInfo = extractPropertyTax(content, price, address);
  const hoa = extractHOA(content);
  const hoaDisplay = hoa !== null ? hoa : 0;

  let o = `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n`;
  o += `💰 **Mortgage Estimate** (Rate: ${rate}% — 30yr Fixed, via MND Daily Index)\n`;
  o += `Property Price: $${price.toLocaleString()}`;
  // Show tax source
  if (taxInfo.source === 'listing') {
    o += ` | Taxes: $${taxInfo.annualTax.toLocaleString()}/yr (from listing)`;
  } else if (taxInfo.stateName) {
    o += ` | Taxes: $${taxInfo.annualTax.toLocaleString()}/yr est. (${taxInfo.stateName} avg ${(taxInfo.taxRate * 100).toFixed(2)}%)`;
  }
  if (hoa !== null) o += ` | HOA: ${hoa > 0 ? '$' + hoa + '/mo' : 'None'}`;
  else o += ` | HOA: N/A`;
  o += `\n\n`;
  o += `| Down | Down Pmt | P&I | Taxes | HOA | Total/mo |\n`;
  o += `|------|----------|-----|-------|-----|----------|\n`;
  [0, 3.5, 5, 10, 20].forEach((pct) => {
    const m = calculateMortgage(price, rate, pct, taxInfo.monthlyTax, hoaDisplay);
    o += `| ${pct}% | $${m.downPayment.toLocaleString()} | $${m.monthlyPI.toLocaleString()} | $${m.taxes.toLocaleString()} | ${m.hoa > 0 ? '$' + m.hoa.toLocaleString() : '—'} | $${m.total.toLocaleString()} |\n`;
  });
  return o;
}

function buildCMATable(price, sqft) {
  const pricePerSqft = Math.round(price / sqft);
  const compLow = Math.round(price * 0.92);
  const compHigh = Math.round(price * 1.08);
  const compMedian = Math.round((compLow + compHigh) / 2);

  let o = `\n━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n`;
  o += `📊 **CMA & Realty AI Trigger**\n\n`;
  o += `| Metric | Value |\n`;
  o += `|--------|-------|\n`;
  o += `| Comp Low | $${compLow.toLocaleString()} |\n`;
  o += `| Comp High | $${compHigh.toLocaleString()} |\n`;
  o += `| Avg $/sqft | $${pricePerSqft} |\n`;
  o += `| Asking Price | $${price.toLocaleString()} |\n`;
  o += `| AI Trigger | $${compMedian.toLocaleString()} |\n`;
  return o;
}

function buildConfidentTrigger(price, sqft) {
  const pricePerSqft = Math.round(price / sqft);
  let o = `\n📈 **Realty AI Trigger Analysis**\n\n`;
  o += `| $/sqft | Price | Buyers | Confidence |\n`;
  o += `|--------|-------|--------|------------|\n`;
  [pricePerSqft - 40, pricePerSqft - 20, pricePerSqft, pricePerSqft + 20, pricePerSqft + 40].forEach((ppsf) => {
    const tp = ppsf * sqft;
    const pool = ppsf < pricePerSqft - 10 ? "Many" : ppsf < pricePerSqft + 10 ? "Moderate" : ppsf < pricePerSqft + 30 ? "Few" : "Almost None";
    const conf = ppsf < pricePerSqft - 10 ? "🟢 High" : ppsf < pricePerSqft + 10 ? "🟡 Medium" : ppsf < pricePerSqft + 30 ? "🟠 Low" : "🔴 Very Low";
    o += `| $${ppsf} | $${tp.toLocaleString()} | ${pool} | ${conf} |\n`;
  });
  return o;
}

// *** SIDEBAR CHANGE: Schedule a Tour moved here from buildCallToAction ***
function buildAreaLinks(address, encodedAddr) {
  let o = `\n━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n`;
  o += `📍 **Explore the Area** — ${address}\n\n`;
  o += `<div style="display:flex;flex-wrap:wrap;gap:8px;margin:8px 0 12px 0;">`;
  [
    { emoji: "🍽️", label: "Restaurants", type: "restaurant" },
    { emoji: "🏫", label: "Schools", type: "school" },
    { emoji: "🏥", label: "Hospitals", type: "hospital" },
    { emoji: "💪", label: "Gyms & Fitness", type: "gym" },
    { emoji: "🌳", label: "Parks", type: "park" },
    { emoji: "🏛️", label: "County Assessor", type: "assessor" },
    { emoji: "🗺️", label: "Map", type: "map" },
  ].forEach(item => {
    o += `<a href="#amenity-${item.type}-${encodedAddr}" style="display:inline-flex;align-items:center;gap:4px;padding:6px 12px;border-radius:8px;border:1px solid #E5E7EB;background:#FAFAFA;color:#444;font-size:12px;font-weight:500;text-decoration:none;white-space:nowrap;">${item.emoji} ${item.label}</a>`;
  });
  o += `<a href="#cma-report-${encodedAddr}" style="display:inline-flex;align-items:center;gap:4px;padding:6px 12px;border-radius:8px;border:1px solid #E5E7EB;background:#FAFAFA;color:#444;font-size:12px;font-weight:500;text-decoration:none;white-space:nowrap;">📊 CMA Report</a>`;
  o += `<a href="#schedule-tour" style="display:inline-flex;align-items:center;gap:4px;padding:6px 12px;border-radius:8px;border:1px solid #E5E7EB;background:#FAFAFA;color:#444;font-size:12px;font-weight:500;text-decoration:none;white-space:nowrap;">📅 Schedule a Tour</a>`;
  o += `<a href="#offer-agent-${encodedAddr}" style="display:inline-flex;align-items:center;gap:4px;padding:6px 12px;border-radius:8px;border:1px solid #E5E7EB;background:#FAFAFA;color:#444;font-size:12px;font-weight:500;text-decoration:none;white-space:nowrap;">📝 Submit an Offer</a>`;
  o += `</div>`;
  return o;
}

// *** SIDEBAR CHANGE: Agent links removed — they now live in the sidebar ***
// buildCallToAction is no longer called from buildPropertyResponse
// The agents are accessible via sidebar buttons, and Schedule a Tour is in buildAreaLinks

function extractPrice(text) {
  const matches = text.match(/\$([0-9,]+(?:,\d{3})*)/g);
  if (matches) {
    const prices = matches.map(m => parseInt(m.replace(/[$,]/g, ""))).filter(p => p > 50000);
   if (prices.length > 0) return prices[0];
  }
  return null;
}

function extractSqft(text) {
  const match = text.match(/([\d,]+)\s*(?:sq\s*ft|sqft|square\s*feet)/i);
  if (match) return parseInt(match[1].replace(/,/g, ""));
  return null;
}

function extractAddress(title) {
  const match = title.match(/[-–]\s*(.+)/);
  return match ? match[1].trim() : title;
}

// ─── MAIN APP ─────────────────────────────────────────────────────────
export default function RealtyAI() {
  const [user, setUser] = useState(() => {
    try {
      const saved = localStorage.getItem('realtyai_user');
      return saved ? JSON.parse(saved) : null;
    } catch { return null; }
  });
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [listening, setListening] = useState(false);
  const [attachments, setAttachments] = useState([]);
  // *** VOICE MODE ***
  const [voiceMode, setVoiceMode] = useState(false);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const speechSynthRef = useRef(window.speechSynthesis);
  const voiceModeRef = useRef(false); // ref to avoid stale closure in callbacks
  const [showMortgageAgent, setShowMortgageAgent] = useState(false);
  const [showOfferAgent, setShowOfferAgent] = useState(false);
  // *** OFFER AGENT: address handed over from a property's "Submit an Offer" button ***
  const [offerAddress, setOfferAddress] = useState("");

  // Split "510 N Alpine DR, Beverly Hills, CA 90210" into the fields the Offer Agent expects,
  // and include the listing's price when the address came from a Match-First card.
  const buildOfferContext = (address) => {
    const ctx = { propertyAddress: address, propertyCity: "", propertyState: "", propertyZip: "", listingPrice: "", apn: "" };
    const m = address.match(/^(.*?),\s*([^,]+),\s*([A-Za-z]{2})\s*(\d{5})?/);
    if (m) {
      ctx.propertyAddress = m[1].trim();
      ctx.propertyCity = m[2].trim();
      ctx.propertyState = m[3].toUpperCase();
      ctx.propertyZip = m[4] || "";
    }
    const cached = matchListingCache[address.toLowerCase().trim()];
    if (cached && cached.price) ctx.listingPrice = String(cached.price);
    return ctx;
  };
  const [showListingAgent, setShowListingAgent] = useState(false);
  const [showTourAgent, setShowTourAgent] = useState(false);
  const [userPlan, setUserPlan] = useState("free");
  const [searchCount, setSearchCount] = useState(0);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [upgradeBillingCycle, setUpgradeBillingCycle] = useState("monthly");
  // *** SIDEBAR: New state ***
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showAccountDropdown, setShowAccountDropdown] = useState(false);
  // *** All user data loaded from Supabase on login — defaults are clean ***
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [showAccountSettings, setShowAccountSettings] = useState(false);
  const [showSearchHistory, setShowSearchHistory] = useState(false);
  const [searchHistory, setSearchHistory] = useState([]);
  // *** AMENITY PANELS ***
  const [showAmenityPanel, setShowAmenityPanel] = useState(false);
  const [amenityType, setAmenityType] = useState(""); // restaurant, school, hospital, gym, park, map, assessor
  const [amenityAddress, setAmenityAddress] = useState("");
  const [amenityResults, setAmenityResults] = useState([]);
  const [amenityLoading, setAmenityLoading] = useState(false);
  const [amenityCenter, setAmenityCenter] = useState(null);
  // *** COUNTY ASSESSOR: parcel characteristics from the county's public records ***
  const [assessorData, setAssessorData] = useState(null);
  const [assessorLoading, setAssessorLoading] = useState(false);
  const [editName, setEditName] = useState("");
  const [editPhone, setEditPhone] = useState("");
  const [editLocation, setEditLocation] = useState("");
  // *** CMA REPORT PANEL ***
  const [showCMAPanel, setShowCMAPanel] = useState(false);
  const [showLiveStream, setShowLiveStream] = useState(false);
  const [loftyLeadId, setLoftyLeadId] = useState(null);
  const [cmaAddress, setCmaAddress] = useState("");
  const [cmaLoading, setCmaLoading] = useState(false);
  const [cmaReport, setCmaReport] = useState("");
  // *** MATCH-FIRST LISTINGS: property panel ***
  const [showPropertyPanel, setShowPropertyPanel] = useState(false);
  const [propertyPanelAddress, setPropertyPanelAddress] = useState("");
  const [propertyPanelContent, setPropertyPanelContent] = useState("");
  const [propertyPanelLoading, setPropertyPanelLoading] = useState(false);
  // *** MARKETPLACE ***
  const [showMarketplace, setShowMarketplace] = useState(false);
  const [marketplaceView, setMarketplaceView] = useState("feed"); // feed | post | detail
  const [marketplaceListings, setMarketplaceListings] = useState([]);
  const [marketplaceLoading, setMarketplaceLoading] = useState(false);
  const [selectedListing, setSelectedListing] = useState(null);
  const [listingMessages, setListingMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [offerAmount, setOfferAmount] = useState("");
  const [showOfferInput, setShowOfferInput] = useState(false);
  const [postForm, setPostForm] = useState({
    address: "", city: "", state: "NV", zip: "", description: "",
    price: "", beds: "", baths: "", sqft: "", lot_sqft: "",
    year_built: "", property_type: "Single Family", photos: [],
    listing_type: "sell", // sell | rent
  });
  const [postPhotos, setPostPhotos] = useState([]);
  const [postUploading, setPostUploading] = useState(false);
  const [marketplaceFilter, setMarketplaceFilter] = useState("all");
  const [marketplaceCategory, setMarketplaceCategory] = useState("buy"); // sell | buy | rent
  const [lightboxPhoto, setLightboxPhoto] = useState(null);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [postVideos, setPostVideos] = useState([]);
  const [mpSearchCity, setMpSearchCity] = useState("");
  const [mpSearchMinPrice, setMpSearchMinPrice] = useState("");
  const [mpSearchMaxPrice, setMpSearchMaxPrice] = useState("");
  const [mpSearchBeds, setMpSearchBeds] = useState("");
  const [idxImportCities, setIdxImportCities] = useState("");
  const [mpPage, setMpPage] = useState(1);
  const [mpTotalCount, setMpTotalCount] = useState(0);
  const MP_PER_PAGE = 60;
  // *** Counters — all from Supabase ***
  const [listingCount, setListingCount] = useState(0);
  const [offerCount, setOfferCount] = useState(0);
  const [approvalCount, setApprovalCount] = useState(0);

  const chatRef = useRef(null);
  const fileRef = useRef(null);
  const recognitionRef = useRef(null);
  const offerIframeRef = useRef(null);
  const listingIframeRef = useRef(null);
  const tourIframeRef = useRef(null);
  const liveVideoRef = useRef(null);
  const liveHlsRef = useRef(null);
  const [liveStreamStatus, setLiveStreamStatus] = useState('offline');
  // *** LIVE STREAM TOS: acceptance tracking ***
  const [liveStreamTosAccepted, setLiveStreamTosAccepted] = useState(null); // null = not checked yet, true/false = checked
  const [liveStreamTosChecked, setLiveStreamTosChecked] = useState(false); // checkbox state
  // *** SIDEBAR: Dropdown ref for click-outside ***
  const dropdownRef = useRef(null);
  // *** AMENITY PANELS: Request ref for click handler closure ***
  const amenityRequestRef = useRef(null);

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTo({ top: chatRef.current.scrollHeight, behavior: "smooth" });
    }
  }, [messages, loading]);

  // *** SIDEBAR: Close dropdown on click outside ***
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowAccountDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Fetch plan + all user data on load
  useEffect(() => {
    if (!user) return;
    (async () => {
      try {
        const { data } = await supabaseRequest(`/users?email=eq.${encodeURIComponent(user.email)}&select=plan,search_count,search_reset_date,profile_photo_url,listing_count,offer_count,approval_count,search_history`, { method: "GET" });
        if (data && data.length > 0) {
          setUserPlan(data[0].plan || "free");
          // Load profile photo
          if (data[0].profile_photo_url) {
            setProfilePhoto(data[0].profile_photo_url);
          } else {
            setProfilePhoto(null);
          }
          // Load counts from Supabase
          setListingCount(data[0].listing_count || 0);
          setOfferCount(data[0].offer_count || 0);
          setApprovalCount(data[0].approval_count || 0);
          // Load search history from Supabase
          if (data[0].search_history) {
            try { setSearchHistory(JSON.parse(data[0].search_history)); } catch { setSearchHistory([]); }
          } else {
            setSearchHistory([]);
          }
          // Monthly search count reset
          const resetDate = new Date(data[0].search_reset_date || Date.now());
          const now = new Date();
          if (now.getMonth() !== resetDate.getMonth() || now.getFullYear() !== resetDate.getFullYear()) {
            setSearchCount(0);
            await supabaseRequest(`/users?email=eq.${encodeURIComponent(user.email)}`, {
              method: "PATCH", body: JSON.stringify({ search_count: 0, search_reset_date: now.toISOString() }),
            });
          } else {
            setSearchCount(data[0].search_count || 0);
          }
        }
      } catch (e) { console.error("Plan fetch error:", e); }
      const params = new URLSearchParams(window.location.search);
      if (params.get("upgraded") === "true") {
        setUserPlan("plus");
        window.history.replaceState({}, "", window.location.pathname);
      }
    })();
  }, [user]);

  // Welcome message
  useEffect(() => {
    if (user && messages.length === 0) {
      setMessages([{
        role: "assistant",
        type: "rich",
        content: `👋 **Welcome to Realty AI, ${user.name || "there"}!**\n\nI'm your AI-powered real estate assistant. I can help you:\n\n🏠 **Residential** — Search homes on Zillow, Realtor.com, Redfin & Homes.com\n🏢 **Commercial** — Find spaces on LoopNet, Crexi & BizBuySell\n🏗️ **New Construction** — Browse brand new homes\n\nJust tell me what you're looking for! For example:\n• *"3 bedroom homes in San Diego under $800K"*\n• *"Restaurant space for lease in Miami"*\n• *"New construction homes in Austin, TX"*`,
      }]);
    }
  }, [user]);

  // Intercept agent link clicks
  useEffect(() => {
    const handleClick = (e) => {
      const link = e.target.closest('a');
      if (!link) return;
      const href = link.getAttribute('href');
      if (!href) return;

      if (href === '#mortgage-agent') {
        e.preventDefault();
        if (userPlan === 'free') { setShowUpgradeModal(true); return; }
        setShowMortgageAgent(true);
      }
      if (href === '#offer-agent') {
        e.preventDefault();
        if (userPlan === 'free') { setShowUpgradeModal(true); return; }
        setOfferAddress("");
        setShowOfferAgent(true);
      }
      // *** OFFER AGENT: property-specific link carries the address ***
      if (href.startsWith('#offer-agent-')) {
        e.preventDefault();
        if (userPlan === 'free') { setShowUpgradeModal(true); return; }
        setOfferAddress(decodeURIComponent(href.substring(13))); // remove '#offer-agent-'
        setShowOfferAgent(true);
      }
      if (href === '#listing-agent') {
        e.preventDefault();
        if (userPlan === 'free') { setShowUpgradeModal(true); return; }
        setShowListingAgent(true);
      }
      if (href === '#schedule-tour') {
        e.preventDefault();
        setShowTourAgent(true);
      }
      // *** CMA REPORT: Intercept CMA hash links ***
      if (href.startsWith('#cma-report-')) {
        e.preventDefault();
        const encodedAddress = href.substring(12); // remove '#cma-report-'
        const address = decodeURIComponent(encodedAddress);
        setCmaAddress(address);
        setShowCMAPanel(true);
        setCmaReport("");
        setCmaLoading(true);
        // Auto-generate the report
        generateCMAReport(address);
      }
      // *** MATCH-FIRST LISTINGS: card click → property panel ***
      if (href.startsWith('#listing-')) {
        e.preventDefault();
        const address = decodeURIComponent(href.substring(9)); // remove '#listing-'
        openPropertyPanel(address);
      }
      // *** AMENITY PANELS: Intercept amenity hash links ***
      if (href.startsWith('#amenity-')) {
        e.preventDefault();
        const parts = href.substring(9); // remove '#amenity-'
        const dashIdx = parts.indexOf('-');
        if (dashIdx > 0) {
          const type = parts.substring(0, dashIdx);
          const encodedAddress = parts.substring(dashIdx + 1);
          const address = decodeURIComponent(encodedAddress);
          // Set state directly (avoids stale closure)
          setAmenityType(type);
          setAmenityAddress(address);
          setShowAmenityPanel(true);
          setAmenityResults([]);
          setAmenityCenter(null);
          setAmenityLoading(true);
          // Store in ref so the fetch effect can pick it up
          amenityRequestRef.current = { type, address };
        }
      }
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [userPlan]);

  // Listen for close messages and completion events from agent iframes
  useEffect(() => {
    const handleMessage = (e) => {
      if (e.data === 'closeMortgageAgent') {
        setShowMortgageAgent(false);
      }
      if (e.data?.type === 'NAVIGATE' && e.data.to === 'dashboard') {
        setShowOfferAgent(false);
        setShowListingAgent(false);
        setShowTourAgent(false);
      }
      // *** LOFTY CRM FLOW 3: Offer submitted ***
      if (e.data?.type === 'OFFER_SUBMITTED' && user && loftyLeadId) {
        loftyCRM('log_offer', {
          leadId: loftyLeadId,
          propertyAddress: e.data.propertyAddress || '',
          offerPrice: e.data.offerPrice || '',
          buyerName: e.data.buyerName || user.name || '',
          notes: e.data.notes || '',
        });
      }
      // *** LOFTY CRM FLOW 3b: Mortgage application submitted ***
      if (e.data?.type === 'MORTGAGE_SUBMITTED' && user && loftyLeadId) {
        loftyCRM('log_mortgage', {
          leadId: loftyLeadId,
          applicantName: e.data.applicantName || user.name || '',
          propertyType: e.data.propertyType || '',
          loanAmount: e.data.loanAmount || '',
        });
      }
      // *** LOFTY CRM FLOW 4: Tour scheduled ***
      if (e.data?.type === 'TOUR_SCHEDULED' && user && loftyLeadId) {
        loftyCRM('log_tour', {
          leadId: loftyLeadId,
          propertyAddress: e.data.propertyAddress || '',
          tourDate: e.data.tourDate || '',
          tourTime: e.data.tourTime || '',
        });
      }
      // *** LOFTY CRM: Listing submitted ***
      if (e.data?.type === 'LISTING_SUBMITTED' && user && loftyLeadId) {
        loftyCRM('log_offer', {
          leadId: loftyLeadId,
          propertyAddress: e.data.propertyAddress || '',
          offerPrice: e.data.listPrice || '',
          buyerName: e.data.sellerName || user.name || '',
          notes: 'Listing submitted via Realty AI Listing Agent. Type: ' + (e.data.propertyType || 'N/A'),
        });
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [user, loftyLeadId]);

  const handleSend = async () => {
    const text = input.trim();
    if (!text && attachments.length === 0) return;

    const lowerText = text.toLowerCase();
    const isNonRealEstate = lowerText.match(/^(write me a poem|tell me a joke|what is the meaning of life|who is the president|write code|help me with math|translate|recipe|cook|weather forecast|stock market|crypto|bitcoin|sports score|movie review|book summary|play a game)/);
    const isGreeting = lowerText.match(/^(hi|hello|hey|good morning|good afternoon|good evening|what can you do|help|how are you)/);

    if (userPlan === "free" && !isGreeting && !isNonRealEstate && searchCount >= 50) {
      setMessages((prev) => [...prev,
        { role: "user", content: text },
        { role: "assistant", type: "rich", content: "🔒 **You've reached your 50 free searches this month.**\n\nUpgrade to **Realty AI Plus** for unlimited searches plus full access to the Mortgage Agent, Offer Agent, and Listing Agent.\n\n💰 Starting at just **$25/month** (billed annually)." }
      ]);
      setInput("");
      setShowUpgradeModal(true);
      return;
    }
    const hasAddress = lowerText.match(/\d+\s+\w+\s+(st|street|ave|avenue|blvd|boulevard|dr|drive|ln|lane|rd|road|ct|court|way|pl|place|cir|circle|pkwy|parkway)|(\d{5})|([a-z]+,?\s*(ca|ny|tx|fl|az|nv|wa|or|co|il|ga|nc|sc|va|md|pa|nj|oh|mi|ma|ct|mn|wi|mo|tn|in|al|la|ky|ok|ut|ia|ar|ms|ks|ne|nm|id|hi|me|nh|ri|mt|de|sd|nd|ak|vt|wy|wv|dc))\b/i);

    const userMsg = {
      role: "user", content: text,
      attachments: attachments.length > 0 ? [...attachments] : undefined,
    };
    setMessages((prev) => [...prev, userMsg]);
    setInput("");
    setAttachments([]);
    setLoading(true);

    if (isNonRealEstate && !hasAddress) {
      const rejectMsg = "I'm specialized in real estate searches only. Please ask me about residential homes, commercial properties, new constructions, or give me a property address and I'll look it up for you!";
      setTimeout(() => {
        setMessages((prev) => [...prev, {
          role: "assistant", type: "rich",
          content: rejectMsg + " 🏠",
        }]);
        if (voiceModeRef.current) speakText(rejectMsg);
        setLoading(false);
      }, 600);
      return;
    }

    if (isGreeting && !hasAddress) {
      const greetMsg = "Hello! I'm Realty AI, your real estate search assistant. I can search for residential, commercial, or new construction properties across major platforms. Just tell me what you're looking for, include details like location, price range, bedrooms, or property type!";
      setTimeout(() => {
        setMessages((prev) => [...prev, {
          role: "assistant", type: "rich",
          content: `Hello! 👋 I'm **Realty AI**, your real estate search assistant.\n\nI can search for **residential**, **commercial**, or **new construction** properties across major platforms. Just tell me what you're looking for — include details like location, price range, bedrooms, or property type!\n\n*Example: "Find me 3 bed homes in San Diego under $700K"*\n*Example: "123 Main St, Los Angeles, CA"*`,
        }]);
        if (voiceModeRef.current) speakText(greetMsg);
        setLoading(false);
      }, 600);
      return;
    }

    let searchQuery = text;
    const isCommercial = lowerText.match(/commercial|lease|restaurant|office|retail|business for sale/);
    const isNewConst = lowerText.match(/new home|new construction/);
    const isAddress = isSpecificAddress(text);

    if (isCommercial) {
      searchQuery += " site:loopnet.com OR site:crexi.com OR site:bizbuysell.com";
    } else if (isNewConst) {
      searchQuery += " new construction homes";
    } else if (isAddress) {
      searchQuery = `"${text}" zillow OR realtor.com OR redfin`;
    } else {
      searchQuery += " site:zillow.com OR site:realtor.com OR site:redfin.com OR site:homes.com";
    }

    try {
      // *** MATCH-FIRST LISTINGS: residential searches hit the IDX/marketplace table first;
      // Firecrawl web search below is the fallback when nothing matches ***
      let response = null;
      let resultCount = 0;
      if (!isCommercial && !isNewConst && !isAddress) {
        const match = await fetchMatchListings(text);
        if (match && match.listings.length > 0) {
          response = buildMatchResponse(text, match);
          resultCount = match.listings.length;
        }
      }
      if (!response) {
      const searchPromises = [
        firecrawlSearch(searchQuery, isAddress ? {
          limit: 3,
          scrapeOptions: { formats: ["markdown", "links"], onlyMainContent: true }
        } : { limit: 10 }),
        fetchMortgageRate(),
      ];
      // For address searches, also search YouTube for property tour videos
      if (isAddress) {
        searchPromises.push(
          firecrawlSearch(`${text} property tour`, { limit: 2 })
            .then(r => {
              const ytUrls = [];
              (r.results || []).forEach(res => {
                if (res.url && res.url.includes('youtube.com/watch')) ytUrls.push({ url: res.url, title: res.title || '' });
              });
              return ytUrls;
            })
            .catch(() => [])
        );
      }
      const settled = await Promise.all(searchPromises);
      const results = settled[0];
      const mortgageRate = settled[1];
      const youtubeVideos = isAddress ? (settled[2] || []) : [];
      // Merge any YouTube videos found in the main search results
      const allVideos = [...(results.videos || []).map(u => ({ url: u, title: '' })), ...youtubeVideos];
      // Dedupe by URL
      const seenVids = new Set();
      const uniqueVideos = allVideos.filter(v => { if (seenVids.has(v.url)) return false; seenVids.add(v.url); return true; });

      // Log Firecrawl response for debugging
      if (results.error) {
        console.error("Firecrawl returned error:", results.error);
      }
      console.log("Firecrawl results count:", (results.results || []).length);

      response = buildPropertyResponse(text, results, mortgageRate, isAddress, uniqueVideos);
      resultCount = (results.results || []).length;
      } // end Firecrawl fallback

      // *** Track search in history — save to Supabase ***
      const queryType = isCommercial ? "Commercial" : isNewConst ? "New Construction" : "Residential";
      const newEntry = { query: text, type: queryType, time: new Date().toISOString(), resultCount: resultCount };
      setSearchHistory((prev) => {
        const updated = [newEntry, ...prev].slice(0, 100);
        // Save to Supabase
        supabaseRequest(`/users?email=eq.${encodeURIComponent(user.email)}`, {
          method: "PATCH", body: JSON.stringify({ search_history: JSON.stringify(updated) }),
        }).catch(() => {});
        return updated;
      });
      // *** LOFTY CRM FLOW 2: Log search activity ***
      if (loftyLeadId) {
        loftyCRM('log_search', {
          leadId: loftyLeadId,
          query: text,
          resultCount: resultCount,
          searchType: queryType,
        });
      }

      const words = response.split(" ");
      let streamed = "";

      setMessages((prev) => [...prev, { role: "assistant", type: "rich", content: "", streaming: true }]);

      for (let i = 0; i < words.length; i += 4) {
        streamed += words.slice(i, i + 4).join(" ") + " ";
        const current = streamed;
        await new Promise((r) => setTimeout(r, 20));
        setMessages((prev) => {
          const updated = [...prev];
          updated[updated.length - 1] = { role: "assistant", type: "rich", content: current, streaming: i + 4 < words.length };
          return updated;
        });
      }
      // *** VOICE MODE: Speak the response aloud ***
      if (voiceModeRef.current) {
        speakText(response);
      }
    } catch (e) {
      setMessages((prev) => [...prev, {
        role: "assistant", type: "rich",
        content: "I encountered an issue searching for properties. Please try again with more specific criteria like location, price range, or property type.",
      }]);
    }
    if (userPlan === "free") {
      const newCount = searchCount + 1;
      setSearchCount(newCount);
      try {
        await supabaseRequest(`/users?email=eq.${encodeURIComponent(user.email)}`, {
          method: "PATCH", body: JSON.stringify({ search_count: newCount }),
        });
      } catch (e) { console.error("Search count update error:", e); }
    } else {
      const newCount = searchCount + 1;
      setSearchCount(newCount);
      try {
        await supabaseRequest(`/users?email=eq.${encodeURIComponent(user.email)}`, {
          method: "PATCH", body: JSON.stringify({ search_count: newCount }),
        });
      } catch (e) { console.error("Search count update error:", e); }
    }
    setLoading(false);
  };

  const toggleVoice = () => {
    if (!("webkitSpeechRecognition" in window) && !("SpeechRecognition" in window)) {
      alert("Voice search is not supported in this browser.");
      return;
    }
    if (listening) {
      recognitionRef.current?.stop();
      setListening(false);
      return;
    }
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new SR();
    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.lang = "en-US";
    recognition.onresult = (e) => {
      const transcript = e.results[0][0].transcript;
      setInput((prev) => prev + " " + transcript);
      setListening(false);
    };
    recognition.onerror = () => setListening(false);
    recognition.onend = () => setListening(false);
    recognitionRef.current = recognition;
    recognition.start();
    setListening(true);
  };

  const handleFiles = (e) => {
    const files = Array.from(e.target.files);
    setAttachments((prev) => [...prev, ...files.map((f) => ({ name: f.name, size: f.size, type: f.type }))]);
  };

  // *** SIDEBAR: Handle profile photo upload — saves to Supabase ***
  const handleProfilePhoto = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Resize image before storing (keep under 500KB for Supabase text field)
      const reader = new FileReader();
      reader.onload = (ev) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const maxSize = 200; // 200x200 max
          let w = img.width, h = img.height;
          if (w > h) { h = Math.round(h * maxSize / w); w = maxSize; }
          else { w = Math.round(w * maxSize / h); h = maxSize; }
          canvas.width = w;
          canvas.height = h;
          canvas.getContext('2d').drawImage(img, 0, 0, w, h);
          const photoData = canvas.toDataURL('image/jpeg', 0.8);
          setProfilePhoto(photoData);
          // saved to Supabase above
          // Save to Supabase
          if (user?.email) {
            supabaseRequest(`/users?email=eq.${encodeURIComponent(user.email)}`, {
              method: "PATCH",
              body: JSON.stringify({ profile_photo_url: photoData }),
            }).catch((err) => console.error("Photo save error:", err));
          }
        };
        img.src = ev.target.result;
      };
      reader.readAsDataURL(file);
    }
  };

  // *** MARKETPLACE: Fetch all listings ***
  const fetchMarketplaceListings = async (page) => {
    setMarketplaceLoading(true);
    const pg = page || mpPage;
    try {
      let filters = "";
      if (marketplaceFilter !== "all") filters += `&status=eq.${marketplaceFilter}`;
      if (mpSearchCity) filters += `&city=ilike.*${encodeURIComponent(mpSearchCity)}*`;
      if (mpSearchMinPrice) filters += `&price=gte.${mpSearchMinPrice}`;
      if (mpSearchMaxPrice) filters += `&price=lte.${mpSearchMaxPrice}`;
      if (mpSearchBeds) filters += `&beds=gte.${mpSearchBeds}`;
      const offset = (pg - 1) * MP_PER_PAGE;
      const res = await supabaseRequest(`/marketplace_listings?order=created_at.desc${filters}&select=*&limit=${MP_PER_PAGE}&offset=${offset}`, { method: "GET", headers: { 'Prefer': 'count=exact' } });
      if (res.data) setMarketplaceListings(res.data);
      if (res.count !== undefined) setMpTotalCount(res.count);
      else if (res.headers && res.headers.get) {
        const range = res.headers.get('content-range');
        if (range) { const total = range.split('/')[1]; if (total && total !== '*') setMpTotalCount(parseInt(total)); }
      }
    } catch (err) {
      console.error("[Marketplace] Fetch error:", err);
    }
    setMarketplaceLoading(false);
  };

  // *** MARKETPLACE: Fetch messages for a listing ***
  const fetchListingMessages = async (listingId) => {
    try {
      const res = await supabaseRequest(`/marketplace_messages?listing_id=eq.${listingId}&order=created_at.asc&select=*`, { method: "GET" });
      if (res.data) setListingMessages(res.data);
    } catch (err) {
      console.error("[Marketplace] Messages fetch error:", err);
    }
  };

  // *** MARKETPLACE: Send a message ***
  const sendMarketplaceMessage = async (listingId, isOffer = false) => {
    if (!user) return;
    const msg = isOffer ? `💰 Offer: $${Number(offerAmount).toLocaleString()}` : newMessage.trim();
    if (!msg && !isOffer) return;
    try {
      await supabaseRequest("/marketplace_messages", {
        method: "POST",
        body: JSON.stringify({
          listing_id: listingId,
          user_email: user.email,
          user_name: user.name || user.email.split("@")[0],
          message: msg,
          offer_amount: isOffer ? Number(offerAmount) : null,
          is_offer: isOffer,
          offer_status: isOffer ? "pending" : null,
        }),
      });
      setNewMessage("");
      setOfferAmount("");
      setShowOfferInput(false);
      await fetchListingMessages(listingId);
      // Send email notification to listing owner
      if (selectedListing && user.email !== selectedListing.seller_email) {
        try {
          await fetch("https://api.emailjs.com/api/v1.0/email/send", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              service_id: "service_rh6uozl",
              template_id: "template_o678r3s",
              user_id: "xElMdZFRvZqh8-bIw",
              template_params: {
                to_email: selectedListing.seller_email,
                subject: isOffer ? `💰 New Offer on ${selectedListing.address} — $${Number(offerAmount).toLocaleString()}` : `💬 New Message on ${selectedListing.address}`,
                message: isOffer ? `${user.name || user.email} made an offer of $${Number(offerAmount).toLocaleString()} on your listing at ${selectedListing.address}. Log in to Realty AI to respond.` : `${user.name || user.email} sent a message on your listing at ${selectedListing.address}: "${msg}"`,
              },
            }),
          });
        } catch (emailErr) { console.log("[Marketplace] Email notification error:", emailErr); }
      }
    } catch (err) {
      console.error("[Marketplace] Send message error:", err);
    }
  };

  // *** MARKETPLACE: Accept/Reject offer ***
  const handleOfferResponse = async (messageId, status, listing) => {
    try {
      await supabaseRequest(`/marketplace_messages?id=eq.${messageId}`, {
        method: "PATCH",
        body: JSON.stringify({ offer_status: status }),
      });
      if (status === "accepted") {
        await supabaseRequest(`/marketplace_listings?id=eq.${listing.id}`, {
          method: "PATCH",
          body: JSON.stringify({ status: "pending" }),
        });
        if (window.emailjs) {
          window.emailjs.send("service_rh6uozl", "template_o678r3s", {
            to_email: "gdifaziorealtor@gmail.com",
            subject: `🏠 Offer Accepted — ${listing.address}`,
            message: `An offer was accepted on ${listing.address}. The buyer will be prompted to submit a formal offer through the Offer Agent.`,
          }, "xElMdZFRvZqh8-bIw").catch(e => console.log("Email error:", e));
        }
      }
      await fetchListingMessages(listing.id);
      await fetchMarketplaceListings();
    } catch (err) {
      console.error("[Marketplace] Offer response error:", err);
    }
  };

  // *** MARKETPLACE: Upload photos/videos to Supabase Storage ***
  const uploadMarketplacePhotos = async (files) => {
    setPostUploading(true);
    const uploadedPhotoUrls = [];
    const uploadedVideoUrls = [];
    for (const file of files) {
      const ext = file.name.split(".").pop().toLowerCase();
      const isVideo = ['mp4', 'mov', 'webm', 'avi', 'mkv'].includes(ext);
      const fileName = `${Date.now()}-${Math.random().toString(36).slice(2)}.${ext}`;
      try {
        const res = await fetch(`${SUPABASE_URL}/storage/v1/object/marketplace-photos/${fileName}`, {
          method: "POST",
          headers: {
            apikey: SUPABASE_ANON_KEY,
            Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
            "Content-Type": file.type,
          },
          body: file,
        });
        if (res.ok) {
          const url = `${SUPABASE_URL}/storage/v1/object/public/marketplace-photos/${fileName}`;
          if (isVideo) uploadedVideoUrls.push(url);
          else uploadedPhotoUrls.push(url);
        }
      } catch (err) {
        console.error("[Marketplace] Upload error:", err);
      }
    }
    if (uploadedPhotoUrls.length) setPostPhotos(prev => [...prev, ...uploadedPhotoUrls]);
    if (uploadedVideoUrls.length) setPostVideos(prev => [...prev, ...uploadedVideoUrls]);
    setPostUploading(false);
  };

  // *** MARKETPLACE: Submit new listing ***
  const submitMarketplaceListing = async () => {
    if (!user || !postForm.address || !postForm.price) return;
    try {
      await supabaseRequest("/marketplace_listings", {
        method: "POST",
        body: JSON.stringify({
          seller_email: user.email,
          seller_name: user.name || user.email.split("@")[0],
          address: postForm.address,
          city: postForm.city,
          state: postForm.state,
          zip: postForm.zip,
          description: postForm.description,
          price: Number(postForm.price),
          beds: postForm.beds ? Number(postForm.beds) : null,
          baths: postForm.baths ? Number(postForm.baths) : null,
          sqft: postForm.sqft ? Number(postForm.sqft) : null,
          lot_sqft: postForm.lot_sqft ? Number(postForm.lot_sqft) : null,
          year_built: postForm.year_built ? Number(postForm.year_built) : null,
          property_type: postForm.property_type,
          photos: postPhotos,
          videos: postVideos,
          listing_type: postForm.listing_type,
        }),
      });
      setPostForm({
        address: "", city: "", state: "NV", zip: "", description: "",
        price: "", beds: "", baths: "", sqft: "", lot_sqft: "",
        year_built: "", property_type: "Single Family", photos: [],
        listing_type: marketplaceCategory === "rent" ? "rent" : "sell",
      });
      setPostPhotos([]);
      setPostVideos([]);
      setMarketplaceView("feed");
      await fetchMarketplaceListings();
    } catch (err) {
      console.error("[Marketplace] Submit error:", err);
      alert("Error posting listing. Please try again.");
    }
  };

  // *** MARKETPLACE: Auto-fetch on open or filter change ***
  useEffect(() => {
    if (showMarketplace) fetchMarketplaceListings();
  }, [showMarketplace, marketplaceFilter, marketplaceCategory]);

  // *** MARKETPLACE: Real-time chat polling (every 5 seconds when viewing a listing) ***
  useEffect(() => {
    if (!showMarketplace || marketplaceView !== "detail" || !selectedListing) return;
    const interval = setInterval(() => {
      fetchListingMessages(selectedListing.id);
    }, 5000);
    return () => clearInterval(interval);
  }, [showMarketplace, marketplaceView, selectedListing]);

  // *** SIDEBAR: Agent click handler (used by sidebar buttons) ***
  const handleAgentClick = (agent) => {
    setSidebarOpen(false); // close mobile sidebar
    if (agent === 'listing') {
      if (userPlan === 'free') { setShowUpgradeModal(true); return; }
      setShowListingAgent(true);
    } else if (agent === 'offer') {
      if (userPlan === 'free') { setShowUpgradeModal(true); return; }
      setShowOfferAgent(true);
    } else if (agent === 'mortgage') {
      if (userPlan === 'free') { setShowUpgradeModal(true); return; }
      setShowMortgageAgent(true);
    } else if (agent === 'live') {
      if (userPlan === 'free') { setShowUpgradeModal(true); return; }
      // Check if user has already accepted Live Stream ToS
      (async () => {
        try {
          const { data } = await supabaseRequest(
            `/user_agreements?user_email=eq.${encodeURIComponent(user.email)}&agreement_type=eq.${LIVE_STREAM_TOS_TYPE}&agreement_version=eq.${LIVE_STREAM_TOS_VERSION}&select=id`,
            { method: 'GET' }
          );
          setLiveStreamTosAccepted(Array.isArray(data) && data.length > 0);
        } catch (e) {
          console.error('[LiveStream] ToS check failed:', e);
          setLiveStreamTosAccepted(false);
        }
      })();
      setLiveStreamTosChecked(false);
      setShowLiveStream(true);
    } else if (agent === 'cma') {
      setCmaAddress("");
      setCmaReport("");
      setCmaLoading(false);
      setShowCMAPanel(true);
    } else if (agent === 'marketplace') {
      setShowMarketplace(true);
      setMarketplaceView("feed");
    } else if (agent === 'marketplace-header') {
      setShowMarketplace(true);
      setMarketplaceView("feed");
    }
  };

  // *** SIDEBAR: User initials helper ***
  const userInitials = user ? (user.name || user.email || "U").split(" ").map(w => w[0]).join("").toUpperCase().substring(0, 2) : "U";

  // *** AMENITY PANELS: Config & fetch ***
  const amenityConfig = {
    restaurant: { label: "Restaurants", emoji: "🍽️", type: "restaurant", color: "#E31837" },
    school: { label: "Schools", emoji: "🏫", type: "school", color: "#3498DB" },
    hospital: { label: "Hospitals", emoji: "🏥", type: "hospital", color: "#27AE60" },
    gym: { label: "Gyms & Fitness", emoji: "💪", type: "gym", color: "#8E44AD" },
    park: { label: "Parks", emoji: "🌳", type: "park", color: "#2ECC71" },
    map: { label: "Map", emoji: "🗺️", type: "map", color: "#E67E22" },
    assessor: { label: "County Assessor", emoji: "🏛️", type: "assessor", color: "#34495E" },
  };

  const fetchNearbyPlaces = async (address, placeType) => {
    setAmenityLoading(true);
    setAmenityResults([]);
    setAmenityCenter(null);
    try {
      const res = await fetch('/.netlify/functions/nearby-places', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ address, type: placeType }),
      });
      const data = await res.json();
      if (data.results) {
        setAmenityResults(data.results);
        setAmenityCenter(data.center);
      }
    } catch (err) {
      console.error('Amenity fetch error:', err);
    }
    setAmenityLoading(false);
  };

  // *** COUNTY ASSESSOR: pull parcel characteristics from the county's public parcel service ***
  const fetchAssessorParcel = async (address) => {
    setAssessorData(null);
    setAssessorLoading(true);
    try {
      const res = await fetch('/.netlify/functions/assessor-parcel', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ address }),
      });
      const data = await res.json();
      console.log('[Assessor]', data.found ? data.county + ' ' + data.state : 'not found: ' + (data.reason || ''));
      setAssessorData(data);
    } catch (err) {
      console.error('[Assessor] fetch failed:', err);
      setAssessorData({ found: false, reason: 'error' });
    }
    setAssessorLoading(false);
  };

  // Trigger fetch when amenity panel opens via click handler
  useEffect(() => {
    if (!showAmenityPanel || !amenityRequestRef.current) return;
    const { type, address } = amenityRequestRef.current;
    amenityRequestRef.current = null; // consume
    if (type !== 'assessor') {
      const googleType = amenityConfig[type]?.type || type;
      fetchNearbyPlaces(address, type === 'map' ? 'point_of_interest' : googleType);
    } else {
      setAmenityLoading(false);
      fetchAssessorParcel(address);
    }
  }, [showAmenityPanel]);

  // *** MATCH-FIRST LISTINGS: open a property panel — runs the same address-search
  // flow handleSend uses (scrape 3 results + mortgage rate + tour videos) ***
  const openPropertyPanel = async (address) => {
    setPropertyPanelAddress(address);
    setPropertyPanelContent("");
    setPropertyPanelLoading(true);
    setShowPropertyPanel(true);
    try {
      const cached = matchListingCache[address.toLowerCase().trim()] || null;
      const searchQuery = `"${address}" zillow OR realtor.com OR redfin`;
      // IDX card with a detail link → scrape our own listing page (full photo set, no "similar homes").
      // Otherwise fall back to the portal search used for typed-in addresses.
      const listingFetch = (cached && cached.detailUrl)
        ? fetch("/.netlify/functions/import-idx-listings", {
            method: "POST", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ detailUrl: cached.detailUrl, address }),
          }).then(r => r.ok ? r.json() : null).then(d => {
            if (!d || d.error) throw new Error((d && d.error) || "detail scrape failed");
            return {
              results: [{ url: cached.detailUrl, title: address, content: d.content || "" }],
              images: (d.photos && d.photos.length) ? d.photos : (cached.photos || []),
              videos: d.videos || [],
            };
          }).catch(e => {
            console.warn("[PropertyPanel] detail scrape failed, using portal search:", e.message);
            return firecrawlSearch(searchQuery, { limit: 3, scrapeOptions: { formats: ["markdown", "links"], onlyMainContent: true } });
          })
        : firecrawlSearch(searchQuery, { limit: 3, scrapeOptions: { formats: ["markdown", "links"], onlyMainContent: true } });
      const settled = await Promise.all([
        listingFetch,
        fetchMortgageRate(),
        // Search YouTube directly for this address — "property tour" as a web query rarely
        // surfaces video results
        Promise.all([
          firecrawlSearch(`"${address}" site:youtube.com`, { limit: 6 }).catch(() => ({ results: [] })),
          firecrawlSearch(`${address} home tour video`, { limit: 4 }).catch(() => ({ results: [] })),
        ]).then(rs => {
          const out = [];
          const seenV = new Set();
          rs.forEach(r => (r.results || []).forEach(res => {
            if (!res.url) return;
            if (!/youtube\.com\/(watch\?v=|shorts\/)|youtu\.be\//i.test(res.url)) return;
            const id = (res.url.match(/(?:watch\?v=|shorts\/|youtu\.be\/)([\w-]{6,})/) || [])[1];
            if (!id || seenV.has(id)) return;
            seenV.add(id);
            out.push({ url: res.url, title: res.title || '' });
          }));
          console.log("[PropertyPanel] youtube videos found:", out.length);
          return out.slice(0, 3);
        }).catch(() => []),
      ]);
      const results = settled[0];
      const mortgageRate = settled[1];
      const youtubeVideos = settled[2] || [];
      const allVideos = [...(results.videos || []).map(u => ({ url: u, title: '' })), ...youtubeVideos];
      const seenVids = new Set();
      const uniqueVideos = allVideos.filter(v => { if (seenVids.has(v.url)) return false; seenVids.add(v.url); return true; });
      // Feed photos: prefer the full set from the detail page, else the card's thumbnails
      const known = cached ? { ...cached, photos: (results.images && results.images.length) ? results.images : cached.photos } : null;
      setPropertyPanelContent(buildPropertyResponse(address, results, mortgageRate, true, uniqueVideos, known));
    } catch (e) {
      console.error("[PropertyPanel] error:", e);
      setPropertyPanelContent("Couldn't load details for this property. Please try again.");
    }
    setPropertyPanelLoading(false);
  };

  // *** CMA REPORT: Generate function (powered by Tavily Research mini) ***
  const generateCMAReport = async (address) => {
    setCmaLoading(true);
    setCmaReport("");
    try {
      console.log("[CMA] Starting Tavily Research mini for:", address);
      setCmaReport("Researching comparable sales, active listings, and market trends...");

      let markdown = "";
      let sources = [];

      const initialRes = await fetch("/.netlify/functions/cma-report", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ address }),
      });

      if (!initialRes.ok) {
        const errText = await initialRes.text();
        throw new Error(`CMA service error (${initialRes.status}): ${errText.slice(0, 200)}`);
      }

      const initial = await initialRes.json();

      if (initial.status === "completed") {
        markdown = initial.markdown || "";
        sources = initial.sources || [];
      } else if (initial.status === "pending" && initial.request_id) {
        const requestId = initial.request_id;
        setCmaReport("Analyzing market data... This can take up to 90 seconds.");

        const maxAttempts = 90;
        let attempt = 0;
        while (attempt < maxAttempts) {
          await new Promise((r) => setTimeout(r, 2000));
          attempt++;
          const pollRes = await fetch(
            `/.netlify/functions/cma-report?id=${encodeURIComponent(requestId)}`
          );
          if (!pollRes.ok) {
            throw new Error(`CMA poll error (${pollRes.status})`);
          }
          const pollData = await pollRes.json();
          console.log(`[CMA] poll ${attempt}/${maxAttempts} status:`, pollData.status, "tavily:", pollData.tavily_status);
          if (pollData.status === "completed") {
            markdown = pollData.markdown || "";
            sources = pollData.sources || [];
            break;
          }
          if (pollData.status === "failed" || pollData.status === "error") {
            console.error("[CMA] Tavily failure payload:", pollData);
            throw new Error(pollData.error || "Research task failed");
          }
        }
        if (!markdown) {
          throw new Error("CMA research timed out after 3 minutes. Please try again.");
        }
      } else {
        throw new Error(initial.error || "Unable to start CMA research.");
      }

      // ─── Render: Tavily's native markdown report (already includes its own Sources) ───
      let report = markdown.trim();

      report += `\n\n---\n*CMA generated by Realty AI.*\n`;

      setCmaReport(report);
    } catch (e) {
      console.error("CMA Report error:", e);
      setCmaReport("Error generating CMA report: " + e.message + "\n\nPlease try again.");
    }
    setCmaLoading(false);
  };


  // *** VOICE MODE: Core functions ***
  const stripMarkdown = (text) => {
    if (!text) return "";
    let clean = text;
    clean = clean.replace(/\{\{IMG:.*?\}\}/g, '');
    clean = clean.replace(/\{\{YOUTUBE:.*?\}\}/g, '');
    clean = clean.replace(/\{\{PHOTO_GRID_START\}\}/g, '');
    clean = clean.replace(/\{\{PHOTO_GRID_END\}\}/g, '');
    clean = clean.replace(/<[^>]+>/g, ' '); // strip HTML (listing cards, area links) so voice mode doesn't read code
    clean = clean.replace(/━+/g, '');
    clean = clean.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');
    clean = clean.replace(/\*\*(.*?)\*\*/g, '$1');
    clean = clean.replace(/\*(.*?)\*/g, '$1');
    clean = clean.replace(/#{1,4}\s*/g, '');
    clean = clean.replace(/\|[^|]+\|/g, '');
    clean = clean.replace(/[-]{3,}/g, '');
    clean = clean.replace(/[🏠🏢🏗️📸💰📊📈📍🍽️🏫🏥💪🌳🏛️🗺️📅🎯📝✅🎥👋🔒🔗✓●🟢🟡🟠🔴]/g, '');
    clean = clean.replace(/\n{2,}/g, '. ');
    clean = clean.replace(/\n/g, '. ');
    clean = clean.replace(/\.\s*\.\s*/g, '. ');
    clean = clean.replace(/\s{2,}/g, ' ');
    return clean.trim();
  };

  const speakText = useCallback((text) => {
    if (!text || !voiceModeRef.current) return;
    const synth = speechSynthRef.current;
    synth.cancel(); // stop any ongoing speech

    const clean = stripMarkdown(text);
    if (!clean || clean.length < 3) return;

    // Split into chunks (speechSynthesis has a ~200 char limit on some browsers)
    const sentences = clean.match(/[^.!?]+[.!?]+|[^.!?]+$/g) || [clean];
    const chunks = [];
    let current = "";
    for (const s of sentences) {
      if ((current + s).length > 180) {
        if (current) chunks.push(current.trim());
        current = s;
      } else {
        current += s;
      }
    }
    if (current) chunks.push(current.trim());

    setIsSpeaking(true);

    // Pick a good voice
    const voices = synth.getVoices();
    const preferred = voices.find(v => v.name.includes("Google US English")) ||
      voices.find(v => v.name.includes("Samantha")) ||
      voices.find(v => v.lang.startsWith("en") && v.localService) ||
      voices.find(v => v.lang.startsWith("en")) ||
      voices[0];

    chunks.forEach((chunk, i) => {
      const utterance = new SpeechSynthesisUtterance(chunk);
      utterance.rate = 1.05;
      utterance.pitch = 1.0;
      utterance.volume = 1.0;
      if (preferred) utterance.voice = preferred;

      if (i === chunks.length - 1) {
        utterance.onend = () => {
          setIsSpeaking(false);
          // Auto-listen after AI finishes speaking (full duplex)
          if (voiceModeRef.current) {
            setTimeout(() => {
              if (voiceModeRef.current && !loading) {
                startVoiceListening();
              }
            }, 500);
          }
        };
      }
      utterance.onerror = () => setIsSpeaking(false);
      synth.speak(utterance);
    });
  }, [loading]);

  const stopSpeaking = () => {
    speechSynthRef.current.cancel();
    setIsSpeaking(false);
  };

  const toggleVoiceMode = () => {
    const newMode = !voiceMode;
    setVoiceMode(newMode);
    voiceModeRef.current = newMode;
    if (!newMode) {
      // Turning off — stop everything
      speechSynthRef.current.cancel();
      setIsSpeaking(false);
      if (recognitionRef.current) {
        recognitionRef.current.stop();
        setListening(false);
      }
    } else {
      // Turning on — start listening immediately
      startVoiceListening();
    }
  };

  const startVoiceListening = () => {
    if (!("webkitSpeechRecognition" in window) && !("SpeechRecognition" in window)) {
      alert("Voice search is not supported in this browser.");
      return;
    }
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new SR();
    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.lang = "en-US";
    recognition.onresult = (e) => {
      const transcript = e.results[0][0].transcript;
      setInput(transcript);
      setListening(false);
      // Auto-send after voice input in voice mode
      if (voiceModeRef.current) {
        setTimeout(() => {
          document.getElementById('realtyai-send-btn')?.click();
        }, 300);
      }
    };
    recognition.onerror = () => setListening(false);
    recognition.onend = () => setListening(false);
    recognitionRef.current = recognition;
    recognition.start();
    setListening(true);
  };

  // Load voices (some browsers load them async)
  useEffect(() => {
    const loadVoices = () => speechSynthRef.current.getVoices();
    loadVoices();
    if (speechSynthRef.current.onvoiceschanged !== undefined) {
      speechSynthRef.current.onvoiceschanged = loadVoices;
    }
    // Cleanup: stop speech on unmount
    return () => speechSynthRef.current.cancel();
  }, []);

  // *** LIVE STREAM: Restream integration (IVS removed) ***
  // Opens Restream Studio session in a new tab after ToS acceptance.
  // Actual agreement acceptance is handled in the modal below.

  if (!user) return (
    <>
      <style>{globalCSS}</style>
      <RegistrationScreen onLogin={async (userData) => {
        setUser(userData);
        localStorage.setItem('realtyai_user', JSON.stringify(userData));
        try {
          const { data } = await supabaseRequest(`/users?email=eq.${encodeURIComponent(userData.email)}&select=plan,search_count,search_reset_date,profile_photo_url,listing_count,offer_count,approval_count,search_history`, { method: "GET" });
          if (data && data.length > 0) {
            setUserPlan(data[0].plan || "free");
            // Load profile photo
            setProfilePhoto(data[0].profile_photo_url || null);
            // Load all counts
            setListingCount(data[0].listing_count || 0);
            setOfferCount(data[0].offer_count || 0);
            setApprovalCount(data[0].approval_count || 0);
            // Load search history
            if (data[0].search_history) {
              try { setSearchHistory(JSON.parse(data[0].search_history)); } catch { setSearchHistory([]); }
            } else {
              setSearchHistory([]);
            }
            // Monthly search count reset
            const resetDate = new Date(data[0].search_reset_date || Date.now());
            const now = new Date();
            if (now.getMonth() !== resetDate.getMonth() || now.getFullYear() !== resetDate.getFullYear()) {
              setSearchCount(0);
              await supabaseRequest(`/users?email=eq.${encodeURIComponent(userData.email)}`, {
                method: "PATCH", body: JSON.stringify({ search_count: 0, search_reset_date: now.toISOString() }),
              });
            } else {
              setSearchCount(data[0].search_count || 0);
            }
          }
        } catch (e) { console.error("Plan fetch error:", e); }
        // *** LOFTY CRM FLOW 1: Create/sync lead on login ***
        const nameParts = (userData.name || '').split(' ');
        loftyCRM('create_lead', {
          firstName: nameParts[0] || '',
          lastName: nameParts.slice(1).join(' ') || '',
          email: userData.email,
          phone: userData.phone || '',
          source: 'Realty AI',
        }).then(res => {
          if (res && res.leadId) {
            setLoftyLeadId(res.leadId);
            console.log('[Lofty CRM] Lead ID stored:', res.leadId);
          }
        });
        // *** ZAPIER → LOFTY: Send lead directly to Lofty via Zapier webhook ***
        // This bypasses API key limitations and populates email/phone in proper Lofty fields
        try {
          const leadFirstName = (userData.name || '').split(' ')[0] || 'Lead';
          const leadLastName = (userData.name || '').split(' ').slice(1).join(' ') || '';
          const zapParams = new URLSearchParams({
            first_name: leadFirstName,
            last_name: leadLastName,
            email: userData.email,
            phone: userData.phone || '',
            source: 'Realty AI',
          }).toString();
          await fetch(`https://hooks.zapier.com/hooks/catch/23175236/ujr2sm9/?${zapParams}`, {
            method: "GET",
          });
          console.log('[Lofty] Lead sent to Zapier → Lofty');
        } catch (zapErr) {
          console.error('[Lofty] Zapier webhook failed:', zapErr);
        }

        // *** LOFTY EMAIL PARSING (backup): Send lead info to Lofty parsing email as fallback ***
        try {
          const leadFirstName2 = (userData.name || '').split(' ')[0] || 'Lead';
          const leadLastName2 = (userData.name || '').split(' ').slice(1).join(' ') || '';
          const leadPhone = userData.phone || '';
          await fetch("https://api.emailjs.com/api/v1.0/email/send", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              service_id: EMAILJS_SERVICE_ID,
              template_id: "template_c58hjxb",
              user_id: EMAILJS_PUBLIC_KEY,
              template_params: {
                to_email: "giancarlo_difazio@axenrealestate.com",
                from_name: userData.name || 'Realty AI Lead',
                first_name: leadFirstName2,
                last_name: leadLastName2,
                from_email: userData.email,
                phone: leadPhone,
                subject: `New Lead: ${userData.name} - ${userData.email}`,
                message: `First Name: ${leadFirstName2}\nLast Name: ${leadLastName2}\nEmail Address: ${userData.email}\nPhone Number: ${leadPhone}\nSource: Realty AI\nComments: New user registered on realtyaii.netlify.app`,
              },
            }),
          });
          console.log('[Lofty] Lead notification email sent to parsing address');
        } catch (emailErr) {
          console.error('[Lofty] Email parsing notification failed:', emailErr);
        }
        const params = new URLSearchParams(window.location.search);
        if (params.get("upgraded") === "true") {
          setUserPlan("plus");
          window.history.replaceState({}, "", window.location.pathname);
        }
      }} />
    </>
  );

  return (
    <>
      <style>{globalCSS}</style>
      {/* *** SIDEBAR CHANGE: Outer wrapper is now flex ROW instead of flex COLUMN *** */}
      <div style={{ height: "100vh", display: "flex", flexDirection: "row", fontFamily: theme.font, overflow: "hidden", width: "100%", maxWidth: "100vw", position: "relative" }}>

        {/* *** SIDEBAR: Mobile overlay backdrop *** */}
        {sidebarOpen && (
          <div
            className="sidebar-overlay"
            onClick={() => setSidebarOpen(false)}
            style={{
              position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
              background: "rgba(0,0,0,0.5)", zIndex: 9999,
            }}
          />
        )}

        {/* ═══ SIDEBAR ═══ */}
        <aside
          className={`sidebar-panel ${sidebarOpen ? 'open' : ''}`}
          style={{
            width: 250, height: "100vh", background: theme.sidebarBg,
            borderRight: `1px solid ${theme.sidebarBorder}`,
            display: "flex", flexDirection: "column", flexShrink: 0,
            zIndex: 10001,
          }}
        >
          {/* Brand Header */}
          <div style={{
            padding: "14px 16px", display: "flex", alignItems: "center", gap: 10,
            borderBottom: `1px solid ${theme.sidebarBorder}`,
          }}>
            <img src="/logo.png" alt="Realty AI" style={{
              width: 38, height: 38, borderRadius: 10, flexShrink: 0,
              boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
            }} />
            <div>
              <div style={{ fontWeight: 700, fontSize: 15, color: "#fff", letterSpacing: ".2px" }}>Realty AI</div>
              <div style={{ fontSize: 10.5, color: theme.sidebarTextMuted }}>AI Real Estate Assistant</div>
            </div>
          </div>

          {/* User Account Section */}
          <div style={{ padding: "14px 16px", borderBottom: `1px solid ${theme.sidebarBorder}` }}>
            {/* Photo + Name + Email */}
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
              <div style={{ position: "relative", flexShrink: 0 }}>
                {profilePhoto ? (
                  <img src={profilePhoto} alt="" style={{
                    width: 42, height: 42, borderRadius: "50%", objectFit: "cover",
                    border: "1.5px solid rgba(255,255,255,0.12)",
                  }} />
                ) : (
                  <div style={{
                    width: 42, height: 42, borderRadius: "50%", background: "rgba(255,255,255,0.1)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    color: "rgba(255,255,255,0.65)", fontWeight: 700, fontSize: 14,
                    border: "1.5px solid rgba(255,255,255,0.1)",
                  }}>{userInitials}</div>
                )}
                <label style={{
                  position: "absolute", bottom: -2, right: -2,
                  width: 18, height: 18, background: theme.red, borderRadius: "50%",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  border: "2px solid " + theme.sidebarBg, cursor: "pointer",
                }}>
                  {Icons.plusSmall}
                  <input type="file" accept="image/*" hidden onChange={handleProfilePhoto} />
                </label>
              </div>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontWeight: 600, fontSize: 13.5, color: "#fff" }}>{user.name || "User"}</div>
                <div style={{ fontSize: 11, color: theme.sidebarTextMuted, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{user.email}</div>
              </div>
            </div>
            {/* Account Actions */}
            <div style={{ display: "flex", flexDirection: "column", gap: 2, marginBottom: 10 }}>
              {[
                { icon: Icons.subscription, label: "Manage subscription", action: () => { setSidebarOpen(false); setShowUpgradeModal(true); } },
                { icon: Icons.settings, label: "Account settings", action: () => { setSidebarOpen(false); setEditName(user.name || ""); setShowAccountSettings(true); } },
              ].map((item, i) => (
                <div key={i} onClick={item.action} style={{
                  display: "flex", alignItems: "center", gap: 8, padding: "7px 8px",
                  borderRadius: 6, cursor: "pointer", fontSize: 12, color: theme.sidebarText,
                  transition: "background 0.1s",
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = "rgba(255,255,255,0.08)"}
                onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
                >{item.icon} {item.label}</div>
              ))}
              <div onClick={() => {
                localStorage.removeItem('realtyai_user');
                setProfilePhoto(null);
                setSearchHistory([]);
                setSearchCount(0);
                setListingCount(0);
                setOfferCount(0);
                setApprovalCount(0);
                setUserPlan("free");
                setEditPhone("");
                setEditLocation("");
                setUser(null); setMessages([]); setSidebarOpen(false);
              }} style={{
                display: "flex", alignItems: "center", gap: 8, padding: "7px 8px",
                borderRadius: 6, cursor: "pointer", fontSize: 12, color: "#e74c3c",
                transition: "background 0.1s",
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = "rgba(231,76,60,0.1)"}
              onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
              >{Icons.logout} Sign out</div>
            </div>
            {/* Counters with Reset */}
            <div style={{ display: "flex", gap: 6 }}>
              {[
                { label: "Searches", value: searchCount },
                { label: "Approvals", value: approvalCount },
                { label: "Listings", value: listingCount },
                { label: "Offers", value: offerCount },
              ].map((stat, i) => (
                <div key={i} onClick={() => { if (stat.label === "Searches") { setSidebarOpen(false); setShowSearchHistory(true); } }} style={{
                  flex: 1, background: theme.sidebarCardBg, border: `1px solid ${theme.sidebarCardBorder}`,
                  borderRadius: 8, padding: "7px 6px", textAlign: "center",
                  cursor: stat.label === "Searches" ? "pointer" : "default",
                  transition: "background 0.15s",
                }}
                onMouseEnter={(e) => { if (stat.label === "Searches") e.currentTarget.style.background = "rgba(255,255,255,0.1)"; }}
                onMouseLeave={(e) => e.currentTarget.style.background = theme.sidebarCardBg}
                >
                  <div style={{ fontSize: 17, fontWeight: 700, color: "#fff" }}>{stat.value}</div>
                  <div style={{ fontSize: 9, color: theme.sidebarTextMuted, letterSpacing: ".3px", marginTop: 1 }}>{stat.label}</div>
                </div>
              ))}
            </div>
            <button onClick={async () => {
              try {
                await supabaseRequest(`/users?email=eq.${encodeURIComponent(user.email)}`, {
                  method: "PATCH",
                  body: JSON.stringify({ search_count: 0, listing_count: 0, offer_count: 0, approval_count: 0 }),
                });
                setSearchCount(0); setListingCount(0); setOfferCount(0); setApprovalCount(0);
              } catch(e) { console.error("Reset error:", e); }
            }} style={{
              width: "100%", marginTop: 8, padding: "5px", background: "transparent",
              border: `1px solid ${theme.sidebarCardBorder}`, borderRadius: 6,
              fontSize: 10, color: theme.sidebarTextMuted, cursor: "pointer",
              fontFamily: theme.font, transition: "all 0.15s",
            }}
            onMouseEnter={(e) => { e.currentTarget.style.color = "#fff"; e.currentTarget.style.borderColor = "rgba(255,255,255,0.2)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.color = theme.sidebarTextMuted; e.currentTarget.style.borderColor = theme.sidebarCardBorder; }}
            >Reset Counters</button>
          </div>

          {/* Agents */}
          <div style={{ padding: "14px 16px", flex: 1 }}>
            <div style={{
              fontSize: 11, fontWeight: 700, textTransform: "uppercase",
              letterSpacing: "1.5px", color: theme.sidebarTextDim, marginBottom: 12,
            }}>Agents</div>
            {[
              { icon: Icons.agentSell, label: "Sell your property", agent: "listing" },
              { icon: Icons.agentOffer, label: "Submit an offer", agent: "offer" },
              { icon: Icons.agentApproved, label: "Get approved", agent: "mortgage" },
              { icon: Icons.agentLive, label: "Live stream", agent: "live" },
              { icon: <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path d="M3 3h18v18H3z" stroke="#E31837" strokeWidth="2"/><path d="M3 9h18M3 15h18M9 3v18M15 3v18" stroke="#E31837" strokeWidth="1.5" opacity="0.5"/></svg>, label: "CMA Report", agent: "cma" },
              { icon: Icons.agentMarketplace, label: "Marketplace", agent: "marketplace-header" },
            ].map((item, i) => (
              item.agent === "marketplace-header" ? (
                <div key={i}>
                  <div style={{
                    display: "flex", alignItems: "center", gap: 10, padding: "10px 0",
                  }}>
                    {item.icon}
                    <span style={{ fontSize: 14, fontWeight: 500, color: theme.sidebarText }}>{item.label}</span>
                  </div>
                  <div style={{ display: "flex", gap: 6, paddingLeft: 0, marginTop: -4, marginBottom: 4 }}>
                    {[
                      { label: "Sell", type: "sell" },
                      { label: "Buy", type: "buy" },
                      { label: "Rent", type: "rent" },
                    ].map(sub => (
                      <button key={sub.type} onClick={() => { handleAgentClick('marketplace'); setMarketplaceCategory(sub.type); }} style={{
                        padding: "4px 12px", borderRadius: 6, fontSize: 11, fontWeight: 600,
                        border: `1px solid ${theme.red}`, background: "transparent",
                        color: theme.red, cursor: "pointer", fontFamily: theme.font,
                        transition: "all 0.15s",
                      }}
                      onMouseEnter={(e) => { e.currentTarget.style.background = theme.red; e.currentTarget.style.color = '#fff'; }}
                      onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = theme.red; }}
                      >{sub.label}</button>
                    ))}
                  </div>
                </div>
              ) : (
              <div key={i} onClick={() => handleAgentClick(item.agent)} style={{
                display: "flex", alignItems: "center", gap: 10, padding: "10px 0",
                cursor: "pointer", transition: "opacity 0.15s",
              }}
              onMouseEnter={(e) => e.currentTarget.style.opacity = "0.7"}
              onMouseLeave={(e) => e.currentTarget.style.opacity = "1"}
              >
                {item.icon}
                <span style={{ fontSize: 14, fontWeight: 500, color: theme.sidebarText }}>{item.label}</span>
              </div>
              )
            ))}
          </div>
        </aside>

        {/* ═══ MAIN CONTENT COLUMN (header + chat + input) ═══ */}
        <div style={{ flex: 1, display: "flex", flexDirection: "column", background: theme.offWhite, minWidth: 0, overflow: "hidden", maxWidth: "100%" }}>

          {/* Header */}
          <header style={{
            display: "flex", alignItems: "center", justifyContent: "space-between",
            padding: window.innerWidth <= 768 ? "10px 12px" : "12px 24px", background: theme.white,
            borderBottom: `1px solid ${theme.greyLight}`,
            boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
            flexShrink: 0, minHeight: 56, zIndex: 100, position: "relative",
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              {/* Mobile hamburger */}
              <button className="mobile-menu-btn" onClick={() => setSidebarOpen(!sidebarOpen)} style={{
                background: "none", border: "none", cursor: "pointer", color: theme.dark,
                padding: 4, display: "flex",
              }}>{Icons.menu}</button>
              <img src="/logo.png" alt="Realty AI" style={{
                width: window.innerWidth <= 768 ? 32 : 42, height: window.innerWidth <= 768 ? 32 : 42, borderRadius: window.innerWidth <= 768 ? 8 : 12,
                boxShadow: "0 3px 10px rgba(227,24,55,0.2)",
              }} />
              <div style={{ minWidth: 0 }}>
                <h1 style={{ fontFamily: theme.fontDisplay, fontSize: window.innerWidth <= 768 ? 16 : 20, fontWeight: 700, color: theme.dark, lineHeight: 1.2, whiteSpace: "nowrap" }}>
                  Realty AI
                </h1>
                {window.innerWidth > 768 && (
                  <p style={{ fontSize: 11, color: theme.grey, fontWeight: 500 }}>AI Real Estate Assistant</p>
                )}
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
              {/* New Search button */}
              <button onClick={() => {
                setMessages([{
                  role: "assistant", type: "rich",
                  content: `👋 **Welcome to Realty AI, ${user.name || "there"}!**\n\nI'm your AI-powered real estate assistant. I can help you:\n\n🏠 **Residential** — Search homes on Zillow, Realtor.com, Redfin & Homes.com\n🏢 **Commercial** — Find spaces on LoopNet, Crexi & BizBuySell\n🏗️ **New Construction** — Browse brand new homes\n\nJust tell me what you're looking for! For example:\n• *"3 bedroom homes in San Diego under $800K"*\n• *"Restaurant space for lease in Miami"*\n• *"New construction homes in Austin, TX"*`,
                }]);
                setInput("");
                setLoading(false);
              }} style={{
                display: "flex", alignItems: "center", gap: 5,
                padding: "6px 14px", background: "transparent",
                border: `1.5px solid ${theme.greyLight}`, borderRadius: 8,
                fontSize: 12, fontWeight: 600, cursor: "pointer",
                fontFamily: theme.font, color: theme.grey,
                transition: "all 0.2s", whiteSpace: "nowrap",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = theme.red; e.currentTarget.style.color = theme.red; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = theme.greyLight; e.currentTarget.style.color = theme.grey; }}
              >
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M12 5v14m-7-7h14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>
                New Search
              </button>
              {/* Plan badge */}
              <div style={{
                fontSize: 10, fontWeight: 700,
                background: userPlan === "plus" ? "#4CAF50" : "#3B82F6",
                color: "#fff",
                padding: "3px 10px", borderRadius: 4, letterSpacing: ".4px", textTransform: "uppercase",
              }}>{userPlan === "plus" ? "PLUS" : "FREE"}</div>
            </div>
          </header>

          {/* Chat Area — UNCHANGED */}
          <div ref={chatRef} style={{
            flex: 1, overflowY: "auto", overflowX: "hidden", padding: window.innerWidth <= 768 ? "16px 8px" : "24px 20px",
            display: "flex", flexDirection: "column", gap: 16,
          }}>
            {messages.map((msg, i) => (
              <ChatMessage key={i} msg={msg} index={i} profilePhoto={profilePhoto} userInitials={userInitials} />
            ))}
            {loading && (
              <div style={{ display: "flex", gap: 12, maxWidth: window.innerWidth <= 768 ? "100%" : 820, margin: "0 auto", animation: "fadeUp 0.3s ease-out" }}>
                <div style={{
                  width: 36, height: 36, borderRadius: 12, flexShrink: 0,
                  background: theme.red, display: "flex", alignItems: "center", justifyContent: "center", color: theme.white,
                }}>{Icons.bot}</div>
                <div style={{
                  background: theme.white, padding: "14px 18px", borderRadius: 16,
                  borderTopLeftRadius: 4, boxShadow: theme.shadow,
                }}>
                  <TypingDots />
                </div>
              </div>
            )}
          </div>

          {/* Attachments Preview — UNCHANGED */}
          {attachments.length > 0 && (
            <div style={{
              padding: "8px 24px", background: theme.white, borderTop: `1px solid ${theme.greyLight}`,
              display: "flex", gap: 8, flexWrap: "wrap",
            }}>
              {attachments.map((a, i) => (
                <div key={i} style={{
                  display: "flex", alignItems: "center", gap: 6, background: "#FEF2F2",
                  padding: "6px 12px", borderRadius: 8, fontSize: 12, color: theme.dark,
                }}>
                  {Icons.file} {a.name}
                  <button onClick={() => setAttachments((p) => p.filter((_, j) => j !== i))} style={{
                    background: "none", border: "none", cursor: "pointer", color: theme.red, fontSize: 16, lineHeight: 1,
                  }}>×</button>
                </div>
              ))}
            </div>
          )}

          {/* Input Bar — UNCHANGED */}
          <div style={{
            padding: "16px 20px", background: theme.white,
            borderTop: `1px solid ${theme.greyLight}`,
            boxShadow: "0 -2px 12px rgba(0,0,0,0.03)",
          }}>
            <div style={{
              maxWidth: window.innerWidth <= 768 ? "100%" : 820, margin: "0 auto", display: "flex", gap: 10, alignItems: "center",
            }}>
              <button onClick={() => fileRef.current?.click()} style={{
                width: 42, height: 42, borderRadius: 12, border: `2px solid ${theme.greyLight}`,
                background: theme.white, cursor: "pointer", display: "flex",
                alignItems: "center", justifyContent: "center", color: theme.grey,
                flexShrink: 0, transition: "all 0.2s",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = theme.red; e.currentTarget.style.color = theme.red; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = theme.greyLight; e.currentTarget.style.color = theme.grey; }}
              >
                {Icons.plus}
              </button>
              <input ref={fileRef} type="file" multiple hidden
                accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx"
                onChange={handleFiles} />

              <div style={{ flex: 1, position: "relative" }}>
                <input
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && !e.shiftKey && handleSend()}
                  placeholder="Search properties... (e.g., 3 bed homes in San Diego)"
                  style={{
                    width: "100%", padding: "13px 52px 13px 18px",
                    border: `2px solid ${theme.greyLight}`, borderRadius: 14,
                    fontSize: 15, fontFamily: theme.font, outline: "none",
                    transition: "border-color 0.2s", background: theme.offWhite,
                  }}
                  onFocus={(e) => e.target.style.borderColor = theme.red}
                  onBlur={(e) => e.target.style.borderColor = theme.greyLight}
                />
                <button onClick={toggleVoice} style={{
                  position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)",
                  background: "none", border: "none", cursor: "pointer",
                  color: listening ? theme.red : theme.grey,
                  animation: listening ? "pulse 1s infinite" : "none",
                }}>
                  {listening ? Icons.micActive : Icons.mic}
                </button>
              </div>

              <button id="realtyai-send-btn" onClick={handleSend} disabled={loading} style={{
                width: 48, height: 48, borderRadius: 14, border: "none",
                background: theme.red, color: theme.white, cursor: "pointer",
                display: "flex", alignItems: "center", justifyContent: "center",
                flexShrink: 0, boxShadow: "0 3px 12px rgba(227,24,55,0.25)",
                transition: "all 0.2s", opacity: loading ? 0.6 : 1,
              }}
              onMouseEnter={(e) => { if (!loading) e.currentTarget.style.background = theme.redDark; }}
              onMouseLeave={(e) => e.currentTarget.style.background = theme.red}
              >
                {loading ? Icons.spinner : Icons.send}
              </button>
            </div>

            {/* *** VOICE MODE: Toggle + Status Bar *** */}
            <div style={{
              maxWidth: window.innerWidth <= 768 ? "100%" : 820, margin: "4px auto 0", display: "flex", alignItems: "center",
              justifyContent: "center", gap: 8,
            }}>
              <button onClick={toggleVoiceMode} title={voiceMode ? "Turn off voice mode" : "Turn on voice mode"} style={{
                display: "flex", alignItems: "center", gap: 6, padding: "6px 14px",
                background: voiceMode ? "rgba(227,24,55,0.08)" : "transparent",
                border: `1.5px solid ${voiceMode ? theme.red : theme.greyLight}`,
                borderRadius: 20, cursor: "pointer", fontSize: 12, fontWeight: 600,
                fontFamily: theme.font, transition: "all 0.2s",
                color: voiceMode ? theme.red : theme.grey,
              }}
              onMouseEnter={(e) => { if (!voiceMode) { e.currentTarget.style.borderColor = theme.red; e.currentTarget.style.color = theme.red; } }}
              onMouseLeave={(e) => { if (!voiceMode) { e.currentTarget.style.borderColor = theme.greyLight; e.currentTarget.style.color = theme.grey; } }}
              >
                {voiceMode ? Icons.voiceOn : Icons.voiceOff}
                {voiceMode ? "Voice On" : "Voice Mode"}
              </button>

              {/* Speaking indicator + stop button */}
              {isSpeaking && (
                <button onClick={stopSpeaking} style={{
                  display: "flex", alignItems: "center", gap: 5, padding: "6px 12px",
                  background: "rgba(227,24,55,0.08)", border: `1.5px solid ${theme.red}`,
                  borderRadius: 20, cursor: "pointer", fontSize: 12, fontWeight: 600,
                  fontFamily: theme.font, color: theme.red, animation: "pulse 1.5s infinite",
                }}>
                  {Icons.stopSpeaking} Stop
                </button>
              )}

              {/* Listening indicator */}
              {voiceMode && listening && !isSpeaking && (
                <span style={{
                  fontSize: 12, color: theme.red, fontWeight: 600,
                  animation: "pulse 1s infinite", display: "flex", alignItems: "center", gap: 4,
                }}>
                  <span style={{ width: 8, height: 8, borderRadius: "50%", background: theme.red, display: "inline-block" }}></span>
                  Listening...
                </span>
              )}
            </div>
            <p style={{ textAlign: "center", fontSize: 11, color: "#999", marginTop: 8 }}>
              Realty AI searches Zillow, Realtor.com, Redfin, Homes.com, LoopNet, Crexi & BizBuySell
              {userPlan === "free" && (
                <span style={{ display: "block", marginTop: 2, color: searchCount >= 40 ? theme.red : "#999" }}>
                  {50 - searchCount} searches remaining this month · <button onClick={() => setShowUpgradeModal(true)} style={{ background: "none", border: "none", color: theme.red, cursor: "pointer", fontFamily: theme.font, fontSize: 11, fontWeight: 600, textDecoration: "underline" }}>Upgrade to Plus</button>
                </span>
              )}
              {userPlan === "plus" && (
                <span style={{ display: "block", marginTop: 2, color: "#27ae60" }}>
                  ✓ Realty AI Plus — Unlimited searches
                </span>
              )}
            </p>
          </div>
        </div>{/* END main content column */}
      </div>{/* END outer flex row */}

      {/* Mortgage Agent Overlay — UNCHANGED */}
      {showMortgageAgent && (
        <div className="agent-overlay"
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            zIndex: 9999, background: 'rgba(0,0,0,0.5)',
            display: 'flex', justifyContent: 'center', alignItems: 'flex-end',
          }}
          onClick={(e) => { if (e.target === e.currentTarget) setShowMortgageAgent(false); }}
        >
          <div style={{
            width: window.innerWidth <= 768 ? '100%' : '95%',
            maxWidth: window.innerWidth <= 768 ? '100%' : 1200,
            height: window.innerWidth <= 768 ? '100%' : '92vh',
            background: '#fff',
            borderRadius: window.innerWidth <= 768 ? 0 : '16px 16px 0 0',
            boxShadow: '0 -4px 40px rgba(0,0,0,0.25)',
            position: 'relative', overflow: 'hidden',
            animation: 'slideUp 0.3s ease-out',
          }}>
            <div style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '10px 16px', background: '#fff', borderBottom: '1px solid #E5E7EB',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <img src="/logo.png" alt="Realty AI" style={{ width: 28, height: 28, borderRadius: 6 }} />
                <span style={{ fontSize: 14, fontWeight: 600, color: '#1A1A1A', fontFamily: theme.font }}>Get Approved!</span>
              </div>
              <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                <button onClick={() => { const iframe = document.querySelector('iframe[title="Mortgage Application"]'); if (iframe) { iframe.contentWindow.postMessage('RESET_AGENT', '*'); iframe.src = iframe.src; } }} style={{ background: 'none', border: '1px solid #E5E7EB', borderRadius: 8, padding: '6px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: theme.font, color: theme.red, minHeight: 32, whiteSpace: 'nowrap' }}>🔄 Start Over</button>
                <button onClick={() => setShowMortgageAgent(false)} style={{ background: 'none', border: '1px solid #E5E7EB', borderRadius: 8, padding: '6px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: theme.font, color: '#555', minHeight: 32, whiteSpace: 'nowrap' }}>✕ Close</button>
              </div>
            </div>
            <iframe src="/mortgage-agent.html" style={{ width: '100%', height: 'calc(100% - 49px)', border: 'none' }} title="Mortgage Application" />
          </div>
        </div>
      )}

      {/* Offer Agent Overlay — UNCHANGED */}
      {showOfferAgent && (
        <div className="agent-overlay"
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            zIndex: 9999, background: 'rgba(0,0,0,0.5)',
            display: 'flex', justifyContent: 'center', alignItems: 'flex-end',
          }}
          onClick={(e) => { if (e.target === e.currentTarget) setShowOfferAgent(false); }}
        >
          <div style={{
            width: window.innerWidth <= 768 ? '100%' : '95%',
            maxWidth: window.innerWidth <= 768 ? '100%' : 1200,
            height: window.innerWidth <= 768 ? '100%' : '92vh',
            background: '#fff',
            borderRadius: window.innerWidth <= 768 ? 0 : '16px 16px 0 0',
            boxShadow: '0 -4px 40px rgba(0,0,0,0.25)',
            position: 'relative', overflow: 'hidden',
            animation: 'slideUp 0.3s ease-out',
          }}>
            <div style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '10px 16px', background: '#fff', borderBottom: '1px solid #E5E7EB',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <img src="/logo.png" alt="Realty AI" style={{ width: 28, height: 28, borderRadius: 6 }} />
                <span style={{ fontSize: 14, fontWeight: 600, color: '#1A1A1A', fontFamily: theme.font }}>Submit an Offer</span>
              </div>
              <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                <button onClick={() => { if (offerIframeRef.current) { offerIframeRef.current.contentWindow.postMessage('RESET_AGENT', '*'); offerIframeRef.current.src = offerIframeRef.current.src; } }} style={{ background: 'none', border: '1px solid #E5E7EB', borderRadius: 8, padding: '6px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: theme.font, color: theme.red, minHeight: 32, whiteSpace: 'nowrap' }}>🔄 Start Over</button>
                <button onClick={() => setShowOfferAgent(false)} style={{ background: 'none', border: '1px solid #E5E7EB', borderRadius: 8, padding: '6px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: theme.font, color: '#555', minHeight: 32, whiteSpace: 'nowrap' }}>✕ Close</button>
              </div>
            </div>
            <iframe ref={offerIframeRef} src="/offer-agent.html"
              style={{ width: '100%', height: 'calc(100% - 49px)', border: 'none' }} title="Submit an Offer"
              onLoad={() => {
                if (offerIframeRef.current && offerAddress) {
                  // The Offer Agent pre-fills its Property Details section from SHARED_CONTEXT
                  try {
                    offerIframeRef.current.contentWindow.postMessage({ type: 'SHARED_CONTEXT', payload: buildOfferContext(offerAddress) }, '*');
                  } catch(e) {}
                }
                if (window.innerWidth <= 768 && offerIframeRef.current) {
                  try {
                    offerIframeRef.current.contentWindow.postMessage('COLLAPSE_SIDEBAR', '*');
                  } catch(e) {}
                }
              }}
            />
          </div>
        </div>
      )}

      {/* Listing Agent Overlay — UNCHANGED */}
      {showListingAgent && (
        <div className="agent-overlay"
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            zIndex: 9999, background: 'rgba(0,0,0,0.5)',
            display: 'flex', justifyContent: 'center', alignItems: 'flex-end',
          }}
          onClick={(e) => { if (e.target === e.currentTarget) setShowListingAgent(false); }}
        >
          <div style={{
            width: window.innerWidth <= 768 ? '100%' : '95%',
            maxWidth: window.innerWidth <= 768 ? '100%' : 1200,
            height: window.innerWidth <= 768 ? '100%' : '92vh',
            background: '#fff',
            borderRadius: window.innerWidth <= 768 ? 0 : '16px 16px 0 0',
            boxShadow: '0 -4px 40px rgba(0,0,0,0.25)',
            position: 'relative', overflow: 'hidden',
            animation: 'slideUp 0.3s ease-out',
          }}>
            <div style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '10px 16px', background: '#fff', borderBottom: '1px solid #E5E7EB',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <img src="/logo.png" alt="Realty AI" style={{ width: 28, height: 28, borderRadius: 6 }} />
                <span style={{ fontSize: 14, fontWeight: 600, color: '#1A1A1A', fontFamily: theme.font }}>Sell Your Property</span>
              </div>
              <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                <button onClick={() => { if (listingIframeRef.current) { listingIframeRef.current.contentWindow.postMessage('RESET_AGENT', '*'); listingIframeRef.current.src = listingIframeRef.current.src; } }} style={{ background: 'none', border: '1px solid #E5E7EB', borderRadius: 8, padding: '6px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: theme.font, color: theme.red, minHeight: 32, whiteSpace: 'nowrap' }}>🔄 Start Over</button>
                <button onClick={() => setShowListingAgent(false)} style={{ background: 'none', border: '1px solid #E5E7EB', borderRadius: 8, padding: '6px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: theme.font, color: '#555', minHeight: 32, whiteSpace: 'nowrap' }}>✕ Close</button>
              </div>
            </div>
            <iframe ref={listingIframeRef} src="/listing-agent.html" style={{ width: '100%', height: 'calc(100% - 49px)', border: 'none' }} title="Sell Your Property" />
          </div>
        </div>
      )}

      {/* Tour Agent Overlay — UNCHANGED */}
      {showTourAgent && (
        <div className="agent-overlay"
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            zIndex: 10001, background: 'rgba(0,0,0,0.5)',
            display: 'flex', justifyContent: 'center', alignItems: 'flex-end',
          }}
          onClick={(e) => { if (e.target === e.currentTarget) setShowTourAgent(false); }}
        >
          <div style={{
            width: window.innerWidth <= 768 ? '100%' : '95%',
            maxWidth: window.innerWidth <= 768 ? '100%' : 1200,
            height: window.innerWidth <= 768 ? '100%' : '92vh',
            background: '#fff',
            borderRadius: window.innerWidth <= 768 ? 0 : '16px 16px 0 0',
            boxShadow: '0 -4px 40px rgba(0,0,0,0.25)',
            position: 'relative', overflow: 'hidden',
            animation: 'slideUp 0.3s ease-out',
            display: 'flex', flexDirection: 'column',
          }}>
            <div style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '10px 16px', background: '#fff', borderBottom: '1px solid #E5E7EB', flexShrink: 0,
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <img src="/logo.png" alt="Realty AI" style={{ width: 28, height: 28, borderRadius: 6 }} />
                <span style={{ fontSize: 14, fontWeight: 600, color: '#1A1A1A' }}>Schedule a Tour</span>
              </div>
              <button onClick={() => setShowTourAgent(false)} style={{ background: 'none', border: '1px solid #E5E7EB', borderRadius: 8, padding: '6px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer', color: '#555', minHeight: 36 }}>✕ Close</button>
            </div>
            <iframe ref={tourIframeRef} src="/schedule-tour.html" style={{ width: '100%', flex: 1, border: 'none' }} title="Schedule a Tour"
              onLoad={() => {
                if (window.innerWidth <= 768 && tourIframeRef.current) {
                  try {
                    const iframeDoc = tourIframeRef.current.contentDocument || tourIframeRef.current.contentWindow.document;
                    const style = iframeDoc.createElement('style');
                    style.textContent = `
                      @media (max-width: 768px) {
                        .back-link, a[href*="dashboard"] { display: none !important; }
                      }
                    `;
                    iframeDoc.head.appendChild(style);
                    // Try to auto-click the 3-bar menu to open sidebar
                    setTimeout(() => {
                      try {
                        const menuBtn = iframeDoc.querySelector('button[aria-label="menu"], button[class*="menu"], .hamburger, [class*="Menu"] button, nav button, header button:first-child');
                        if (menuBtn) menuBtn.click();
                      } catch(e2) {}
                    }, 1000);
                  } catch(e) { console.log('[Tour] iframe access restricted:', e.message); }
                }
              }}
            />
          </div>
        </div>
      )}

      {/* ═══ MARKETPLACE OVERLAY ═══ */}
      {showMarketplace && (
        <div className="agent-overlay" style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          zIndex: 9999, background: 'rgba(0,0,0,0.5)',
          display: 'flex', justifyContent: 'center', alignItems: 'flex-end',
        }}
        onClick={(e) => { if (e.target === e.currentTarget) setShowMarketplace(false); }}
        >
          <div style={{
            width: window.innerWidth <= 768 ? '100%' : '95%',
            maxWidth: window.innerWidth <= 768 ? '100%' : 1100,
            height: window.innerWidth <= 768 ? '100%' : '94vh',
            background: '#fff',
            borderRadius: window.innerWidth <= 768 ? 0 : '16px 16px 0 0',
            boxShadow: '0 -4px 40px rgba(0,0,0,0.25)',
            position: 'relative', overflow: 'hidden',
            animation: 'slideUp 0.3s ease-out',
            display: 'flex', flexDirection: 'column',
          }}>
            {/* Marketplace Header */}
            <div style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '12px 20px', background: '#fff', borderBottom: '1px solid #E5E7EB',
              flexShrink: 0,
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <img src="/logo.png" alt="Realty AI" style={{ width: 28, height: 28, borderRadius: 6 }} />
                <span style={{ fontSize: 16, fontWeight: 700, color: theme.red, fontFamily: theme.font }}>
                  Marketplace
                </span>
                {marketplaceView !== "feed" && (
                  <button onClick={() => { setMarketplaceView("feed"); setSelectedListing(null); }} style={{
                    background: 'none', border: '1px solid #E5E7EB', borderRadius: 8,
                    padding: '4px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer',
                    fontFamily: theme.font, color: '#555', marginLeft: 8,
                  }}>← Back</button>
                )}
              </div>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                {user && user.email === 'gdifaziorealtor@gmail.com' && marketplaceView === "feed" && (
                  <>
                  <input
                    value={idxImportCities}
                    onChange={e => setIdxImportCities(e.target.value)}
                    placeholder="City, ST (e.g. San Francisco CA, Las Vegas)"
                    style={{
                      padding: '6px 10px', border: '1px solid #ccc', borderRadius: 6,
                      fontSize: 11, fontFamily: theme.font, width: 200,
                    }}
                  />
                  <button onClick={async () => {
                    const btn = document.getElementById('idx-import-btn');
                    if (btn) { btn.disabled = true; }
                    let totalImported = 0;
                    let totalFound = 0;
                    const cityFilter = idxImportCities.trim().toLowerCase().split(',').map(c => c.trim()).filter(c => c);
                    if (cityFilter.length === 0) { alert('Enter city to import (e.g. "San Francisco, CA" or "Las Vegas")'); if (btn) btn.disabled = false; return; }
                    // Smart parsing: rejoin comma-separated tokens that look like "City, ST"
                    // "San Francisco, CA, Las Vegas" → [{city:"San Francisco",state:"CA"}, {city:"Las Vegas",state:"NV"}]
                    const parsedCities = [];
                    for (let i = 0; i < cityFilter.length; i++) {
                      const cur = cityFilter[i];
                      if (cur.length === 2 && /^[a-z]{2}$/i.test(cur) && parsedCities.length > 0) {
                        parsedCities[parsedCities.length - 1].state = cur.toUpperCase();
                      } else {
                        const withState = cur.match(/^(.+?)\s+([a-z]{2})$/i);
                        if (withState) {
                          parsedCities.push({ city: withState[1].trim(), state: withState[2].toUpperCase() });
                        } else {
                          parsedCities.push({ city: cur, state: 'NV' });
                        }
                      }
                    }
                    if (parsedCities.length === 0) { alert('Could not parse cities'); if (btn) btn.disabled = false; return; }
                    try {
                      const existing = {};
                      let addrOffset = 0;
                      while (true) {
                        const { data: batch } = await supabaseRequest('/marketplace_listings?select=address&seller_email=eq.gdifaziorealtor@gmail.com&limit=1000&offset=' + addrOffset, { method: 'GET' });
                        if (!batch || batch.length === 0) break;
                        batch.forEach(r => { if (r.address) existing[r.address.toLowerCase().trim()] = true; });
                        if (batch.length < 1000) break;
                        addrOffset += 1000;
                      }
                      if (btn) btn.textContent = Object.keys(existing).length + ' existing, importing ' + parsedCities.map(c => c.city).join(', ') + '...';

                      // Import each city separately using area URLs (server-side filtering)
                      for (const cityObj of parsedCities) {
                      let pg = 1;
                      let cityEmptyPages = 0;
                      if (btn) btn.textContent = 'Importing ' + cityObj.city + ', ' + cityObj.state + '...';
                      let rateLimitRetries = 0;
                      while (true) {
                        if (btn) btn.textContent = cityObj.city + ' pg ' + pg + ' (' + totalImported + ' new total)...';
                        try {
                          const res = await fetch('/.netlify/functions/import-idx-listings', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ page: pg, city: cityObj.city, state: cityObj.state }),
                          });
                          if (res.status === 429) {
                            rateLimitRetries++;
                            if (rateLimitRetries > 5) { cityEmptyPages++; if (cityEmptyPages >= 3) break; pg++; rateLimitRetries = 0; continue; }
                            if (btn) btn.textContent = cityObj.city + ' pg ' + pg + ' (rate limit, waiting ' + (rateLimitRetries * 3) + 's)...';
                            await new Promise(r => setTimeout(r, rateLimitRetries * 3000));
                            continue;
                          }
                          rateLimitRetries = 0;
                          if (!res.ok) { cityEmptyPages++; if (cityEmptyPages >= 3) break; pg++; continue; }
                          const data = await res.json();
                          const listings = data.listings || [];
                          if (listings.length === 0) { cityEmptyPages++; if (cityEmptyPages >= 3) break; pg++; continue; }
                          cityEmptyPages = 0;
                          totalFound += listings.length;

                          for (const l of listings) {
                            if (!l.address || !l.price || l.price < 5000 || !l.address.includes(',')) continue;
                            if (existing[l.address.toLowerCase().trim()]) continue;
                            const parts = l.address.match(/^(.+),\s*([A-Za-z\s]+),\s*([A-Z]{2})\s*(\d{5})?/);
                            const city = parts ? parts[2].trim() : l.city || '';
                            const state = parts ? parts[3].trim() : l.state || 'NV';
                            const zip = parts ? (parts[4] || '') : l.zip || '';
                            const photos = Array.isArray(l.photos) ? l.photos : (l.photo_url ? [l.photo_url] : []);
                            try {
                              await supabaseRequest('/marketplace_listings', {
                                method: 'POST',
                                body: JSON.stringify({
                                  seller_email: 'gdifaziorealtor@gmail.com',
                                  seller_name: 'Giancarlo Di Fazio',
                                  address: l.address, city, state, zip,
                                  description: (l.beds||'?') + ' bed, ' + (l.baths||'?') + ' bath, ' + (l.sqft||0) + ' sqft. ' + (l.status||'Active') + '. ' + (l.agent||''),
                                  price: l.price, beds: l.beds||null, baths: l.baths||null, sqft: l.sqft||null,
                                  property_type: 'Single Family', photos, status: 'active', listing_type: 'sell',
                                }),
                              });
                              totalImported++;
                              existing[l.address.toLowerCase().trim()] = true;
                            } catch(ie) {}
                          }
                          if (btn) btn.textContent = '\u2713 ' + totalImported + ' new (' + cityObj.city + ' pg ' + pg + ')...';
                      } catch(pe) { cityEmptyPages++; if (cityEmptyPages >= 3) break; }
                        pg++;
                        await new Promise(r => setTimeout(r, 800));
                      }
                      } // end for each city
                      if (btn) { btn.textContent = '\u2713 ' + totalImported + ' imported from ' + parsedCities.length + ' cities'; setTimeout(() => { btn.textContent = '\ud83d\udce5 Import IDX'; btn.disabled = false; }, 8000); }
                      if (totalImported > 0) fetchMarketplaceListings();
                    } catch (e) {
                      console.error('Import error:', e);
                      if (btn) { btn.textContent = totalImported > 0 ? '\u2713 ' + totalImported + ' (partial)' : 'Error'; setTimeout(() => { btn.textContent = '\ud83d\udce5 Import IDX'; btn.disabled = false; }, 3000); }
                      if (totalImported > 0) fetchMarketplaceListings();
                    }
                  }} id="idx-import-btn" style={{
                    padding: '8px 14px', background: '#1a1a2e', color: '#fff',
                    border: 'none', borderRadius: 8, fontSize: 12, fontWeight: 600,
                    cursor: 'pointer', fontFamily: theme.font, whiteSpace: 'nowrap',
                  }}>\ud83d\udce5 Import IDX</button>
                  </>
                )}
                {user && marketplaceView === "feed" && (
                  <button onClick={() => setMarketplaceView("post")} style={{
                    padding: '8px 16px', background: theme.red, color: '#fff',
                    border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600,
                    cursor: 'pointer', fontFamily: theme.font,
                  }}>+ Post Listing</button>
                )}
                <button onClick={() => setShowMarketplace(false)} style={{
                  background: 'none', border: '1px solid #E5E7EB', borderRadius: 8,
                  padding: '6px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer',
                  fontFamily: theme.font, color: '#555', minHeight: 32,
                }}>✕ Close</button>
              </div>
            </div>

            {/* ─── FEED VIEW ─── */}
            {marketplaceView === "feed" && (
              <div style={{ flex: 1, overflow: 'auto' }}>
                {/* Category Tabs (Sell/Buy/Rent) */}
                <div style={{ padding: '12px 20px', borderBottom: '1px solid #f0f0f0', display: 'flex', gap: 0 }}>
                  {["buy", "sell", "rent"].map(cat => (
                    <button key={cat} onClick={() => setMarketplaceCategory(cat)} style={{
                      padding: '8px 20px', fontSize: 13, fontWeight: 600,
                      border: 'none', borderBottom: marketplaceCategory === cat ? `3px solid ${theme.red}` : '3px solid transparent',
                      background: 'transparent',
                      color: marketplaceCategory === cat ? theme.red : '#777',
                      cursor: 'pointer', fontFamily: theme.font, textTransform: 'capitalize',
                    }}>{cat === "buy" ? "Buy" : cat === "sell" ? "Sell" : "Rent"}</button>
                  ))}
                </div>
                {/* Search & Filter Bar */}
                <div style={{ padding: '10px 20px', borderBottom: '1px solid #f0f0f0', display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
                  <input value={mpSearchCity} onChange={(e) => setMpSearchCity(e.target.value)} placeholder="City..."
                    style={{ padding: '6px 10px', border: '1px solid #ddd', borderRadius: 6, fontSize: 12, fontFamily: theme.font, width: 100, outline: 'none' }}
                    onKeyDown={(e) => { if (e.key === 'Enter') { setMpPage(1); fetchMarketplaceListings(1); } }}
                  />
                  <input value={mpSearchMinPrice} onChange={(e) => setMpSearchMinPrice(e.target.value.replace(/[^0-9]/g, ''))} placeholder="Min $"
                    style={{ padding: '6px 10px', border: '1px solid #ddd', borderRadius: 6, fontSize: 12, fontFamily: theme.font, width: 70, outline: 'none' }}
                  />
                  <input value={mpSearchMaxPrice} onChange={(e) => setMpSearchMaxPrice(e.target.value.replace(/[^0-9]/g, ''))} placeholder="Max $"
                    style={{ padding: '6px 10px', border: '1px solid #ddd', borderRadius: 6, fontSize: 12, fontFamily: theme.font, width: 70, outline: 'none' }}
                  />
                  <select value={mpSearchBeds} onChange={(e) => setMpSearchBeds(e.target.value)}
                    style={{ padding: '6px 8px', border: '1px solid #ddd', borderRadius: 6, fontSize: 12, fontFamily: theme.font, outline: 'none', background: '#fff' }}>
                    <option value="">Beds</option>
                    <option value="1">1+</option><option value="2">2+</option><option value="3">3+</option><option value="4">4+</option><option value="5">5+</option>
                  </select>
                  {["all", "active", "pending", "sold"].map(f => (
                    <button key={f} onClick={() => setMarketplaceFilter(f)} style={{
                      padding: '5px 10px', borderRadius: 14, fontSize: 11, fontWeight: 600,
                      border: marketplaceFilter === f ? '2px solid ' + theme.red : '1px solid #ddd',
                      background: marketplaceFilter === f ? '#FEF2F2' : '#fff',
                      color: marketplaceFilter === f ? theme.red : '#555',
                      cursor: 'pointer', fontFamily: theme.font, textTransform: 'capitalize',
                    }}>{f === "all" ? "All" : f}</button>
                  ))}
                  <button onClick={() => { setMpPage(1); fetchMarketplaceListings(1); }} style={{
                    padding: '5px 12px', borderRadius: 6, fontSize: 11, fontWeight: 600,
                    border: 'none', background: theme.red, color: '#fff',
                    cursor: 'pointer', fontFamily: theme.font,
                  }}>Search</button>
                  <span style={{ marginLeft: 'auto', fontSize: 12, color: '#999' }}>
                    {mpTotalCount > 0 ? mpTotalCount.toLocaleString() : marketplaceListings.length} listing{(mpTotalCount || marketplaceListings.length) !== 1 ? 's' : ''}
                  </span>
                </div>

                {/* Listings Grid */}
                {marketplaceLoading ? (
                  <div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}>
                    {Icons.spinner}
                  </div>
                ) : marketplaceListings.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '60px 20px', color: '#999' }}>
                    <div style={{ fontSize: 48, marginBottom: 16 }}>🏘️</div>
                    <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>No listings yet</div>
                    <div style={{ fontSize: 13 }}>Be the first to post a property for sale!</div>
                  </div>
                ) : (
                  <>
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: window.innerWidth <= 768 ? '1fr' : 'repeat(auto-fill, minmax(300px, 1fr))',
                    gap: 16, padding: 20,
                  }}>
                    {marketplaceListings.map(listing => (
                      <div key={listing.id} onClick={() => {
                        setSelectedListing(listing);
                        setMarketplaceView("detail");
                        fetchListingMessages(listing.id);
                      }} style={{
                        border: '1px solid #E5E7EB', borderRadius: 12, overflow: 'hidden',
                        cursor: 'pointer', transition: 'all 0.2s', background: '#fff',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                      }}
                      onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.12)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                      onMouseLeave={(e) => { e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)'; e.currentTarget.style.transform = 'translateY(0)'; }}
                      >
                        {/* Photo */}
                        <div style={{
                          height: 180, background: '#f3f4f6',
                          backgroundImage: listing.photos && listing.photos[0] ? `url(${listing.photos[0]})` : 'none',
                          backgroundSize: 'cover', backgroundPosition: 'center',
                          position: 'relative',
                        }}>
                          {(!listing.photos || !listing.photos[0]) && (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#ccc', fontSize: 48 }}>🏠</div>
                          )}
                          <div style={{
                            position: 'absolute', top: 10, left: 10,
                            padding: '4px 10px', borderRadius: 6, fontSize: 11, fontWeight: 700,
                            textTransform: 'uppercase', letterSpacing: '0.5px',
                            background: listing.status === 'active' ? '#22C55E' : listing.status === 'pending' ? '#F59E0B' : listing.status === 'sold' ? '#EF4444' : '#6B7280',
                            color: '#fff',
                          }}>{listing.status}</div>
                          {listing.photos && listing.photos.length > 1 && (
                            <div style={{
                              position: 'absolute', bottom: 10, right: 10,
                              padding: '3px 8px', borderRadius: 4, fontSize: 11, fontWeight: 600,
                              background: 'rgba(0,0,0,0.6)', color: '#fff',
                            }}>📷 {listing.photos.length}</div>
                          )}
                        </div>
                        {/* Info */}
                        <div style={{ padding: '14px 16px' }}>
                          <div style={{ fontSize: 20, fontWeight: 700, color: theme.dark, fontFamily: theme.font }}>
                            ${Number(listing.price).toLocaleString()}
                          </div>
                          <div style={{ fontSize: 13, color: '#555', marginTop: 4, fontWeight: 500 }}>
                            {listing.address}
                          </div>
                          {(listing.beds || listing.baths || listing.sqft) && (
                            <div style={{ display: 'flex', gap: 12, marginTop: 8, fontSize: 12, color: '#777' }}>
                              {listing.beds && <span>{listing.beds} bed{listing.beds > 1 ? 's' : ''}</span>}
                              {listing.baths && <span>{listing.baths} bath{listing.baths > 1 ? 's' : ''}</span>}
                              {listing.sqft && <span>{Number(listing.sqft).toLocaleString()} sqft</span>}
                            </div>
                          )}
                          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10, fontSize: 11, color: '#aaa' }}>
                            <span>by {listing.seller_name || 'Agent'}</span>
                            <span>{listing.offers_count > 0 ? `${listing.offers_count} offer${listing.offers_count > 1 ? 's' : ''}` : 'No offers'}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  {/* ─── PAGINATION ─── */}
                  {mpTotalCount > MP_PER_PAGE && (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '16px 0', flexWrap: 'wrap' }}>
                      <button disabled={mpPage <= 1} onClick={() => { setMpPage(1); fetchMarketplaceListings(1); }} style={{
                        padding: '6px 12px', border: '1px solid #E5E7EB', borderRadius: 6, background: '#fff',
                        cursor: mpPage <= 1 ? 'default' : 'pointer', opacity: mpPage <= 1 ? 0.4 : 1,
                        fontSize: 12, fontFamily: theme.font,
                      }}>« First</button>
                      <button disabled={mpPage <= 1} onClick={() => { const p = mpPage - 1; setMpPage(p); fetchMarketplaceListings(p); }} style={{
                        padding: '6px 12px', border: '1px solid #E5E7EB', borderRadius: 6, background: '#fff',
                        cursor: mpPage <= 1 ? 'default' : 'pointer', opacity: mpPage <= 1 ? 0.4 : 1,
                        fontSize: 12, fontFamily: theme.font,
                      }}>‹ Prev</button>
                      <span style={{ fontSize: 13, fontFamily: theme.font, color: '#555', padding: '0 8px' }}>
                        Page {mpPage} of {Math.ceil(mpTotalCount / MP_PER_PAGE)} ({mpTotalCount.toLocaleString()} total)
                      </span>
                      <button disabled={mpPage >= Math.ceil(mpTotalCount / MP_PER_PAGE)} onClick={() => { const p = mpPage + 1; setMpPage(p); fetchMarketplaceListings(p); }} style={{
                        padding: '6px 12px', border: '1px solid #E5E7EB', borderRadius: 6, background: '#fff',
                        cursor: mpPage >= Math.ceil(mpTotalCount / MP_PER_PAGE) ? 'default' : 'pointer',
                        opacity: mpPage >= Math.ceil(mpTotalCount / MP_PER_PAGE) ? 0.4 : 1,
                        fontSize: 12, fontFamily: theme.font,
                      }}>Next ›</button>
                      <button disabled={mpPage >= Math.ceil(mpTotalCount / MP_PER_PAGE)} onClick={() => { const p = Math.ceil(mpTotalCount / MP_PER_PAGE); setMpPage(p); fetchMarketplaceListings(p); }} style={{
                        padding: '6px 12px', border: '1px solid #E5E7EB', borderRadius: 6, background: '#fff',
                        cursor: mpPage >= Math.ceil(mpTotalCount / MP_PER_PAGE) ? 'default' : 'pointer',
                        opacity: mpPage >= Math.ceil(mpTotalCount / MP_PER_PAGE) ? 0.4 : 1,
                        fontSize: 12, fontFamily: theme.font,
                      }}>Last »</button>
                    </div>
                  )}
                  </>
                )}
              </div>
            )}

            {/* ─── POST LISTING VIEW ─── */}
            {marketplaceView === "post" && (
              <div style={{ flex: 1, overflow: 'auto', padding: 20 }}>
                <h3 style={{ fontSize: 18, fontWeight: 700, color: theme.dark, fontFamily: theme.font, marginBottom: 20 }}>
                  Post a Listing
                </h3>
                <div style={{ display: 'grid', gridTemplateColumns: window.innerWidth <= 768 ? '1fr' : '1fr 1fr', gap: 14, maxWidth: 700 }}>
                  {/* Listing Type */}
                  <div style={{ gridColumn: '1 / -1', display: 'flex', gap: 8, marginBottom: 4 }}>
                    {["sell", "rent"].map(lt => (
                      <button key={lt} onClick={() => setPostForm(p => ({...p, listing_type: lt}))} style={{
                        padding: '8px 20px', borderRadius: 8, fontSize: 13, fontWeight: 600,
                        border: postForm.listing_type === lt ? `2px solid ${theme.red}` : '2px solid #ddd',
                        background: postForm.listing_type === lt ? '#FEF2F2' : '#fff',
                        color: postForm.listing_type === lt ? theme.red : '#555',
                        cursor: 'pointer', fontFamily: theme.font,
                      }}>{lt === "sell" ? "For Sale" : "For Rent"}</button>
                    ))}
                  </div>
                  <div style={{ gridColumn: '1 / -1' }}>
                    <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Property Address *</label>
                    <input value={postForm.address} onChange={(e) => setPostForm(p => ({...p, address: e.target.value}))}
                      placeholder="123 Main St" style={{ width: '100%', padding: '10px 14px', border: '2px solid #E5E7EB', borderRadius: 8, fontSize: 14, fontFamily: theme.font, outline: 'none', boxSizing: 'border-box' }}
                      onFocus={(e) => e.target.style.borderColor = theme.red} onBlur={(e) => e.target.style.borderColor = '#E5E7EB'}
                    />
                  </div>
                  <div>
                    <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>City</label>
                    <input value={postForm.city} onChange={(e) => setPostForm(p => ({...p, city: e.target.value}))}
                      placeholder="Las Vegas" style={{ width: '100%', padding: '10px 14px', border: '2px solid #E5E7EB', borderRadius: 8, fontSize: 14, fontFamily: theme.font, outline: 'none', boxSizing: 'border-box' }}
                      onFocus={(e) => e.target.style.borderColor = theme.red} onBlur={(e) => e.target.style.borderColor = '#E5E7EB'}
                    />
                  </div>
                  <div style={{ display: 'flex', gap: 10 }}>
                    <div style={{ flex: 1 }}>
                      <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>State</label>
                      <input value={postForm.state} onChange={(e) => setPostForm(p => ({...p, state: e.target.value}))}
                        placeholder="NV" style={{ width: '100%', padding: '10px 14px', border: '2px solid #E5E7EB', borderRadius: 8, fontSize: 14, fontFamily: theme.font, outline: 'none', boxSizing: 'border-box' }}
                        onFocus={(e) => e.target.style.borderColor = theme.red} onBlur={(e) => e.target.style.borderColor = '#E5E7EB'}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>ZIP</label>
                      <input value={postForm.zip} onChange={(e) => setPostForm(p => ({...p, zip: e.target.value}))}
                        placeholder="89141" style={{ width: '100%', padding: '10px 14px', border: '2px solid #E5E7EB', borderRadius: 8, fontSize: 14, fontFamily: theme.font, outline: 'none', boxSizing: 'border-box' }}
                        onFocus={(e) => e.target.style.borderColor = theme.red} onBlur={(e) => e.target.style.borderColor = '#E5E7EB'}
                      />
                    </div>
                  </div>
                  <div>
                    <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Asking Price *</label>
                    <input value={postForm.price} onChange={(e) => setPostForm(p => ({...p, price: e.target.value.replace(/[^0-9]/g, '')}))}
                      placeholder="600000" type="text" style={{ width: '100%', padding: '10px 14px', border: '2px solid #E5E7EB', borderRadius: 8, fontSize: 14, fontFamily: theme.font, outline: 'none', boxSizing: 'border-box' }}
                      onFocus={(e) => e.target.style.borderColor = theme.red} onBlur={(e) => e.target.style.borderColor = '#E5E7EB'}
                    />
                    {postForm.price && <div style={{ fontSize: 11, color: '#999', marginTop: 2 }}>${Number(postForm.price).toLocaleString()}</div>}
                  </div>
                  <div>
                    <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Property Type</label>
                    <select value={postForm.property_type} onChange={(e) => setPostForm(p => ({...p, property_type: e.target.value}))}
                      style={{ width: '100%', padding: '10px 14px', border: '2px solid #E5E7EB', borderRadius: 8, fontSize: 14, fontFamily: theme.font, outline: 'none', background: '#fff', boxSizing: 'border-box' }}>
                      <option>Single Family</option>
                      <option>Condo</option>
                      <option>Townhouse</option>
                      <option>Multi-Family</option>
                      <option>Land</option>
                      <option>Commercial</option>
                    </select>
                  </div>
                  <div>
                    <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Beds</label>
                    <input value={postForm.beds} onChange={(e) => setPostForm(p => ({...p, beds: e.target.value}))}
                      placeholder="4" type="number" style={{ width: '100%', padding: '10px 14px', border: '2px solid #E5E7EB', borderRadius: 8, fontSize: 14, fontFamily: theme.font, outline: 'none', boxSizing: 'border-box' }}
                      onFocus={(e) => e.target.style.borderColor = theme.red} onBlur={(e) => e.target.style.borderColor = '#E5E7EB'}
                    />
                  </div>
                  <div>
                    <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Baths</label>
                    <input value={postForm.baths} onChange={(e) => setPostForm(p => ({...p, baths: e.target.value}))}
                      placeholder="3" type="number" style={{ width: '100%', padding: '10px 14px', border: '2px solid #E5E7EB', borderRadius: 8, fontSize: 14, fontFamily: theme.font, outline: 'none', boxSizing: 'border-box' }}
                      onFocus={(e) => e.target.style.borderColor = theme.red} onBlur={(e) => e.target.style.borderColor = '#E5E7EB'}
                    />
                  </div>
                  <div>
                    <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Sqft</label>
                    <input value={postForm.sqft} onChange={(e) => setPostForm(p => ({...p, sqft: e.target.value}))}
                      placeholder="2400" type="number" style={{ width: '100%', padding: '10px 14px', border: '2px solid #E5E7EB', borderRadius: 8, fontSize: 14, fontFamily: theme.font, outline: 'none', boxSizing: 'border-box' }}
                      onFocus={(e) => e.target.style.borderColor = theme.red} onBlur={(e) => e.target.style.borderColor = '#E5E7EB'}
                    />
                  </div>
                  <div>
                    <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Year Built</label>
                    <input value={postForm.year_built} onChange={(e) => setPostForm(p => ({...p, year_built: e.target.value}))}
                      placeholder="2005" type="number" style={{ width: '100%', padding: '10px 14px', border: '2px solid #E5E7EB', borderRadius: 8, fontSize: 14, fontFamily: theme.font, outline: 'none', boxSizing: 'border-box' }}
                      onFocus={(e) => e.target.style.borderColor = theme.red} onBlur={(e) => e.target.style.borderColor = '#E5E7EB'}
                    />
                  </div>
                  <div style={{ gridColumn: '1 / -1' }}>
                    <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Description</label>
                    <textarea value={postForm.description} onChange={(e) => setPostForm(p => ({...p, description: e.target.value}))}
                      placeholder="Describe the property — features, upgrades, neighborhood highlights..."
                      rows={4} style={{ width: '100%', padding: '10px 14px', border: '2px solid #E5E7EB', borderRadius: 8, fontSize: 14, fontFamily: theme.font, outline: 'none', resize: 'vertical', boxSizing: 'border-box' }}
                      onFocus={(e) => e.target.style.borderColor = theme.red} onBlur={(e) => e.target.style.borderColor = '#E5E7EB'}
                    />
                  </div>
                  {/* Photo & Video Upload */}
                  <div style={{ gridColumn: '1 / -1' }}>
                    <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Photos & Videos</label>
                    <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
                      {postPhotos.map((url, i) => (
                        <div key={"p"+i} style={{ position: 'relative' }}>
                          <img src={url} alt="" style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 8, border: '1px solid #ddd' }} />
                          <button onClick={() => setPostPhotos(p => p.filter((_, idx) => idx !== i))} style={{
                            position: 'absolute', top: -6, right: -6, width: 20, height: 20, borderRadius: '50%',
                            background: '#EF4444', color: '#fff', border: 'none', fontSize: 11, cursor: 'pointer',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                          }}>✕</button>
                        </div>
                      ))}
                      {postVideos.map((url, i) => (
                        <div key={"v"+i} style={{ position: 'relative' }}>
                          <div style={{ width: 80, height: 80, borderRadius: 8, border: '1px solid #ddd', background: '#111', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 24 }}>🎬</div>
                          <button onClick={() => setPostVideos(p => p.filter((_, idx) => idx !== i))} style={{
                            position: 'absolute', top: -6, right: -6, width: 20, height: 20, borderRadius: '50%',
                            background: '#EF4444', color: '#fff', border: 'none', fontSize: 11, cursor: 'pointer',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                          }}>✕</button>
                        </div>
                      ))}
                      <label style={{
                        width: 80, height: 80, borderRadius: 8, border: '2px dashed #ddd',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column',
                        cursor: postUploading ? 'wait' : 'pointer', color: '#aaa', fontSize: 20,
                        background: '#fafafa',
                      }}>
                        {postUploading ? '...' : <>+<span style={{ fontSize: 9, marginTop: 2 }}>Photo/Video</span></>}
                        <input type="file" accept="image/*,video/*" multiple hidden
                          onChange={(e) => { if (e.target.files.length) uploadMarketplacePhotos(Array.from(e.target.files)); }}
                        />
                      </label>
                    </div>
                  </div>
                  {/* Submit */}
                  <div style={{ gridColumn: '1 / -1', marginTop: 8 }}>
                    <button onClick={submitMarketplaceListing} disabled={!postForm.address || !postForm.price}
                      style={{
                        padding: '14px 32px', background: theme.red, color: '#fff',
                        border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 700,
                        cursor: !postForm.address || !postForm.price ? 'not-allowed' : 'pointer',
                        fontFamily: theme.font, opacity: !postForm.address || !postForm.price ? 0.5 : 1,
                        boxShadow: '0 4px 16px rgba(227,24,55,0.25)',
                      }}>
                      Post Listing
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* ─── DETAIL VIEW (Listing + Chat) ─── */}
            {marketplaceView === "detail" && selectedListing && (
              <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: window.innerWidth <= 768 ? 'column' : 'row' }}>
                {/* Left — Listing Info */}
                <div style={{
                  width: window.innerWidth <= 768 ? '100%' : '55%',
                  overflow: 'auto', borderRight: window.innerWidth <= 768 ? 'none' : '1px solid #E5E7EB',
                  borderBottom: window.innerWidth <= 768 ? '1px solid #E5E7EB' : 'none',
                  maxHeight: window.innerWidth <= 768 ? '45%' : 'auto',
                }}>
                  {/* Photos carousel — clickable for lightbox */}
                  {selectedListing.photos && selectedListing.photos.length > 0 ? (
                    <div style={{ position: 'relative' }}>
                      <div style={{ display: 'flex', overflowX: 'auto', scrollSnapType: 'x mandatory' }}>
                        {selectedListing.photos.map((url, i) => (
                          <img key={i} src={url} alt="" onClick={() => { setLightboxPhoto(selectedListing.photos); setLightboxIndex(i); }} style={{
                            width: '100%', height: 260, objectFit: 'cover', flexShrink: 0,
                            scrollSnapAlign: 'start', cursor: 'zoom-in',
                          }} />
                        ))}
                      </div>
                      {selectedListing.photos.length > 1 && (
                        <div style={{ position: 'absolute', bottom: 10, right: 10, padding: '3px 8px', borderRadius: 4, fontSize: 11, background: 'rgba(0,0,0,0.6)', color: '#fff' }}>
                          📷 {selectedListing.photos.length} photos — click to enlarge
                        </div>
                      )}
                    </div>
                  ) : (
                    <div style={{ height: 200, background: '#f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ccc', fontSize: 64 }}>🏠</div>
                  )}
                  {/* Videos */}
                  {selectedListing.videos && selectedListing.videos.length > 0 && (
                    <div style={{ padding: '0 20px' }}>
                      {selectedListing.videos.map((url, i) => (
                        <video key={i} src={url} controls style={{ width: '100%', borderRadius: 8, marginTop: 10, maxHeight: 240 }} />
                      ))}
                    </div>
                  )}
                  <div style={{ padding: '16px 20px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                      <div>
                        <div style={{ fontSize: 24, fontWeight: 700, color: theme.dark, fontFamily: theme.font }}>
                          ${Number(selectedListing.price).toLocaleString()}
                          {selectedListing.listing_type === 'rent' && <span style={{ fontSize: 14, fontWeight: 400, color: '#777' }}>/mo</span>}
                        </div>
                        <div style={{ fontSize: 14, color: '#555', marginTop: 2 }}>{selectedListing.address}</div>
                        {selectedListing.city && (
                          <div style={{ fontSize: 13, color: '#777' }}>
                            {selectedListing.city}{selectedListing.state ? `, ${selectedListing.state}` : ''} {selectedListing.zip || ''}
                          </div>
                        )}
                      </div>
                      <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                        {selectedListing.listing_type && (
                          <div style={{
                            padding: '4px 10px', borderRadius: 6, fontSize: 11, fontWeight: 700,
                            textTransform: 'uppercase', background: selectedListing.listing_type === 'rent' ? '#3B82F6' : '#8B5CF6', color: '#fff',
                          }}>{selectedListing.listing_type === 'rent' ? 'For Rent' : 'For Sale'}</div>
                        )}
                        <div style={{
                          padding: '4px 10px', borderRadius: 6, fontSize: 11, fontWeight: 700,
                          textTransform: 'uppercase',
                          background: selectedListing.status === 'active' ? '#22C55E' : selectedListing.status === 'pending' ? '#F59E0B' : '#EF4444',
                          color: '#fff',
                        }}>{selectedListing.status}</div>
                      </div>
                    </div>
                    {(selectedListing.beds || selectedListing.baths || selectedListing.sqft) && (
                      <div style={{ display: 'flex', gap: 16, marginTop: 12, fontSize: 13, color: '#555' }}>
                        {selectedListing.beds && <span><strong>{selectedListing.beds}</strong> beds</span>}
                        {selectedListing.baths && <span><strong>{selectedListing.baths}</strong> baths</span>}
                        {selectedListing.sqft && <span><strong>{Number(selectedListing.sqft).toLocaleString()}</strong> sqft</span>}
                        {selectedListing.year_built && <span>Built <strong>{selectedListing.year_built}</strong></span>}
                      </div>
                    )}
                    {selectedListing.description && (
                      <p style={{ fontSize: 13, color: '#666', marginTop: 12, lineHeight: 1.6 }}>{selectedListing.description}</p>
                    )}
                    <div style={{ display: 'flex', gap: 12, marginTop: 14, fontSize: 11, color: '#aaa' }}>
                      <span>Listed by {selectedListing.seller_name || 'Agent'}</span>
                      <span>•</span>
                      <span>{new Date(selectedListing.created_at).toLocaleDateString()}</span>
                      <span>•</span>
                      <span>{selectedListing.views_count || 0} views</span>
                    </div>
                    {/* Map */}
                    {(selectedListing.address || selectedListing.city) && (
                      <div style={{ marginTop: 16, borderRadius: 10, overflow: 'hidden', border: '1px solid #E5E7EB' }}>
                        <iframe
                          title="Listing Map"
                          width="100%" height="200" style={{ border: 'none' }}
                          src={`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY || ''}&q=${encodeURIComponent(selectedListing.address + (selectedListing.city ? ', ' + selectedListing.city : '') + (selectedListing.state ? ', ' + selectedListing.state : ''))}&zoom=15`}
                        />
                      </div>
                    )}
                    {/* Amenity & Action Buttons */}
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 14 }}>
                      {[
                        { emoji: "🍽️", label: "Restaurants", type: "restaurant" },
                        { emoji: "🏫", label: "Schools", type: "school" },
                        { emoji: "🏥", label: "Hospitals", type: "hospital" },
                        { emoji: "💪", label: "Gyms & Fitness", type: "gym" },
                        { emoji: "🌳", label: "Parks", type: "park" },
                        { emoji: "🏛️", label: "County Assessor", type: "assessor" },
                        { emoji: "🗺️", label: "Map", type: "map" },
                      ].map(item => (
                        <button key={item.type} onClick={() => {
                          const addr = selectedListing.address + (selectedListing.city ? ', ' + selectedListing.city : '') + (selectedListing.state ? ', ' + selectedListing.state : '');
                          setAmenityType(item.type);
                          setAmenityAddress(addr);
                          setShowAmenityPanel(true);
                          setAmenityResults([]);
                          setAmenityCenter(null);
                          setAmenityLoading(true);
                          amenityRequestRef.current = { type: item.type, address: addr };
                        }} style={{
                          padding: '6px 12px', borderRadius: 8, fontSize: 12, fontWeight: 500,
                          border: '1px solid #E5E7EB', background: '#FAFAFA', color: '#444',
                          cursor: 'pointer', fontFamily: theme.font, display: 'flex', alignItems: 'center', gap: 4,
                          transition: 'all 0.15s',
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.background = '#FEF2F2'; e.currentTarget.style.borderColor = theme.red; }}
                        onMouseLeave={(e) => { e.currentTarget.style.background = '#FAFAFA'; e.currentTarget.style.borderColor = '#E5E7EB'; }}
                        >{item.emoji} {item.label}</button>
                      ))}
                      <button onClick={() => {
                        const addr = selectedListing.address + (selectedListing.city ? ', ' + selectedListing.city : '') + (selectedListing.state ? ', ' + selectedListing.state : '');
                        setCmaAddress(addr);
                        setCmaReport("");
                        setCmaLoading(false);
                        setShowCMAPanel(true);
                      }} style={{
                        padding: '6px 12px', borderRadius: 8, fontSize: 12, fontWeight: 500,
                        border: '1px solid #E5E7EB', background: '#FAFAFA', color: '#444',
                        cursor: 'pointer', fontFamily: theme.font, display: 'flex', alignItems: 'center', gap: 4,
                        transition: 'all 0.15s',
                      }}
                      onMouseEnter={(e) => { e.currentTarget.style.background = '#FEF2F2'; e.currentTarget.style.borderColor = theme.red; }}
                      onMouseLeave={(e) => { e.currentTarget.style.background = '#FAFAFA'; e.currentTarget.style.borderColor = '#E5E7EB'; }}
                      >📊 CMA Report</button>
                      <button onClick={() => {
                        setShowTourAgent(true);
                      }} style={{
                        padding: '6px 12px', borderRadius: 8, fontSize: 12, fontWeight: 500,
                        border: '1px solid #E5E7EB', background: '#FAFAFA', color: '#444',
                        cursor: 'pointer', fontFamily: theme.font, display: 'flex', alignItems: 'center', gap: 4,
                        transition: 'all 0.15s',
                      }}
                      onMouseEnter={(e) => { e.currentTarget.style.background = '#FEF2F2'; e.currentTarget.style.borderColor = theme.red; }}
                      onMouseLeave={(e) => { e.currentTarget.style.background = '#FAFAFA'; e.currentTarget.style.borderColor = '#E5E7EB'; }}
                      >📅 Schedule a Tour</button>
                    </div>
                  </div>
                </div>

                {/* Right — Chat Thread */}
                <div style={{
                  flex: 1, display: 'flex', flexDirection: 'column', background: '#FAFAFA',
                  minHeight: window.innerWidth <= 768 ? '55%' : 'auto',
                }}>
                  <div style={{ padding: '12px 16px', borderBottom: '1px solid #E5E7EB', background: '#fff' }}>
                    <span style={{ fontSize: 14, fontWeight: 600, color: theme.dark }}>
                      Discussion & Offers ({listingMessages.length})
                    </span>
                  </div>
                  {/* Messages */}
                  <div style={{ flex: 1, overflow: 'auto', padding: '12px 16px', display: 'flex', flexDirection: 'column', gap: 10 }}>
                    {listingMessages.length === 0 && (
                      <div style={{ textAlign: 'center', color: '#aaa', fontSize: 13, padding: 30 }}>
                        No messages yet. Start the conversation!
                      </div>
                    )}
                    {listingMessages.map(msg => (
                      <div key={msg.id} style={{
                        padding: '10px 14px', borderRadius: 10,
                        background: msg.is_offer ? '#FEF9C3' : msg.user_email === (user && user.email) ? '#E8F5FF' : '#fff',
                        border: msg.is_offer ? '2px solid #F59E0B' : '1px solid #E5E7EB',
                        maxWidth: '85%',
                        alignSelf: msg.user_email === (user && user.email) ? 'flex-end' : 'flex-start',
                      }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                          <span style={{ fontSize: 11, fontWeight: 600, color: msg.is_offer ? '#B45309' : '#555' }}>
                            {msg.user_name || (msg.user_email ? msg.user_email.split("@")[0] : 'User')}
                            {msg.is_offer && ' — OFFER'}
                          </span>
                          <span style={{ fontSize: 10, color: '#aaa', marginLeft: 10 }}>
                            {new Date(msg.created_at).toLocaleString()}
                          </span>
                        </div>
                        <div style={{ fontSize: 14, color: '#333' }}>
                          {msg.is_offer ? (
                            <div>
                              <div style={{ fontSize: 18, fontWeight: 700, color: '#B45309' }}>
                                ${Number(msg.offer_amount).toLocaleString()}
                              </div>
                              {msg.offer_status && (
                                <div style={{
                                  display: 'inline-block', marginTop: 6, padding: '3px 10px', borderRadius: 4,
                                  fontSize: 11, fontWeight: 700, textTransform: 'uppercase',
                                  background: msg.offer_status === 'accepted' ? '#22C55E' : msg.offer_status === 'rejected' ? '#EF4444' : '#F59E0B',
                                  color: '#fff',
                                }}>{msg.offer_status}</div>
                              )}
                              {/* Seller can accept/reject */}
                              {msg.offer_status === 'pending' && user && user.email === selectedListing.seller_email && (
                                <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                                  <button onClick={() => handleOfferResponse(msg.id, 'accepted', selectedListing)} style={{
                                    padding: '6px 14px', background: '#22C55E', color: '#fff', border: 'none',
                                    borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer',
                                  }}>✓ Accept</button>
                                  <button onClick={() => handleOfferResponse(msg.id, 'rejected', selectedListing)} style={{
                                    padding: '6px 14px', background: '#EF4444', color: '#fff', border: 'none',
                                    borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer',
                                  }}>✕ Reject</button>
                                </div>
                              )}
                              {/* Buyer prompted to submit formal offer when accepted */}
                              {msg.offer_status === 'accepted' && user && msg.user_email === user.email && (
                                <button onClick={() => { setShowMarketplace(false); setShowOfferAgent(true); }} style={{
                                  marginTop: 8, padding: '8px 16px', background: theme.red, color: '#fff',
                                  border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer',
                                }}>📝 Submit Formal Offer</button>
                              )}
                            </div>
                          ) : (
                            msg.message
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                  {/* Input Area */}
                  {user ? (
                    <div style={{ padding: '12px 16px', borderTop: '1px solid #E5E7EB', background: '#fff' }}>
                      {showOfferInput ? (
                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                          <span style={{ fontSize: 13, fontWeight: 600, color: '#B45309' }}>$</span>
                          <input value={offerAmount} onChange={(e) => setOfferAmount(e.target.value.replace(/[^0-9]/g, ''))}
                            placeholder="Your offer amount" type="text" autoFocus
                            style={{ flex: 1, padding: '10px 14px', border: '2px solid #F59E0B', borderRadius: 8, fontSize: 14, fontFamily: theme.font, outline: 'none' }}
                            onKeyDown={(e) => { if (e.key === 'Enter' && offerAmount) sendMarketplaceMessage(selectedListing.id, true); }}
                          />
                          <button onClick={() => sendMarketplaceMessage(selectedListing.id, true)} disabled={!offerAmount}
                            style={{ padding: '10px 16px', background: '#F59E0B', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: offerAmount ? 'pointer' : 'not-allowed', opacity: offerAmount ? 1 : 0.5 }}>
                            Send Offer
                          </button>
                          <button onClick={() => setShowOfferInput(false)}
                            style={{ padding: '10px 12px', background: '#f3f4f6', color: '#555', border: 'none', borderRadius: 8, fontSize: 12, cursor: 'pointer' }}>
                            Cancel
                          </button>
                        </div>
                      ) : (
                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                          <input value={newMessage} onChange={(e) => setNewMessage(e.target.value)}
                            placeholder="Type a message..."
                            style={{ flex: 1, padding: '10px 14px', border: '2px solid #E5E7EB', borderRadius: 8, fontSize: 14, fontFamily: theme.font, outline: 'none' }}
                            onKeyDown={(e) => { if (e.key === 'Enter' && newMessage.trim()) sendMarketplaceMessage(selectedListing.id); }}
                            onFocus={(e) => e.target.style.borderColor = theme.red} onBlur={(e) => e.target.style.borderColor = '#E5E7EB'}
                          />
                          <button onClick={() => sendMarketplaceMessage(selectedListing.id)} disabled={!newMessage.trim()}
                            style={{ padding: '10px 14px', background: theme.red, color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: newMessage.trim() ? 'pointer' : 'not-allowed', opacity: newMessage.trim() ? 1 : 0.5 }}>
                            Send
                          </button>
                          {selectedListing.status === 'active' && user && user.email !== selectedListing.seller_email && (
                            <button onClick={() => setShowOfferInput(true)}
                              style={{ padding: '10px 14px', background: '#F59E0B', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                              💰 Make Offer
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div style={{ padding: '16px', textAlign: 'center', borderTop: '1px solid #E5E7EB', background: '#fff' }}>
                      <span style={{ fontSize: 13, color: '#999' }}>Sign in to chat and make offers</span>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ═══ PHOTO LIGHTBOX MODAL ═══ */}
      {lightboxPhoto && (
        <div onClick={() => setLightboxPhoto(null)} className="agent-overlay" style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          zIndex: 99999, background: 'rgba(0,0,0,0.92)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          cursor: 'pointer',
        }}>
          <button onClick={(e) => { e.stopPropagation(); setLightboxIndex(i => (i - 1 + lightboxPhoto.length) % lightboxPhoto.length); }} style={{
            position: 'absolute', left: 20, top: '50%', transform: 'translateY(-50%)',
            background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: '50%',
            width: 48, height: 48, fontSize: 24, color: '#fff', cursor: 'pointer',
            display: lightboxPhoto.length > 1 ? 'flex' : 'none', alignItems: 'center', justifyContent: 'center',
          }}>←</button>
          <img src={lightboxPhoto[lightboxIndex]} alt="" onClick={(e) => e.stopPropagation()} style={{
            maxWidth: '90vw', maxHeight: '90vh', objectFit: 'contain', borderRadius: 8,
            cursor: 'default',
          }} />
          <button onClick={(e) => { e.stopPropagation(); setLightboxIndex(i => (i + 1) % lightboxPhoto.length); }} style={{
            position: 'absolute', right: 20, top: '50%', transform: 'translateY(-50%)',
            background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: '50%',
            width: 48, height: 48, fontSize: 24, color: '#fff', cursor: 'pointer',
            display: lightboxPhoto.length > 1 ? 'flex' : 'none', alignItems: 'center', justifyContent: 'center',
          }}>→</button>
          <div style={{ position: 'absolute', top: 20, right: 20, color: '#fff', fontSize: 14 }}>
            {lightboxIndex + 1} / {lightboxPhoto.length}
          </div>
          <button onClick={() => setLightboxPhoto(null)} style={{
            position: 'absolute', top: 20, left: 20, background: 'rgba(255,255,255,0.2)',
            border: 'none', borderRadius: 8, padding: '8px 16px', color: '#fff', fontSize: 14,
            cursor: 'pointer', fontWeight: 600,
          }}>✕ Close</button>
        </div>
      )}

      {/* *** MATCH-FIRST LISTINGS: PROPERTY PANEL *** */}
      {showPropertyPanel && (
        <div className="agent-overlay"
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            zIndex: 9999, background: 'rgba(0,0,0,0.5)',
            display: 'flex', justifyContent: 'center', alignItems: 'flex-end',
          }}
          onClick={(e) => { if (e.target === e.currentTarget) setShowPropertyPanel(false); }}
        >
          <div style={{
            width: window.innerWidth <= 768 ? '100%' : '95%',
            maxWidth: window.innerWidth <= 768 ? '100%' : 1000,
            height: window.innerWidth <= 768 ? '100%' : '92vh',
            background: '#fff',
            borderRadius: window.innerWidth <= 768 ? 0 : '16px 16px 0 0',
            boxShadow: '0 -4px 40px rgba(0,0,0,0.25)',
            position: 'relative', overflow: 'hidden',
            animation: 'slideUp 0.3s ease-out',
            display: 'flex', flexDirection: 'column',
          }}>
            <div style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '12px 20px', background: '#fff', borderBottom: '1px solid #E5E7EB',
              flexShrink: 0, gap: 8,
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
                <img src="/logo.png" alt="Realty AI" style={{ width: 28, height: 28, borderRadius: 6, flexShrink: 0 }} />
                <span style={{ fontSize: 15, fontWeight: 700, color: theme.red, fontFamily: theme.font, whiteSpace: 'nowrap' }}>
                  🏠 Property Details
                </span>
                {window.innerWidth > 768 && (
                  <span style={{ fontSize: 12, color: theme.grey, maxWidth: 420, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {propertyPanelAddress}
                  </span>
                )}
              </div>
              <button onClick={() => setShowPropertyPanel(false)} style={{
                background: 'none', border: '1px solid #E5E7EB', borderRadius: 8,
                padding: '6px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer',
                fontFamily: theme.font, color: '#555', minHeight: 32,
              }}>✕ Close</button>
            </div>
            <div style={{ flex: 1, overflowY: 'auto', padding: '20px 24px' }}>
              {propertyPanelLoading ? (
                <div style={{ textAlign: 'center', padding: '60px 20px' }}>
                  <div style={{ marginBottom: 16 }}>{Icons.spinner}</div>
                  <h3 style={{ fontSize: 18, fontWeight: 700, color: theme.dark, fontFamily: theme.fontDisplay, marginBottom: 8 }}>
                    Loading property details
                  </h3>
                  <p style={{ fontSize: 14, color: theme.grey }}>
                    Pulling the listing, photos, mortgage estimate, and area info...
                  </p>
                  <p style={{ fontSize: 12, color: '#bbb' }}>This may take 10-20 seconds</p>
                </div>
              ) : (
                <div style={{ fontSize: 14, lineHeight: 1.65, color: theme.dark, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                  <RichContent content={propertyPanelContent} />
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* *** CMA REPORT PANEL *** */}
      {showCMAPanel && (
        <div className="agent-overlay"
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            zIndex: 10001, background: 'rgba(0,0,0,0.5)',
            display: 'flex', justifyContent: 'center', alignItems: 'flex-end',
          }}
          onClick={(e) => { if (e.target === e.currentTarget) setShowCMAPanel(false); }}
        >
          <div style={{
            width: window.innerWidth <= 768 ? '100%' : '95%',
            maxWidth: window.innerWidth <= 768 ? '100%' : 1000,
            height: window.innerWidth <= 768 ? '100%' : '92vh',
            background: '#fff',
            borderRadius: window.innerWidth <= 768 ? 0 : '16px 16px 0 0',
            boxShadow: '0 -4px 40px rgba(0,0,0,0.25)',
            position: 'relative', overflow: 'hidden',
            animation: 'slideUp 0.3s ease-out',
            display: 'flex', flexDirection: 'column',
          }}>
            {/* Header */}
            <div style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '12px 20px', background: '#fff', borderBottom: '1px solid #E5E7EB',
              flexShrink: 0,
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <img src="/logo.png" alt="Realty AI" style={{ width: 28, height: 28, borderRadius: 6 }} />
                <span style={{ fontSize: 15, fontWeight: 700, color: theme.red, fontFamily: theme.font }}>
                  📊 CMA Report
                </span>
              </div>
              <button onClick={() => setShowCMAPanel(false)} style={{
                background: 'none', border: '1px solid #E5E7EB', borderRadius: 8,
                padding: '6px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer',
                fontFamily: theme.font, color: '#555', minHeight: 32,
              }}>✕ Close</button>
            </div>

            {/* Address Input */}
            <div style={{
              padding: '16px 20px', borderBottom: '1px solid #f0f0f0',
              display: 'flex', flexDirection: 'column', gap: 10, flexShrink: 0,
            }}>
              <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                <input
                  value={cmaAddress}
                  onChange={(e) => setCmaAddress(e.target.value)}
                  onKeyDown={(e) => { if (e.key === 'Enter' && cmaAddress.trim()) { setCmaReport(""); setCmaLoading(true); generateCMAReport(cmaAddress.trim()); } }}
                  placeholder="Enter property address (e.g., 123 Main St, Las Vegas, NV 89141)"
                  style={{
                    flex: 1, padding: '12px 16px', border: '2px solid #E5E7EB', borderRadius: 10,
                    fontSize: 14, fontFamily: theme.font, outline: 'none',
                  }}
                  onFocus={(e) => e.target.style.borderColor = theme.red}
                  onBlur={(e) => e.target.style.borderColor = '#E5E7EB'}
                />
                <button
                  onClick={() => { if (cmaAddress.trim()) { setCmaReport(""); setCmaLoading(true); generateCMAReport(cmaAddress.trim()); } }}
                  disabled={cmaLoading || !cmaAddress.trim()}
                  style={{
                    padding: '12px 20px', background: theme.red, color: '#fff',
                    border: 'none', borderRadius: 10, fontSize: 14, fontWeight: 600,
                    cursor: cmaLoading ? 'not-allowed' : 'pointer', fontFamily: theme.font,
                    opacity: cmaLoading || !cmaAddress.trim() ? 0.6 : 1,
                    whiteSpace: 'nowrap', flexShrink: 0,
                  }}
                >
                  {cmaLoading ? 'Generating...' : 'Generate CMA'}
                </button>
              </div>
            </div>

            {/* Report Content */}
            <div style={{ flex: 1, overflowY: 'auto', padding: '20px 24px' }}>
              {/* Loading State */}
              {cmaLoading && (
                <div style={{ textAlign: 'center', padding: '60px 20px' }}>
                  <div style={{ marginBottom: 16 }}>{Icons.spinner}</div>
                  <h3 style={{ fontSize: 18, fontWeight: 700, color: theme.dark, fontFamily: theme.fontDisplay, marginBottom: 8 }}>
                    Generating CMA Report
                  </h3>
                  <p style={{ fontSize: 14, color: theme.grey, marginBottom: 4 }}>
                    Searching comparable sales, active listings, and market data...
                  </p>
                  <p style={{ fontSize: 12, color: '#bbb' }}>
                    This may take 10-15 seconds
                  </p>
                  <div style={{ display: 'flex', justifyContent: 'center', gap: 16, marginTop: 24 }}>
                    {['Comps', 'Active Listings', 'Market Trends', 'AI Analysis'].map((step, i) => (
                      <div key={i} style={{
                        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6,
                      }}>
                        <div style={{
                          width: 36, height: 36, borderRadius: '50%',
                          background: 'rgba(227,24,55,0.08)', display: 'flex',
                          alignItems: 'center', justifyContent: 'center',
                          animation: `pulse 1.5s infinite`, animationDelay: `${i * 0.3}s`,
                        }}>
                          <div style={{ width: 8, height: 8, borderRadius: '50%', background: theme.red }} />
                        </div>
                        <span style={{ fontSize: 10, color: theme.grey }}>{step}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Empty State (no address yet, opened from sidebar) */}
              {!cmaLoading && !cmaReport && !cmaAddress && (
                <div style={{ textAlign: 'center', padding: '60px 20px' }}>
                  <div style={{ fontSize: 48, marginBottom: 12, opacity: 0.3 }}>📊</div>
                  <h3 style={{ fontSize: 18, fontWeight: 700, color: theme.dark, fontFamily: theme.fontDisplay, marginBottom: 8 }}>
                    Comparative Market Analysis
                  </h3>
                  <p style={{ fontSize: 14, color: theme.grey, lineHeight: 1.6 }}>
                    Enter a property address above to generate a professional CMA report with comparable sales, active listings, market trends, and an AI-powered value estimate.
                  </p>
                </div>
              )}

              {/* Report Rendered */}
              {!cmaLoading && cmaReport && (
                <div>
                  <div style={{
                    background: 'linear-gradient(135deg, rgba(227,24,55,0.05), rgba(227,24,55,0.02))',
                    borderRadius: 12, padding: '16px 20px', marginBottom: 20,
                    border: '1px solid rgba(227,24,55,0.1)',
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                      <span style={{ fontSize: 16 }}>📊</span>
                      <span style={{ fontSize: 14, fontWeight: 700, color: theme.red }}>CMA Report</span>
                    </div>
                    <span style={{ fontSize: 13, color: theme.dark, fontWeight: 600 }}>{cmaAddress}</span>
                    <span style={{ fontSize: 11, color: theme.grey, display: 'block', marginTop: 4 }}>
                      Generated {new Date().toLocaleDateString()} · Powered by Tavily Research
                    </span>
                  </div>
                  <div style={{ fontSize: 14, lineHeight: 1.7, color: theme.dark }}>
                    <RichContent content={cmaReport} />
                  </div>
                </div>
              )}
            </div>

            {/* Footer */}
            <div style={{
              padding: '10px 20px', borderTop: '1px solid #f0f0f0',
              display: 'flex', justifyContent: 'flex-end', alignItems: 'center', flexShrink: 0,
            }}>
              {cmaReport && (
                <button onClick={() => { setCmaReport(""); setCmaLoading(true); generateCMAReport(cmaAddress); }} style={{
                  padding: '6px 14px', background: 'transparent', border: '1px solid #E5E7EB',
                  borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: 'pointer',
                  fontFamily: theme.font, color: theme.grey,
                }}>🔄 Regenerate</button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* *** ACCOUNT SETTINGS MODAL *** */}
      {showAccountSettings && (
        <div className="agent-overlay"
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            zIndex: 99999, background: 'rgba(0,0,0,0.6)',
            display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '40px 12px 20px', overflowY: 'auto',
          }}
          onClick={(e) => { if (e.target === e.currentTarget) setShowAccountSettings(false); }}
        >
          <div style={{
            background: '#fff', borderRadius: 20, maxWidth: 480, width: '100%',
            boxShadow: '0 24px 80px rgba(0,0,0,0.2)', animation: 'fadeUp 0.3s ease-out',
            overflow: 'hidden', maxHeight: '90vh', overflowY: 'auto',
          }}>
            {/* Header */}
            <div style={{
              padding: '20px 24px', borderBottom: '1px solid #f0f0f0',
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            }}>
              <h2 style={{ fontSize: 18, fontWeight: 700, color: theme.dark, fontFamily: theme.fontDisplay, margin: 0 }}>Account Settings</h2>
              <button onClick={() => setShowAccountSettings(false)} style={{
                background: 'none', border: '1px solid #E5E7EB', borderRadius: 8,
                padding: '4px 12px', fontSize: 13, cursor: 'pointer', color: '#555',
              }}>✕</button>
            </div>

            <div style={{ padding: '20px 24px' }}>
              {/* Profile Photo */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 24 }}>
                <div style={{ position: 'relative' }}>
                  {profilePhoto ? (
                    <img src={profilePhoto} alt="" style={{ width: 64, height: 64, borderRadius: '50%', objectFit: 'cover', border: '2px solid #e5e5e5' }} />
                  ) : (
                    <div style={{
                      width: 64, height: 64, borderRadius: '50%', background: '#f0f0f0',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      color: '#999', fontWeight: 700, fontSize: 22, border: '2px solid #e5e5e5',
                    }}>{userInitials}</div>
                  )}
                  <label style={{
                    position: 'absolute', bottom: -2, right: -2,
                    width: 24, height: 24, background: theme.red, borderRadius: '50%',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    border: '2px solid #fff', cursor: 'pointer',
                  }}>
                    <svg width="12" height="12" fill="none" viewBox="0 0 16 16"><path d="M8 3v10M3 8h10" stroke="#fff" strokeWidth="2" strokeLinecap="round"/></svg>
                    <input type="file" accept="image/*" hidden onChange={handleProfilePhoto} />
                  </label>
                </div>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 16, color: theme.dark }}>{user.name || "User"}</div>
                  <div style={{ fontSize: 12, color: theme.grey }}>{user.email}</div>
                </div>
              </div>

              {/* Editable Fields */}
              <div style={{ marginBottom: 14 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: theme.dark, marginBottom: 4 }}>Full Name</label>
                <input value={editName} onChange={(e) => setEditName(e.target.value)} style={{
                  width: '100%', padding: '10px 14px', border: '2px solid #E5E7EB', borderRadius: 10,
                  fontSize: 14, fontFamily: theme.font, outline: 'none',
                }} onFocus={(e) => e.target.style.borderColor = theme.red}
                onBlur={(e) => e.target.style.borderColor = '#E5E7EB'} />
              </div>
              <div style={{ marginBottom: 14 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: theme.dark, marginBottom: 4 }}>Email</label>
                <input value={user.email} disabled style={{
                  width: '100%', padding: '10px 14px', border: '2px solid #E5E7EB', borderRadius: 10,
                  fontSize: 14, fontFamily: theme.font, outline: 'none', background: '#f9f9f9', color: '#999',
                }} />
              </div>
              <div style={{ marginBottom: 14 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: theme.dark, marginBottom: 4 }}>Phone</label>
                <input value={editPhone} onChange={(e) => setEditPhone(e.target.value)} placeholder="(555) 123-4567" style={{
                  width: '100%', padding: '10px 14px', border: '2px solid #E5E7EB', borderRadius: 10,
                  fontSize: 14, fontFamily: theme.font, outline: 'none',
                }} onFocus={(e) => e.target.style.borderColor = theme.red}
                onBlur={(e) => e.target.style.borderColor = '#E5E7EB'} />
              </div>
              <div style={{ marginBottom: 20 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: theme.dark, marginBottom: 4 }}>Location</label>
                <input value={editLocation} onChange={(e) => setEditLocation(e.target.value)} placeholder="Las Vegas, NV" style={{
                  width: '100%', padding: '10px 14px', border: '2px solid #E5E7EB', borderRadius: 10,
                  fontSize: 14, fontFamily: theme.font, outline: 'none',
                }} onFocus={(e) => e.target.style.borderColor = theme.red}
                onBlur={(e) => e.target.style.borderColor = '#E5E7EB'} />
              </div>

              {/* Subscription Card */}
              <div style={{
                background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: 12,
                padding: '14px 16px', marginBottom: 20,
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                  <span style={{ fontSize: 13, fontWeight: 600, color: theme.dark }}>Current Plan</span>
                  <span style={{
                    fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 4,
                    background: userPlan === 'plus' ? '#4CAF50' : '#E5E7EB',
                    color: userPlan === 'plus' ? '#fff' : '#666',
                    textTransform: 'uppercase', letterSpacing: '.4px',
                  }}>{userPlan === 'plus' ? 'PLUS' : 'FREE'}</span>
                </div>
                {userPlan === 'plus' ? (
                  <p style={{ fontSize: 12, color: theme.grey, margin: 0 }}>Unlimited searches, all agents unlocked</p>
                ) : (
                  <button onClick={() => { setShowAccountSettings(false); setShowUpgradeModal(true); }} style={{
                    width: '100%', padding: 10, background: theme.red, color: '#fff',
                    border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600,
                    cursor: 'pointer', fontFamily: theme.font,
                  }}>Upgrade to Plus</button>
                )}
              </div>

              {/* Save / Cancel */}
              <div style={{ display: 'flex', gap: 10 }}>
                <button onClick={() => {
                  // Save name
                  const updated = { ...user, name: editName || user.name };
                  setUser(updated);
                  localStorage.setItem('realtyai_user', JSON.stringify(updated));
                  // Save phone & location
                  // phone saved in state
                  // location saved in state
                  // Update name in Supabase
                  if (editName && editName !== user.name) {
                    supabaseRequest(`/users?email=eq.${encodeURIComponent(user.email)}`, {
                      method: "PATCH", body: JSON.stringify({ name: editName }),
                    }).catch(() => {});
                  }
                  setShowAccountSettings(false);
                }} style={{
                  flex: 1, padding: 12, background: theme.red, color: '#fff',
                  border: 'none', borderRadius: 10, fontSize: 14, fontWeight: 600,
                  cursor: 'pointer', fontFamily: theme.font,
                }}>Save Changes</button>
                <button onClick={() => setShowAccountSettings(false)} style={{
                  flex: 1, padding: 12, background: 'transparent', color: theme.grey,
                  border: `1px solid ${theme.greyLight}`, borderRadius: 10, fontSize: 14,
                  cursor: 'pointer', fontFamily: theme.font,
                }}>Cancel</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* *** SEARCH HISTORY MODAL *** */}
      {showSearchHistory && (
        <div className="agent-overlay"
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            zIndex: 99999, background: 'rgba(0,0,0,0.6)',
            display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '40px 12px 20px', overflowY: 'auto',
          }}
          onClick={(e) => { if (e.target === e.currentTarget) setShowSearchHistory(false); }}
        >
          <div style={{
            background: '#fff', borderRadius: 20, maxWidth: 520, width: '100%',
            boxShadow: '0 24px 80px rgba(0,0,0,0.2)', animation: 'fadeUp 0.3s ease-out',
            overflow: 'hidden', maxHeight: '80vh', display: 'flex', flexDirection: 'column',
          }}>
            {/* Header */}
            <div style={{
              padding: '20px 24px', borderBottom: '1px solid #f0f0f0',
              display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0,
            }}>
              <h2 style={{ fontSize: 18, fontWeight: 700, color: theme.dark, fontFamily: theme.fontDisplay, margin: 0 }}>Search History</h2>
              <button onClick={() => setShowSearchHistory(false)} style={{
                background: 'none', border: '1px solid #E5E7EB', borderRadius: 8,
                padding: '4px 12px', fontSize: 13, cursor: 'pointer', color: '#555',
              }}>✕</button>
            </div>

            {/* Stats summary */}
            <div style={{ padding: '16px 24px', borderBottom: '1px solid #f0f0f0', display: 'flex', gap: 12 }}>
              {[
                { label: 'Searches', value: searchCount, color: theme.red },
                { label: 'Approvals', value: approvalCount, color: '#3498DB' },
                { label: 'Listings', value: listingCount, color: '#8E44AD' },
                { label: 'Offers', value: offerCount, color: '#27AE60' },
              ].map((s, i) => (
                <div key={i} style={{
                  flex: 1, background: '#f9f9f9', borderRadius: 10, padding: '10px 8px', textAlign: 'center',
                }}>
                  <div style={{ fontSize: 22, fontWeight: 700, color: s.color }}>{s.value}</div>
                  <div style={{ fontSize: 10, color: theme.grey, marginTop: 2 }}>{s.label}</div>
                </div>
              ))}
            </div>

            {/* Search list */}
            <div style={{ flex: 1, overflowY: 'auto', padding: '8px 16px' }}>
              {searchHistory.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '40px 20px', color: theme.grey }}>
                  <div style={{ fontSize: 32, marginBottom: 8, opacity: 0.3 }}>🔍</div>
                  <p style={{ fontSize: 14 }}>No searches yet this session.</p>
                  <p style={{ fontSize: 12, color: '#bbb' }}>Your searches will appear here as you use Realty AI.</p>
                </div>
              ) : (
                searchHistory.map((s, i) => (
                  <div key={i} onClick={() => {
                    setShowSearchHistory(false);
                    setInput(s.query);
                  }} style={{
                    display: 'flex', alignItems: 'center', gap: 12, padding: '12px 10px',
                    borderBottom: '1px solid #f5f5f5', cursor: 'pointer', borderRadius: 8,
                    transition: 'background 0.1s',
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.background = '#fafafa'}
                  onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                  >
                    <div style={{
                      width: 36, height: 36, borderRadius: 10, flexShrink: 0,
                      background: s.type === 'Commercial' ? 'rgba(52,152,219,0.1)' : s.type === 'New Construction' ? 'rgba(46,204,113,0.1)' : 'rgba(227,24,55,0.08)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16,
                    }}>
                      {s.type === 'Commercial' ? '🏢' : s.type === 'New Construction' ? '🏗️' : '🏠'}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 13.5, fontWeight: 500, color: theme.dark, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{s.query}</div>
                      <div style={{ fontSize: 11, color: theme.grey, marginTop: 2 }}>
                        {s.type} · {s.resultCount} results · {new Date(s.time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                      </div>
                    </div>
                    <svg width="14" height="14" fill="none" viewBox="0 0 16 16"><path d="M6 4l4 4-4 4" stroke="#ccc" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      )}

      {/* *** AMENITY PANEL OVERLAY *** */}
      {showAmenityPanel && (
        <div className="agent-overlay"
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            zIndex: 10001, background: 'rgba(0,0,0,0.5)',
            display: 'flex', justifyContent: 'center', alignItems: 'flex-end',
          }}
          onClick={(e) => { if (e.target === e.currentTarget) setShowAmenityPanel(false); }}
        >
          <div style={{
            width: window.innerWidth <= 768 ? '100%' : '95%',
            maxWidth: window.innerWidth <= 768 ? '100%' : 900,
            height: window.innerWidth <= 768 ? '100%' : '88vh',
            background: '#fff',
            borderRadius: window.innerWidth <= 768 ? 0 : '16px 16px 0 0',
            boxShadow: '0 -4px 40px rgba(0,0,0,0.25)',
            position: 'relative', overflow: 'hidden',
            animation: 'slideUp 0.3s ease-out',
            display: 'flex', flexDirection: 'column',
          }}>
            {/* Header */}
            <div style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: window.innerWidth <= 768 ? '10px 12px' : '12px 20px', background: '#fff', borderBottom: '1px solid #E5E7EB',
              flexShrink: 0, gap: 8,
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0, flex: 1, overflow: 'hidden' }}>
                <img src="/logo.png" alt="Realty AI" style={{ width: 28, height: 28, borderRadius: 6, flexShrink: 0 }} />
                <span style={{ fontSize: window.innerWidth <= 768 ? 13 : 15, fontWeight: 700, color: amenityConfig[amenityType]?.color || theme.dark, fontFamily: theme.font, whiteSpace: 'nowrap' }}>
                  {amenityConfig[amenityType]?.emoji} {amenityConfig[amenityType]?.label || 'Amenities'}
                </span>
                {window.innerWidth > 768 && (
                  <span style={{ fontSize: 12, color: theme.grey, maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    near {amenityAddress}
                  </span>
                )}
              </div>
              <button onClick={() => setShowAmenityPanel(false)} style={{
                background: 'none', border: '1px solid #E5E7EB', borderRadius: 8,
                padding: '6px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer',
                fontFamily: theme.font, color: '#555', minHeight: 32,
              }}>✕ Close</button>
            </div>

            {/* Panel Content */}
            <div style={{ flex: 1, overflowY: 'auto', padding: 0 }}>
              {/* ─── MAP PANEL ─── */}
              {amenityType === 'map' && (
                <div style={{ width: '100%', height: '100%' }}>
                  <iframe
                    src={`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY || ''}&q=${encodeURIComponent(amenityAddress)}&zoom=15&maptype=roadmap`}
                    style={{ width: '100%', height: '100%', border: 'none' }}
                    title="Property Map"
                    allowFullScreen
                    loading="lazy"
                  />
                </div>
              )}

              {/* ─── COUNTY ASSESSOR PANEL ─── */}
              {amenityType === 'assessor' && (
                <div style={{ padding: 24 }}>
                  <div style={{
                    background: '#F8F9FA', borderRadius: 16, padding: 28, textAlign: 'center',
                    border: '1px solid #E5E7EB', marginBottom: 20,
                  }}>
                    <div style={{ fontSize: 48, marginBottom: 12 }}>🏛️</div>
                    <h3 style={{ fontSize: 20, fontWeight: 700, color: theme.dark, fontFamily: theme.fontDisplay, marginBottom: 8 }}>
                      County Assessor Records
                    </h3>
                    <p style={{ fontSize: 14, color: theme.grey, marginBottom: 20, lineHeight: 1.6 }}>
                      {assessorData && assessorData.found
                        ? 'Parcel record from the ' + assessorData.source + ' for:'
                        : 'Look up property tax records, assessed values, ownership history, and parcel information for:'}
                    </p>
                    <div style={{
                      background: '#fff', borderRadius: 10, padding: '14px 18px',
                      border: '2px solid #E5E7EB', fontSize: 15, fontWeight: 600,
                      color: theme.dark, marginBottom: 16,
                    }}>
                      🏛️ {(assessorData && assessorData.found && assessorData.parcel.situsAddress) || amenityAddress}
                    </div>

                    {assessorLoading && (
                      <div style={{ padding: '12px 0' }}>
                        <div style={{ marginBottom: 8 }}>{Icons.spinner}</div>
                        <p style={{ fontSize: 13, color: theme.grey }}>Looking up the county parcel record...</p>
                      </div>
                    )}

                    {!assessorLoading && assessorData && assessorData.found && (
                      <div style={{ textAlign: 'left', background: '#fff', border: '1px solid #E5E7EB', borderRadius: 10, overflow: 'hidden', marginBottom: 16 }}>
                        {[
                          { label: 'APN / Parcel #', value: assessorData.parcel.apn },
                          { label: 'Use type', value: assessorData.parcel.useType },
                          { label: 'Year built', value: assessorData.parcel.yearBuilt },
                          { label: 'Beds / Baths', value: (assessorData.parcel.beds || assessorData.parcel.baths)
                              ? `${assessorData.parcel.beds || '—'} / ${assessorData.parcel.baths || '—'}` : null },
                          { label: 'Building sqft', value: assessorData.parcel.sqft ? Number(assessorData.parcel.sqft).toLocaleString() : null },
                          { label: 'Lot sqft', value: assessorData.parcel.lotSqft ? Number(assessorData.parcel.lotSqft).toLocaleString() : null },
                          { label: 'County', value: assessorData.county ? assessorData.county + (assessorData.state ? ', ' + assessorData.state : '') : null },
                        ].filter(r => r.value !== null && r.value !== undefined && r.value !== '').map((row, i) => (
                          <div key={i} style={{
                            display: 'flex', justifyContent: 'space-between', gap: 12,
                            padding: '10px 14px', borderTop: i === 0 ? 'none' : '1px solid #F3F4F6', fontSize: 13,
                          }}>
                            <span style={{ color: theme.grey }}>{row.label}</span>
                            <span style={{ color: theme.dark, fontWeight: 600, textAlign: 'right' }}>{row.value}</span>
                          </div>
                        ))}
                      </div>
                    )}

                    {!assessorLoading && assessorData && !assessorData.found && (
                      <p style={{ fontSize: 12, color: '#999', marginBottom: 12 }}>
                        {assessorData.reason === 'no_adapter'
                          ? `Parcel records for ${assessorData.county || 'this'} County${assessorData.state ? ', ' + assessorData.state : ''} aren't available directly yet — use the link below.`
                          : "Couldn't read the county parcel record for this address — use the link below."}
                      </p>
                    )}

                    <a
                      href={(assessorData && assessorData.portalUrl)
                        || `https://www.google.com/search?q=county+assessor+property+search+${encodeURIComponent(amenityAddress)}`}
                      target="_blank" rel="noopener noreferrer"
                      style={{ fontSize: 13, color: theme.red, fontWeight: 600, textDecoration: 'underline' }}
                    >
                      {assessorData && assessorData.portalUrl ? 'Open the full record on the county portal →' : 'Find the county assessor for this property →'}
                    </a>
                  </div>
                  <p style={{ fontSize: 11, color: '#aaa', textAlign: 'center' }}>
                    County assessor records are public information. Data varies by county jurisdiction.
                  </p>
                </div>
              )}

              {/* ─── PLACES RESULTS (Restaurants, Schools, Hospitals, Gyms, Parks) ─── */}
              {amenityType !== 'map' && amenityType !== 'assessor' && (
                <div style={{ padding: 16 }}>
                  {/* Mini map at top */}
                  {amenityCenter && (
                    <div style={{ borderRadius: 12, overflow: 'hidden', marginBottom: 16, boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
                      <iframe
                        src={`https://www.google.com/maps/embed/v1/search?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY || ''}&q=${encodeURIComponent(amenityConfig[amenityType]?.label || amenityType)}+near+${encodeURIComponent(amenityAddress)}&zoom=13`}
                        style={{ width: '100%', height: 200, border: 'none' }}
                        title="Amenity Map"
                        loading="lazy"
                      />
                    </div>
                  )}

                  {/* Loading state */}
                  {amenityLoading && (
                    <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                      <div style={{ marginBottom: 12 }}>{Icons.spinner}</div>
                      <p style={{ fontSize: 14, color: theme.grey }}>
                        Searching for {amenityConfig[amenityType]?.label?.toLowerCase() || 'places'} near this property...
                      </p>
                    </div>
                  )}

                  {/* Results */}
                  {!amenityLoading && amenityResults.length > 0 && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                      <div style={{ fontSize: 13, color: theme.grey, fontWeight: 600, padding: '0 4px 8px', borderBottom: '1px solid #f0f0f0' }}>
                        {amenityResults.length} {amenityConfig[amenityType]?.label?.toLowerCase() || 'places'} found nearby
                      </div>
                      {amenityResults.map((place, i) => (
                        <div key={i} style={{
                          display: 'flex', gap: 12, padding: '14px 8px',
                          borderBottom: '1px solid #f5f5f5', alignItems: 'flex-start',
                          animation: 'fadeUp 0.3s ease-out',
                          animationDelay: `${i * 0.04}s`, animationFillMode: 'backwards',
                        }}>
                          {/* Photo or Emoji Placeholder */}
                          {place.photoUrl ? (
                            <img src={place.photoUrl} alt={place.name} style={{
                              width: 64, height: 64, borderRadius: 10, objectFit: 'cover', flexShrink: 0,
                              boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                            }} />
                          ) : (
                            <div style={{
                              width: 64, height: 64, borderRadius: 10, flexShrink: 0,
                              background: `${amenityConfig[amenityType]?.color || theme.red}12`,
                              display: 'flex', alignItems: 'center', justifyContent: 'center',
                              fontSize: 26,
                            }}>
                              {amenityConfig[amenityType]?.emoji || '📍'}
                            </div>
                          )}

                          {/* Details */}
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 8 }}>
                              <h4 style={{ fontSize: 14.5, fontWeight: 600, color: theme.dark, margin: 0, lineHeight: 1.3 }}>
                                {place.name}
                              </h4>
                              <span style={{
                                fontSize: 12, color: amenityConfig[amenityType]?.color || theme.red,
                                fontWeight: 700, whiteSpace: 'nowrap', flexShrink: 0,
                              }}>
                                {place.distance} mi
                              </span>
                            </div>
                            <p style={{ fontSize: 12.5, color: theme.grey, margin: '3px 0 6px', lineHeight: 1.3 }}>
                              {place.address}
                            </p>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                              {/* Rating */}
                              {place.rating && (
                                <span style={{ fontSize: 12, color: '#F39C12', fontWeight: 600 }}>
                                  ★ {place.rating}
                                  <span style={{ color: '#bbb', fontWeight: 400, marginLeft: 3 }}>
                                    ({place.totalRatings})
                                  </span>
                                </span>
                              )}
                              {/* Price Level */}
                              {place.priceLevel !== null && place.priceLevel > 0 && (
                                <span style={{ fontSize: 12, color: '#27ae60', fontWeight: 600 }}>
                                  {'$'.repeat(place.priceLevel)}
                                </span>
                              )}
                              {/* Open/Closed */}
                              {place.isOpen !== null && (
                                <span style={{
                                  fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 4,
                                  background: place.isOpen ? 'rgba(46,204,113,0.1)' : 'rgba(231,76,60,0.1)',
                                  color: place.isOpen ? '#27ae60' : '#e74c3c',
                                }}>
                                  {place.isOpen ? 'Open' : 'Closed'}
                                </span>
                              )}
                              {/* Directions Link */}
                              <a
                                href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(place.name + ' ' + place.address)}`}
                                target="_blank" rel="noopener noreferrer"
                                style={{
                                  fontSize: 12, color: theme.red, fontWeight: 600,
                                  textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 3,
                                }}
                              >
                                📍 Directions
                              </a>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* No results */}
                  {!amenityLoading && amenityResults.length === 0 && (
                    <div style={{ textAlign: 'center', padding: '40px 20px', color: theme.grey }}>
                      <div style={{ fontSize: 40, marginBottom: 12, opacity: 0.3 }}>{amenityConfig[amenityType]?.emoji || '📍'}</div>
                      <p style={{ fontSize: 14, marginBottom: 8 }}>No {amenityConfig[amenityType]?.label?.toLowerCase() || 'places'} found nearby.</p>
                      <a
                        href={`https://www.google.com/maps/search/${encodeURIComponent(amenityConfig[amenityType]?.label || amenityType)}+near+${encodeURIComponent(amenityAddress)}`}
                        target="_blank" rel="noopener noreferrer"
                        style={{ fontSize: 13, color: theme.red, fontWeight: 600, textDecoration: 'underline' }}
                      >
                        Try searching on Google Maps →
                      </a>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Footer with Google Maps fallback */}
            {amenityType !== 'map' && amenityType !== 'assessor' && (
              <div style={{
                padding: '10px 20px', borderTop: '1px solid #f0f0f0',
                display: 'flex', justifyContent: 'center', flexShrink: 0,
              }}>
                <a
                  href={`https://www.google.com/maps/search/${encodeURIComponent(amenityConfig[amenityType]?.label || amenityType)}+near+${encodeURIComponent(amenityAddress)}`}
                  target="_blank" rel="noopener noreferrer"
                  style={{
                    fontSize: 12, color: theme.grey, textDecoration: 'none',
                    display: 'flex', alignItems: 'center', gap: 5,
                  }}
                >
                  🗺️ View all on Google Maps
                </a>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Upgrade Modal — UNCHANGED */}
      {showUpgradeModal && (
        <div className="agent-overlay"
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            zIndex: 99999, background: 'rgba(0,0,0,0.6)',
            display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '40px 12px 20px', overflowY: 'auto',
          }}
          onClick={(e) => { if (e.target === e.currentTarget) setShowUpgradeModal(false); }}
        >
          <div style={{
            background: '#fff', borderRadius: 20, maxWidth: 520, width: '100%',
            boxShadow: '0 24px 80px rgba(0,0,0,0.2)', animation: 'fadeUp 0.3s ease-out', overflow: 'hidden',
            maxHeight: '90vh', overflowY: 'auto',
          }}>
            <div style={{
              background: 'linear-gradient(135deg, #E31837, #B71230)',
              padding: '28px 32px', color: '#fff', textAlign: 'center',
            }}>
              <img src="/logo.png" alt="Realty AI" style={{ width: 56, height: 56, borderRadius: 12, marginBottom: 8, boxShadow: '0 4px 16px rgba(0,0,0,0.2)' }} />
              <h2 style={{ fontSize: 22, fontWeight: 700, fontFamily: theme.fontDisplay, margin: 0 }}>Upgrade to Realty AI Plus</h2>
              <p style={{ fontSize: 13, opacity: 0.9, marginTop: 6 }}>Unlock the full power of AI-driven real estate</p>
            </div>
            <div style={{ padding: '24px 32px' }}>
              <div style={{ display: 'flex', justifyContent: 'center', gap: 0, background: '#F3F4F6', borderRadius: 10, padding: 4, marginBottom: 24 }}>
                <button onClick={() => setUpgradeBillingCycle('monthly')} style={{
                  flex: 1, padding: '10px 16px', borderRadius: 8, border: 'none',
                  background: upgradeBillingCycle === 'monthly' ? '#fff' : 'transparent',
                  boxShadow: upgradeBillingCycle === 'monthly' ? '0 1px 4px rgba(0,0,0,0.1)' : 'none',
                  fontWeight: 600, fontSize: 13, cursor: 'pointer', fontFamily: theme.font,
                  color: upgradeBillingCycle === 'monthly' ? theme.dark : '#888',
                }}>Monthly — $29.95/mo</button>
                <button onClick={() => setUpgradeBillingCycle('yearly')} style={{
                  flex: 1, padding: '10px 16px', borderRadius: 8, border: 'none',
                  background: upgradeBillingCycle === 'yearly' ? '#fff' : 'transparent',
                  boxShadow: upgradeBillingCycle === 'yearly' ? '0 1px 4px rgba(0,0,0,0.1)' : 'none',
                  fontWeight: 600, fontSize: 13, cursor: 'pointer', fontFamily: theme.font,
                  color: upgradeBillingCycle === 'yearly' ? theme.dark : '#888',
                }}>Annual — $25/mo</button>
              </div>
              {upgradeBillingCycle === 'yearly' && (
                <div style={{ textAlign: 'center', fontSize: 12, color: '#27ae60', fontWeight: 600, marginTop: -16, marginBottom: 16 }}>
                  Save $59.40/year with annual billing
                </div>
              )}
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 24 }}>
                {[
                  { feature: 'Property searches', free: '50/month', plus: 'Unlimited' },
                  { feature: 'Mortgage Agent', free: '🔒', plus: '✅' },
                  { feature: 'Offer Agent (RPA)', free: '🔒', plus: '✅' },
                  { feature: 'Listing Agent', free: '🔒', plus: '✅' },
                  { feature: 'Document upload to Drive', free: '🔒', plus: '✅' },
                  { feature: 'PDF generation', free: '🔒', plus: '✅' },
                  { feature: 'Email notifications', free: '🔒', plus: '✅' },
                  { feature: 'Voice search', free: '✅', plus: '✅' },
                  { feature: 'Schedule a Tour', free: '✅', plus: '✅' },
                ].map((row, i) => (
                  <div key={i} style={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    padding: '8px 0', borderBottom: '1px solid #F3F4F6', fontSize: 13,
                  }}>
                    <span style={{ color: theme.dark, fontWeight: 500 }}>{row.feature}</span>
                    <div style={{ display: 'flex', gap: 24 }}>
                      <span style={{ width: 70, textAlign: 'center', color: '#999' }}>{row.free}</span>
                      <span style={{ width: 70, textAlign: 'center', color: '#27ae60', fontWeight: 600 }}>{row.plus}</span>
                    </div>
                  </div>
                ))}
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 24, fontSize: 10, color: '#999', marginTop: -4 }}>
                  <span style={{ width: 70, textAlign: 'center' }}>FREE</span>
                  <span style={{ width: 70, textAlign: 'center', color: theme.red, fontWeight: 700 }}>PLUS</span>
                </div>
              </div>
              <button
                onClick={async () => {
                  try {
                    const res = await fetch('/.netlify/functions/create-checkout', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ email: user.email, name: user.name, plan: upgradeBillingCycle }),
                    });
                    const data = await res.json();
                    if (data.url) window.open(data.url, '_blank');
                    else alert('Error creating checkout session. Please try again.');
                  } catch (e) {
                    console.error('Checkout error:', e);
                    alert('Error connecting to payment system. Please try again.');
                  }
                }}
                style={{
                  width: '100%', padding: 16, background: theme.red, color: '#fff',
                  border: 'none', borderRadius: 12, fontSize: 16, fontWeight: 700,
                  fontFamily: theme.font, cursor: 'pointer',
                  boxShadow: '0 4px 16px rgba(227,24,55,0.3)', transition: 'all 0.2s',
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = '#B71230'}
                onMouseLeave={(e) => e.currentTarget.style.background = theme.red}
              >
                {upgradeBillingCycle === 'yearly' ? 'Upgrade — $300/year ($25/mo)' : 'Upgrade — $29.95/month'}
              </button>
              <button
                onClick={() => setShowUpgradeModal(false)}
                style={{
                  width: '100%', padding: 12, background: 'transparent', color: '#999',
                  border: 'none', fontSize: 13, cursor: 'pointer', fontFamily: theme.font, marginTop: 8,
                }}
              >
                Maybe later
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ═══ LIVE STREAM OVERLAY (Restream + ToS) ═══ */}
      {showLiveStream && (
        <div className="agent-overlay"
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            zIndex: 9999, background: 'rgba(0,0,0,0.85)',
            display: 'flex', justifyContent: 'center', alignItems: 'center',
          }}
          onClick={(e) => { if (e.target === e.currentTarget) setShowLiveStream(false); }}
        >
          <div style={{
            width: window.innerWidth <= 768 ? '100%' : '90%',
            maxWidth: 720,
            height: window.innerWidth <= 768 ? '100%' : 'auto',
            maxHeight: '90vh',
            background: '#111',
            borderRadius: window.innerWidth <= 768 ? 0 : 16,
            overflow: 'hidden',
            boxShadow: '0 8px 60px rgba(0,0,0,0.6)',
            display: 'flex', flexDirection: 'column',
          }}>
            {/* Header */}
            <div style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '12px 20px', background: '#1a1a2e', borderBottom: '1px solid rgba(255,255,255,0.1)',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <img src="/logo.png" alt="Realty AI" style={{ width: 28, height: 28, borderRadius: 6 }} />
                <span style={{ fontSize: 15, fontWeight: 700, color: '#fff', fontFamily: theme.fontDisplay }}>Live Stream</span>
              </div>
              <button onClick={() => setShowLiveStream(false)} style={{
                background: 'none', border: '1px solid rgba(255,255,255,0.2)', borderRadius: 8,
                padding: '6px 14px', fontSize: 12, fontWeight: 600, cursor: 'pointer',
                color: '#fff', fontFamily: theme.font,
              }}>✕ Close</button>
            </div>

            {/* Body */}
            <div style={{ flex: 1, background: '#111', overflow: 'auto', padding: 0 }}>
              {liveStreamTosAccepted === null ? (
                /* Loading ToS status */
                <div style={{ padding: 40, color: '#888', textAlign: 'center' }}>Loading…</div>
              ) : liveStreamTosAccepted === false ? (
                /* ToS acceptance screen */
                <div style={{ padding: '24px 28px', color: '#e0e0e0', fontFamily: theme.font }}>
                  <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 14, color: '#fff', fontFamily: theme.fontDisplay }}>
                    Before you go live
                  </div>
                  <div style={{
                    maxHeight: 340, overflowY: 'auto', background: '#0a0a14', border: '1px solid rgba(255,255,255,0.08)',
                    borderRadius: 8, padding: '16px 18px', fontSize: 13, lineHeight: 1.6, color: '#c8c8d0',
                    whiteSpace: 'pre-wrap', marginBottom: 18,
                  }}>
                    {LIVE_STREAM_TOS_TEXT}
                  </div>
                  <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, cursor: 'pointer', marginBottom: 16 }}>
                    <input
                      type="checkbox"
                      checked={liveStreamTosChecked}
                      onChange={(e) => setLiveStreamTosChecked(e.target.checked)}
                      style={{ marginTop: 3, cursor: 'pointer', width: 16, height: 16, accentColor: '#E31837' }}
                    />
                    <span style={{ fontSize: 13, color: '#d0d0d8', lineHeight: 1.5 }}>
                      I have read and agree to the Live Stream Terms of Use. I understand I am legally responsible for all content I broadcast.
                    </span>
                  </label>
                  <button
                    disabled={!liveStreamTosChecked}
                    onClick={async () => {
                      try {
                        await supabaseRequest('/user_agreements', {
                          method: 'POST',
                          body: JSON.stringify({
                            user_email: user.email,
                            agreement_type: LIVE_STREAM_TOS_TYPE,
                            agreement_version: LIVE_STREAM_TOS_VERSION,
                            user_agent: (typeof navigator !== 'undefined' ? navigator.userAgent : null),
                          }),
                        });
                        setLiveStreamTosAccepted(true);
                      } catch (e) {
                        console.error('[LiveStream] Failed to record ToS acceptance:', e);
                        alert('Could not save your agreement. Please try again.');
                      }
                    }}
                    style={{
                      width: '100%', padding: '12px 18px', borderRadius: 10, border: 'none',
                      background: liveStreamTosChecked ? '#E31837' : '#444',
                      color: '#fff', fontWeight: 700, fontSize: 14, fontFamily: theme.font,
                      cursor: liveStreamTosChecked ? 'pointer' : 'not-allowed',
                      transition: 'background 0.2s',
                    }}
                  >
                    I Agree — Continue to Live Stream
                  </button>
                </div>
              ) : (
                /* Launch screen (ToS already accepted) */
                <div style={{ padding: '36px 28px', color: '#e0e0e0', fontFamily: theme.font, textAlign: 'center' }}>
                  <div style={{ fontSize: 44, marginBottom: 16 }}>🎥</div>
                  <div style={{ fontSize: 20, fontWeight: 700, marginBottom: 12, color: '#fff', fontFamily: theme.fontDisplay }}>
                    Ready to go live
                  </div>
                  <div style={{ fontSize: 14, color: '#b0b0b8', lineHeight: 1.6, marginBottom: 24, maxWidth: 480, margin: '0 auto 24px' }}>
                    Click below to open the Realty AI Live Stream studio in a new tab. You'll be able to go on camera and connect your own YouTube, Facebook, or Twitch channels to stream alongside.
                  </div>
                  <button
                    onClick={() => {
                      window.open('https://studio.restream.io/edd-dpvd-vzt', '_blank', 'noopener,noreferrer');
                    }}
                    style={{
                      padding: '14px 32px', borderRadius: 10, border: 'none',
                      background: '#E31837', color: '#fff', fontWeight: 700, fontSize: 15,
                      fontFamily: theme.font, cursor: 'pointer', boxShadow: '0 4px 16px rgba(227,24,55,0.3)',
                    }}
                  >
                    Join Live Session →
                  </button>
                  <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', marginTop: 20 }}>
                    Opens in a new tab · Powered by Restream
                  </div>
                </div>
              )}
            </div>

            {/* Footer */}
            <div style={{
              padding: '10px 20px', background: '#1a1a2e', borderTop: '1px solid rgba(255,255,255,0.1)',
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            }}>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)' }}>
                Powered by  Nation Realtor 
              </div>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.3)' }}>
                Realty AI | Live Stream
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
